var Us = Object.defineProperty, ks = Object.defineProperties;
var Bs = Object.getOwnPropertyDescriptors;
var Nt = Object.getOwnPropertySymbols, Hs = Object.getPrototypeOf, ai = Object.prototype.hasOwnProperty, si = Object.prototype.propertyIsEnumerable, Gs = Reflect.get;
var ui = (e) => {
  throw TypeError(e);
};
var Sr = (e, t, r) => t in e ? Us(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, E = (e, t) => {
  for (var r in t || (t = {}))
    ai.call(t, r) && Sr(e, r, t[r]);
  if (Nt)
    for (var r of Nt(t))
      si.call(t, r) && Sr(e, r, t[r]);
  return e;
}, I = (e, t) => ks(e, Bs(t));
var br = (e, t) => {
  var r = {};
  for (var n in e)
    ai.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && Nt)
    for (var n of Nt(e))
      t.indexOf(n) < 0 && si.call(e, n) && (r[n] = e[n]);
  return r;
};
var b = (e, t, r) => Sr(e, typeof t != "symbol" ? t + "" : t, r), ci = (e, t, r) => t.has(e) || ui("Cannot " + r);
var li = (e, t, r) => (ci(e, t, "read from private field"), r ? r.call(e) : t.get(e)), fi = (e, t, r) => t.has(e) ? ui("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), di = (e, t, r, n) => (ci(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r);
var wr = (e, t, r) => Gs(Hs(e), r, t);
var U = (e, t, r) => new Promise((n, i) => {
  var o = (c) => {
    try {
      u(r.next(c));
    } catch (s) {
      i(s);
    }
  }, a = (c) => {
    try {
      u(r.throw(c));
    } catch (s) {
      i(s);
    }
  }, u = (c) => c.done ? n(c.value) : Promise.resolve(c.value).then(o, a);
  u((r = r.apply(e, t)).next());
});
import { U as Mo, W as Fs, X as cn, Y as js, s as We, Z as de, _ as Io, $ as xo, a0 as Do, a1 as _e, P as Vs, a2 as $s, a3 as Uo, x as zs, a4 as Xs, a5 as qs, a6 as Ws, a7 as Ks, a8 as Ys, a9 as zt, q as Js, aa as Ar, ab as Or, ac as Zs, ad as Qs, c as eu, n as tu, o as ru, L as nu, h as iu, t as ou, ae as au, E as su, af as uu, ag as cu, I as Rr, J as pi, ah as lu, ai as fu, K as du, N as pu, O as hu, Q as _u, R as vu, T as yu, aj as mu, ak as gu, al as hi, am as Eu, an as Tu, ao as Su } from "./common-UcZNNvqZ.js";
import { g as _i, L as bu } from "./LDObserve-CHIjcqIn.js";
import { a as wu, i as ko } from "./buffer-DIFxvF2Q.js";
const Bo = [
  "assert",
  "count",
  "countReset",
  "debug",
  "dir",
  "dirxml",
  "error",
  "group",
  "groupCollapsed",
  "groupEnd",
  "info",
  "log",
  "table",
  "time",
  "timeEnd",
  "timeLog",
  "trace",
  "warn"
];
var j = /* @__PURE__ */ ((e) => (e.DeviceMemory = "DeviceMemory", e.ViewportHeight = "ViewportHeight", e.ViewportWidth = "ViewportWidth", e.ScreenHeight = "ScreenHeight", e.ScreenWidth = "ScreenWidth", e.ViewportArea = "ViewportArea", e))(j || {}), $ = /* @__PURE__ */ ((e) => (e.Device = "Device", e.WebVital = "WebVital", e.Performance = "Performance", e.Frontend = "Frontend", e.Backend = "Backend", e))($ || {}), Ho = { exports: {} }, Lr = { exports: {} }, vi;
function Au() {
  return vi || (vi = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(Mo, function() {
      function r(p) {
        return !isNaN(parseFloat(p)) && isFinite(p);
      }
      function n(p) {
        return p.charAt(0).toUpperCase() + p.substring(1);
      }
      function i(p) {
        return function() {
          return this[p];
        };
      }
      var o = ["isConstructor", "isEval", "isNative", "isToplevel"], a = ["columnNumber", "lineNumber"], u = ["fileName", "functionName", "source"], c = ["args"], s = ["evalOrigin"], l = o.concat(a, u, c, s);
      function f(p) {
        if (p)
          for (var v = 0; v < l.length; v++)
            p[l[v]] !== void 0 && this["set" + n(l[v])](p[l[v]]);
      }
      f.prototype = {
        getArgs: function() {
          return this.args;
        },
        setArgs: function(p) {
          if (Object.prototype.toString.call(p) !== "[object Array]")
            throw new TypeError("Args must be an Array");
          this.args = p;
        },
        getEvalOrigin: function() {
          return this.evalOrigin;
        },
        setEvalOrigin: function(p) {
          if (p instanceof f)
            this.evalOrigin = p;
          else if (p instanceof Object)
            this.evalOrigin = new f(p);
          else
            throw new TypeError("Eval Origin must be an Object or StackFrame");
        },
        toString: function() {
          var p = this.getFileName() || "", v = this.getLineNumber() || "", y = this.getColumnNumber() || "", g = this.getFunctionName() || "";
          return this.getIsEval() ? p ? "[eval] (" + p + ":" + v + ":" + y + ")" : "[eval]:" + v + ":" + y : g ? g + " (" + p + ":" + v + ":" + y + ")" : p + ":" + v + ":" + y;
        }
      }, f.fromString = function(v) {
        var y = v.indexOf("("), g = v.lastIndexOf(")"), w = v.substring(0, y), A = v.substring(y + 1, g).split(","), R = v.substring(g + 1);
        if (R.indexOf("@") === 0)
          var P = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(R, ""), G = P[1], C = P[2], F = P[3];
        return new f({
          functionName: w,
          args: A || void 0,
          fileName: G,
          lineNumber: C || void 0,
          columnNumber: F || void 0
        });
      };
      for (var d = 0; d < o.length; d++)
        f.prototype["get" + n(o[d])] = i(o[d]), f.prototype["set" + n(o[d])] = /* @__PURE__ */ function(p) {
          return function(v) {
            this[p] = !!v;
          };
        }(o[d]);
      for (var h = 0; h < a.length; h++)
        f.prototype["get" + n(a[h])] = i(a[h]), f.prototype["set" + n(a[h])] = /* @__PURE__ */ function(p) {
          return function(v) {
            if (!r(v))
              throw new TypeError(p + " must be a Number");
            this[p] = Number(v);
          };
        }(a[h]);
      for (var _ = 0; _ < u.length; _++)
        f.prototype["get" + n(u[_])] = i(u[_]), f.prototype["set" + n(u[_])] = /* @__PURE__ */ function(p) {
          return function(v) {
            this[p] = String(v);
          };
        }(u[_]);
      return f;
    });
  }(Lr)), Lr.exports;
}
(function(e, t) {
  (function(r, n) {
    e.exports = n(Au());
  })(Mo, function(n) {
    var i = /(^|@)\S+:\d+/, o = /^\s*at .*(\S+:\d+|\(native\))/m, a = /^(eval@)?(\[native code])?$/;
    return {
      /**
       * Given an Error object, extract the most information from it.
       *
       * @param {Error} error object
       * @return {Array} of StackFrames
       */
      parse: function(c) {
        if (typeof c.stacktrace != "undefined" || typeof c["opera#sourceloc"] != "undefined")
          return this.parseOpera(c);
        if (c.stack && c.stack.match(o))
          return this.parseV8OrIE(c);
        if (c.stack)
          return this.parseFFOrSafari(c);
        throw new Error("Cannot parse given Error object");
      },
      // Separate line and column numbers from a string of the form: (URI:Line:Column)
      extractLocation: function(c) {
        if (c.indexOf(":") === -1)
          return [c];
        var s = /(.+?)(?::(\d+))?(?::(\d+))?$/, l = s.exec(c.replace(/[()]/g, ""));
        return [l[1], l[2] || void 0, l[3] || void 0];
      },
      parseV8OrIE: function(c) {
        var s = c.stack.split(`
`).filter(function(l) {
          return !!l.match(o);
        }, this);
        return s.map(function(l) {
          l.indexOf("(eval ") > -1 && (l = l.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, ""));
          var f = l.replace(/^\s+/, "").replace(/\(eval code/g, "("), d = f.match(/ (\((.+):(\d+):(\d+)\)$)/);
          f = d ? f.replace(d[0], "") : f;
          var h = f.split(/\s+/).slice(1), _ = this.extractLocation(d ? d[1] : h.pop()), p = h.join(" ") || void 0, v = ["eval", "<anonymous>"].indexOf(_[0]) > -1 ? void 0 : _[0];
          return new n({
            functionName: p,
            fileName: v,
            lineNumber: _[1],
            columnNumber: _[2],
            source: l
          });
        }, this);
      },
      parseFFOrSafari: function(c) {
        var s = c.stack.split(`
`).filter(function(l) {
          return !l.match(a);
        }, this);
        return s.map(function(l) {
          if (l.indexOf(" > eval") > -1 && (l = l.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), l.indexOf("@") === -1 && l.indexOf(":") === -1)
            return new n({
              functionName: l
            });
          var f = /((.*".+"[^@]*)?[^@]*)(?:@)/, d = l.match(f), h = d && d[1] ? d[1] : void 0, _ = this.extractLocation(l.replace(f, ""));
          return new n({
            functionName: h,
            fileName: _[0],
            lineNumber: _[1],
            columnNumber: _[2],
            source: l
          });
        }, this);
      },
      parseOpera: function(c) {
        return !c.stacktrace || c.message.indexOf(`
`) > -1 && c.message.split(`
`).length > c.stacktrace.split(`
`).length ? this.parseOpera9(c) : c.stack ? this.parseOpera11(c) : this.parseOpera10(c);
      },
      parseOpera9: function(c) {
        for (var s = /Line (\d+).*script (?:in )?(\S+)/i, l = c.message.split(`
`), f = [], d = 2, h = l.length; d < h; d += 2) {
          var _ = s.exec(l[d]);
          _ && f.push(new n({
            fileName: _[2],
            lineNumber: _[1],
            source: l[d]
          }));
        }
        return f;
      },
      parseOpera10: function(c) {
        for (var s = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, l = c.stacktrace.split(`
`), f = [], d = 0, h = l.length; d < h; d += 2) {
          var _ = s.exec(l[d]);
          _ && f.push(
            new n({
              functionName: _[3] || void 0,
              fileName: _[2],
              lineNumber: _[1],
              source: l[d]
            })
          );
        }
        return f;
      },
      // Opera 10.65+ Error.stack very similar to FF/Safari
      parseOpera11: function(c) {
        var s = c.stack.split(`
`).filter(function(l) {
          return !!l.match(i) && !l.match(/^Error created at/);
        }, this);
        return s.map(function(l) {
          var f = l.split("@"), d = this.extractLocation(f.pop()), h = f.shift() || "", _ = h.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0, p;
          h.match(/\(([^)]*)\)/) && (p = h.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
          var v = p === void 0 || p === "[arguments not available]" ? void 0 : p.split(",");
          return new n({
            functionName: _,
            args: v,
            fileName: d[0],
            lineNumber: d[1],
            columnNumber: d[2],
            source: l
          });
        }, this);
      }
    };
  });
})(Ho);
var Ou = Ho.exports;
const yi = /* @__PURE__ */ Fs(Ou);
function dr(e) {
  try {
    return yi.parse(e);
  } catch (t) {
    try {
      return yi.parse(new Error());
    } catch (r) {
      return console.warn("Highlight Warning: failed to parse error", {
        originalError: t,
        secondaryError: r
      }), [];
    }
  }
}
const Um = {
  level: [...Bo],
  logger: "console",
  stringifyOptions: {
    depthOfLimit: 10,
    numOfKeysLimit: 100,
    stringLengthLimit: 1e3
  }
};
function Ru(e, t) {
  const r = t.logger;
  if (!r)
    return () => {
    };
  let n;
  typeof r == "string" ? n = window[r] : n = r;
  const i = [];
  if (t.level.includes("error") && window) {
    const a = (u) => {
      const { message: c, error: s } = u;
      let l = [];
      s && (l = dr(s));
      const f = [
        cn(c, t.stringifyOptions)
      ];
      e({
        type: "Error",
        trace: l,
        time: Date.now(),
        value: f
      });
    };
    window.addEventListener("error", a), i.push(() => {
      window && window.removeEventListener("error", a);
    });
  }
  for (const a of t.level)
    i.push(o(n, a));
  return () => {
    i.forEach((a) => a());
  };
  function o(a, u) {
    return a[u] ? js(a, u, (c) => (...s) => {
      c.apply(this, s);
      try {
        e(Lu(u, t, ...s));
      } catch (l) {
        c("highlight logger error:", l, ...s);
      }
    }) : () => {
    };
  }
}
function Lu(e, t, ...r) {
  const n = dr(new Error()), i = t.serializeConsoleAttributes ? r.map(
    (o) => typeof o == "object" ? cn(o, t.stringifyOptions) : o
  ) : r.filter((o) => typeof o != "object").map((o) => `${o}`);
  return {
    type: e,
    trace: n,
    value: i,
    attributes: cn(
      r.filter((o) => typeof o == "object").reduce((o, a) => E(E({}, o), a), {}),
      t.stringifyOptions
    ),
    time: Date.now()
  };
}
const Pu = {
  start: 0,
  end: 3
}, Nu = {
  start: 4,
  end: 5
}, Pr = {
  start: 6,
  end: 7
}, Nr = {
  start: 8,
  end: 8
}, Cu = {
  start: 9,
  end: 9
}, Mu = {
  start: 10,
  end: 15
};
function Iu() {
  if (crypto && crypto.getRandomValues) {
    const t = new Uint8Array(16);
    return crypto.getRandomValues(t), [...t.values()];
  }
  const e = [];
  for (let t = 0; t < 16; t += 1)
    e.push(Math.floor(Math.random() * 256));
  return e;
}
function Ge(e, t) {
  let r = "";
  for (let n = t.start; n <= t.end; n += 1)
    r += e[n].toString(16).padStart(2, "0");
  return r;
}
function xu(e) {
  return e[Nr.start] = (e[Nr.start] | 128) & 191, e[Pr.start] = e[Pr.start] & 15 | 64, `${Ge(e, Pu)}-${Ge(e, Nu)}-${Ge(e, Pr)}-${Ge(e, Nr)}${Ge(e, Cu)}-${Ge(e, Mu)}`;
}
function Du() {
  const e = Iu();
  return xu(e);
}
function ln() {
  return typeof crypto != "undefined" && typeof crypto.randomUUID == "function" ? crypto.randomUUID() : Du();
}
function Cr(e, t, r, n) {
  var c, s, l, f;
  let i = n != null ? n : t, o = dr(i), a = {};
  t instanceof Error && (t = t.message, t.cause && (a = { "exception.cause": t.cause }));
  const u = ku(o);
  e({
    error: i,
    event: We(t),
    type: "window.onerror",
    url: window.location.href,
    source: r != null ? r : "",
    lineNumber: (c = u[0]) != null && c.lineNumber ? (s = u[0]) == null ? void 0 : s.lineNumber : 0,
    columnNumber: (l = u[0]) != null && l.columnNumber ? (f = u[0]) == null ? void 0 : f.columnNumber : 0,
    stackTrace: u,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    payload: a ? We(a) : void 0,
    id: ln()
  });
}
const Uu = (e, { enablePromisePatch: t }) => {
  if (typeof window == "undefined") return () => {
  };
  const r = window.onerror = (a, u, c, s, l) => {
    Cr(e, a, u, l);
  }, n = window.onunhandledrejection = (a) => {
    if (a.reason) {
      const u = a.promise;
      u.getStack ? Cr(
        e,
        a.reason,
        a.type,
        u.getStack()
      ) : Cr(e, a.reason, a.type);
    }
  }, i = window.Promise, o = class extends i {
    constructor(c) {
      super(c);
      b(this, "promiseCreationError");
      this.promiseCreationError = new Error();
    }
    getStack() {
      return this.promiseCreationError;
    }
    static shouldPatch() {
      const c = typeof window.Zone == "undefined";
      return t && c;
    }
  };
  return o.shouldPatch() && (window.Promise = o), () => {
    window.Promise = i, window.onunhandledrejection = n, window.onerror = r;
  };
}, ku = (e) => {
  var r, n;
  if (e.length === 0)
    return e;
  const t = e[0];
  return (r = t.fileName) != null && r.includes("highlight.run") || (n = t.fileName) != null && n.includes("highlight.io") || t.functionName === "new highlightPromise" ? e.slice(1) : e;
}, Bu = [
  '["\\"Script error.\\""]',
  '"Script error."',
  '["\\"Load failed.\\""]',
  '"Load failed."',
  '["\\"Network request failed.\\""]',
  '"Network request failed."',
  '["\\"Document is not focused.\\""]',
  '"Document is not focused."',
  '["\\"Failed to fetch\\""]',
  '"Failed to fetch"',
  '[{"isTrusted":true}]',
  '{"isTrusted":true}',
  '["{}"]',
  '"{}"',
  '[""]',
  '""',
  '["\\"\\""]',
  '""'
], Hu = [
  "websocket error",
  '\\"ResizeObserver loop'
];
var Gu = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, Ae = "1.9.0", mi = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function Fu(e) {
  var t = /* @__PURE__ */ new Set([e]), r = /* @__PURE__ */ new Set(), n = e.match(mi);
  if (!n)
    return function() {
      return !1;
    };
  var i = {
    major: +n[1],
    minor: +n[2],
    patch: +n[3],
    prerelease: n[4]
  };
  if (i.prerelease != null)
    return function(c) {
      return c === e;
    };
  function o(u) {
    return r.add(u), !1;
  }
  function a(u) {
    return t.add(u), !0;
  }
  return function(c) {
    if (t.has(c))
      return !0;
    if (r.has(c))
      return !1;
    var s = c.match(mi);
    if (!s)
      return o(c);
    var l = {
      major: +s[1],
      minor: +s[2],
      patch: +s[3],
      prerelease: s[4]
    };
    return l.prerelease != null || i.major !== l.major ? o(c) : i.major === 0 ? i.minor === l.minor && i.patch <= l.patch ? a(c) : o(c) : i.minor <= l.minor ? a(c) : o(c);
  };
}
var ju = Fu(Ae), Vu = Ae.split(".")[0], _t = Symbol.for("opentelemetry.js.api." + Vu), vt = Gu;
function bt(e, t, r, n) {
  var i;
  n === void 0 && (n = !1);
  var o = vt[_t] = (i = vt[_t]) !== null && i !== void 0 ? i : {
    version: Ae
  };
  if (!n && o[e]) {
    var a = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + e);
    return r.error(a.stack || a.message), !1;
  }
  if (o.version !== Ae) {
    var a = new Error("@opentelemetry/api: Registration of version v" + o.version + " for " + e + " does not match previously registered API v" + Ae);
    return r.error(a.stack || a.message), !1;
  }
  return o[e] = t, r.debug("@opentelemetry/api: Registered a global for " + e + " v" + Ae + "."), !0;
}
function Ne(e) {
  var t, r, n = (t = vt[_t]) === null || t === void 0 ? void 0 : t.version;
  if (!(!n || !ju(n)))
    return (r = vt[_t]) === null || r === void 0 ? void 0 : r[e];
}
function wt(e, t) {
  t.debug("@opentelemetry/api: Unregistering a global for " + e + " v" + Ae + ".");
  var r = vt[_t];
  r && delete r[e];
}
var $u = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, zu = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Xu = (
  /** @class */
  function() {
    function e(t) {
      this._namespace = t.namespace || "DiagComponentLogger";
    }
    return e.prototype.debug = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return it("debug", this._namespace, t);
    }, e.prototype.error = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return it("error", this._namespace, t);
    }, e.prototype.info = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return it("info", this._namespace, t);
    }, e.prototype.warn = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return it("warn", this._namespace, t);
    }, e.prototype.verbose = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return it("verbose", this._namespace, t);
    }, e;
  }()
);
function it(e, t, r) {
  var n = Ne("diag");
  if (n)
    return r.unshift(t), n[e].apply(n, zu([], $u(r), !1));
}
var M;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.ERROR = 30] = "ERROR", e[e.WARN = 50] = "WARN", e[e.INFO = 60] = "INFO", e[e.DEBUG = 70] = "DEBUG", e[e.VERBOSE = 80] = "VERBOSE", e[e.ALL = 9999] = "ALL";
})(M || (M = {}));
function qu(e, t) {
  e < M.NONE ? e = M.NONE : e > M.ALL && (e = M.ALL), t = t || {};
  function r(n, i) {
    var o = t[n];
    return typeof o == "function" && e >= i ? o.bind(t) : function() {
    };
  }
  return {
    error: r("error", M.ERROR),
    warn: r("warn", M.WARN),
    info: r("info", M.INFO),
    debug: r("debug", M.DEBUG),
    verbose: r("verbose", M.VERBOSE)
  };
}
var Wu = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ku = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Yu = "diag", re = (
  /** @class */
  function() {
    function e() {
      function t(i) {
        return function() {
          for (var o = [], a = 0; a < arguments.length; a++)
            o[a] = arguments[a];
          var u = Ne("diag");
          if (u)
            return u[i].apply(u, Ku([], Wu(o), !1));
        };
      }
      var r = this, n = function(i, o) {
        var a, u, c;
        if (o === void 0 && (o = { logLevel: M.INFO }), i === r) {
          var s = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
          return r.error((a = s.stack) !== null && a !== void 0 ? a : s.message), !1;
        }
        typeof o == "number" && (o = {
          logLevel: o
        });
        var l = Ne("diag"), f = qu((u = o.logLevel) !== null && u !== void 0 ? u : M.INFO, i);
        if (l && !o.suppressOverrideMessage) {
          var d = (c = new Error().stack) !== null && c !== void 0 ? c : "<failed to generate stacktrace>";
          l.warn("Current logger will be overwritten from " + d), f.warn("Current logger will overwrite one already registered from " + d);
        }
        return bt("diag", f, r, !0);
      };
      r.setLogger = n, r.disable = function() {
        wt(Yu, r);
      }, r.createComponentLogger = function(i) {
        return new Xu(i);
      }, r.verbose = t("verbose"), r.debug = t("debug"), r.info = t("info"), r.warn = t("warn"), r.error = t("error");
    }
    return e.instance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e;
  }()
), Ju = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Zu = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Qu = (
  /** @class */
  function() {
    function e(t) {
      this._entries = t ? new Map(t) : /* @__PURE__ */ new Map();
    }
    return e.prototype.getEntry = function(t) {
      var r = this._entries.get(t);
      if (r)
        return Object.assign({}, r);
    }, e.prototype.getAllEntries = function() {
      return Array.from(this._entries.entries()).map(function(t) {
        var r = Ju(t, 2), n = r[0], i = r[1];
        return [n, i];
      });
    }, e.prototype.setEntry = function(t, r) {
      var n = new e(this._entries);
      return n._entries.set(t, r), n;
    }, e.prototype.removeEntry = function(t) {
      var r = new e(this._entries);
      return r._entries.delete(t), r;
    }, e.prototype.removeEntries = function() {
      for (var t, r, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = new e(this._entries);
      try {
        for (var a = Zu(n), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          o._entries.delete(c);
        }
      } catch (s) {
        t = { error: s };
      } finally {
        try {
          u && !u.done && (r = a.return) && r.call(a);
        } finally {
          if (t) throw t.error;
        }
      }
      return o;
    }, e.prototype.clear = function() {
      return new e();
    }, e;
  }()
), ec = Symbol("BaggageEntryMetadata"), tc = re.instance();
function rc(e) {
  return e === void 0 && (e = {}), new Qu(new Map(Object.entries(e)));
}
function nc(e) {
  return typeof e != "string" && (tc.error("Cannot create baggage metadata from unknown type: " + typeof e), e = ""), {
    __TYPE__: ec,
    toString: function() {
      return e;
    }
  };
}
function Mn(e) {
  return Symbol.for(e);
}
var ic = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      var r = this;
      r._currentContext = t ? new Map(t) : /* @__PURE__ */ new Map(), r.getValue = function(n) {
        return r._currentContext.get(n);
      }, r.setValue = function(n, i) {
        var o = new e(r._currentContext);
        return o._currentContext.set(n, i), o;
      }, r.deleteValue = function(n) {
        var i = new e(r._currentContext);
        return i._currentContext.delete(n), i;
      };
    }
    return e;
  }()
), Se = new ic(), xe = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), oc = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.createGauge = function(t, r) {
      return hc;
    }, e.prototype.createHistogram = function(t, r) {
      return _c;
    }, e.prototype.createCounter = function(t, r) {
      return pc;
    }, e.prototype.createUpDownCounter = function(t, r) {
      return vc;
    }, e.prototype.createObservableGauge = function(t, r) {
      return mc;
    }, e.prototype.createObservableCounter = function(t, r) {
      return yc;
    }, e.prototype.createObservableUpDownCounter = function(t, r) {
      return gc;
    }, e.prototype.addBatchObservableCallback = function(t, r) {
    }, e.prototype.removeBatchObservableCallback = function(t) {
    }, e;
  }()
), pr = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
    }
    return e;
  }()
), ac = (
  /** @class */
  function(e) {
    xe(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n) {
    }, t;
  }(pr)
), sc = (
  /** @class */
  function(e) {
    xe(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n) {
    }, t;
  }(pr)
), uc = (
  /** @class */
  function(e) {
    xe(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n) {
    }, t;
  }(pr)
), cc = (
  /** @class */
  function(e) {
    xe(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n) {
    }, t;
  }(pr)
), In = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.addCallback = function(t) {
    }, e.prototype.removeCallback = function(t) {
    }, e;
  }()
), lc = (
  /** @class */
  function(e) {
    xe(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(In)
), fc = (
  /** @class */
  function(e) {
    xe(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(In)
), dc = (
  /** @class */
  function(e) {
    xe(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(In)
), Go = new oc(), pc = new ac(), hc = new uc(), _c = new cc(), vc = new sc(), yc = new lc(), mc = new fc(), gc = new dc();
function Ec() {
  return Go;
}
var ve;
(function(e) {
  e[e.INT = 0] = "INT", e[e.DOUBLE = 1] = "DOUBLE";
})(ve || (ve = {}));
var Tc = {
  get: function(e, t) {
    if (e != null)
      return e[t];
  },
  keys: function(e) {
    return e == null ? [] : Object.keys(e);
  }
}, Sc = {
  set: function(e, t, r) {
    e != null && (e[t] = r);
  }
}, bc = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, wc = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Ac = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.active = function() {
      return Se;
    }, e.prototype.with = function(t, r, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      return r.call.apply(r, wc([n], bc(i), !1));
    }, e.prototype.bind = function(t, r) {
      return r;
    }, e.prototype.enable = function() {
      return this;
    }, e.prototype.disable = function() {
      return this;
    }, e;
  }()
), Oc = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Rc = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Mr = "context", Lc = new Ac(), hr = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalContextManager = function(t) {
      return bt(Mr, t, re.instance());
    }, e.prototype.active = function() {
      return this._getContextManager().active();
    }, e.prototype.with = function(t, r, n) {
      for (var i, o = [], a = 3; a < arguments.length; a++)
        o[a - 3] = arguments[a];
      return (i = this._getContextManager()).with.apply(i, Rc([t, r, n], Oc(o), !1));
    }, e.prototype.bind = function(t, r) {
      return this._getContextManager().bind(t, r);
    }, e.prototype._getContextManager = function() {
      return Ne(Mr) || Lc;
    }, e.prototype.disable = function() {
      this._getContextManager().disable(), wt(Mr, re.instance());
    }, e;
  }()
), ue;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.SAMPLED = 1] = "SAMPLED";
})(ue || (ue = {}));
var Fo = "0000000000000000", jo = "00000000000000000000000000000000", Vo = {
  traceId: jo,
  spanId: Fo,
  traceFlags: ue.NONE
}, lt = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = Vo), this._spanContext = t;
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, r) {
      return this;
    }, e.prototype.setAttributes = function(t) {
      return this;
    }, e.prototype.addEvent = function(t, r) {
      return this;
    }, e.prototype.addLink = function(t) {
      return this;
    }, e.prototype.addLinks = function(t) {
      return this;
    }, e.prototype.setStatus = function(t) {
      return this;
    }, e.prototype.updateName = function(t) {
      return this;
    }, e.prototype.end = function(t) {
    }, e.prototype.isRecording = function() {
      return !1;
    }, e.prototype.recordException = function(t, r) {
    }, e;
  }()
), xn = Mn("OpenTelemetry Context Key SPAN");
function Dn(e) {
  return e.getValue(xn) || void 0;
}
function Pc() {
  return Dn(hr.getInstance().active());
}
function Un(e, t) {
  return e.setValue(xn, t);
}
function Nc(e) {
  return e.deleteValue(xn);
}
function Cc(e, t) {
  return Un(e, new lt(t));
}
function $o(e) {
  var t;
  return (t = Dn(e)) === null || t === void 0 ? void 0 : t.spanContext();
}
var Mc = /^([0-9a-f]{32})$/i, Ic = /^[0-9a-f]{16}$/i;
function zo(e) {
  return Mc.test(e) && e !== jo;
}
function xc(e) {
  return Ic.test(e) && e !== Fo;
}
function _r(e) {
  return zo(e.traceId) && xc(e.spanId);
}
function Dc(e) {
  return new lt(e);
}
var Ir = hr.getInstance(), Xo = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.startSpan = function(t, r, n) {
      n === void 0 && (n = Ir.active());
      var i = !!(r != null && r.root);
      if (i)
        return new lt();
      var o = n && $o(n);
      return Uc(o) && _r(o) ? new lt(o) : new lt();
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o, a, u;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? u = r : arguments.length === 3 ? (o = r, u = n) : (o = r, a = n, u = i);
        var c = a != null ? a : Ir.active(), s = this.startSpan(t, o, c), l = Un(c, s);
        return Ir.with(l, u, void 0, s);
      }
    }, e;
  }()
);
function Uc(e) {
  return typeof e == "object" && typeof e.spanId == "string" && typeof e.traceId == "string" && typeof e.traceFlags == "number";
}
var kc = new Xo(), Bc = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.startSpan = function(t, r, n) {
      return this._getTracer().startSpan(t, r, n);
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o = this._getTracer();
      return Reflect.apply(o.startActiveSpan, o, arguments);
    }, e.prototype._getTracer = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateTracer(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : kc;
    }, e;
  }()
), Hc = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, r, n) {
      return new Xo();
    }, e;
  }()
), Gc = new Hc(), gi = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, r, n) {
      var i;
      return (i = this.getDelegateTracer(t, r, n)) !== null && i !== void 0 ? i : new Bc(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : Gc;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateTracer = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getTracer(t, r, n);
    }, e;
  }()
), Zt;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(Zt || (Zt = {}));
var yt;
(function(e) {
  e[e.INTERNAL = 0] = "INTERNAL", e[e.SERVER = 1] = "SERVER", e[e.CLIENT = 2] = "CLIENT", e[e.PRODUCER = 3] = "PRODUCER", e[e.CONSUMER = 4] = "CONSUMER";
})(yt || (yt = {}));
var Qt;
(function(e) {
  e[e.UNSET = 0] = "UNSET", e[e.OK = 1] = "OK", e[e.ERROR = 2] = "ERROR";
})(Qt || (Qt = {}));
var O = hr.getInstance(), m = re.instance(), Fc = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getMeter = function(t, r, n) {
      return Go;
    }, e;
  }()
), jc = new Fc(), xr = "metrics", Vc = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalMeterProvider = function(t) {
      return bt(xr, t, re.instance());
    }, e.prototype.getMeterProvider = function() {
      return Ne(xr) || jc;
    }, e.prototype.getMeter = function(t, r, n) {
      return this.getMeterProvider().getMeter(t, r, n);
    }, e.prototype.disable = function() {
      wt(xr, re.instance());
    }, e;
  }()
), kn = Vc.getInstance(), $c = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r) {
    }, e.prototype.extract = function(t, r) {
      return t;
    }, e.prototype.fields = function() {
      return [];
    }, e;
  }()
), Bn = Mn("OpenTelemetry Baggage Key");
function qo(e) {
  return e.getValue(Bn) || void 0;
}
function zc() {
  return qo(hr.getInstance().active());
}
function Xc(e, t) {
  return e.setValue(Bn, t);
}
function qc(e) {
  return e.deleteValue(Bn);
}
var Dr = "propagation", Wc = new $c(), Kc = (
  /** @class */
  function() {
    function e() {
      this.createBaggage = rc, this.getBaggage = qo, this.getActiveBaggage = zc, this.setBaggage = Xc, this.deleteBaggage = qc;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalPropagator = function(t) {
      return bt(Dr, t, re.instance());
    }, e.prototype.inject = function(t, r, n) {
      return n === void 0 && (n = Sc), this._getGlobalPropagator().inject(t, r, n);
    }, e.prototype.extract = function(t, r, n) {
      return n === void 0 && (n = Tc), this._getGlobalPropagator().extract(t, r, n);
    }, e.prototype.fields = function() {
      return this._getGlobalPropagator().fields();
    }, e.prototype.disable = function() {
      wt(Dr, re.instance());
    }, e.prototype._getGlobalPropagator = function() {
      return Ne(Dr) || Wc;
    }, e;
  }()
), z = Kc.getInstance(), Ur = "trace", Yc = (
  /** @class */
  function() {
    function e() {
      this._proxyTracerProvider = new gi(), this.wrapSpanContext = Dc, this.isSpanContextValid = _r, this.deleteSpan = Nc, this.getSpan = Dn, this.getActiveSpan = Pc, this.getSpanContext = $o, this.setSpan = Un, this.setSpanContext = Cc;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalTracerProvider = function(t) {
      var r = bt(Ur, this._proxyTracerProvider, re.instance());
      return r && this._proxyTracerProvider.setDelegate(t), r;
    }, e.prototype.getTracerProvider = function() {
      return Ne(Ur) || this._proxyTracerProvider;
    }, e.prototype.getTracer = function(t, r) {
      return this.getTracerProvider().getTracer(t, r);
    }, e.prototype.disable = function() {
      wt(Ur, re.instance()), this._proxyTracerProvider = new gi();
    }, e;
  }()
), L = Yc.getInstance(), Wo = Mn("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function Ko(e) {
  return e.setValue(Wo, !0);
}
function Hn(e) {
  return e.getValue(Wo) === !0;
}
var Jc = "=", fn = ";", dn = ",", kr = "baggage", Zc = 180, Qc = 4096, el = 8192, tl = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function rl(e) {
  return e.reduce(function(t, r) {
    var n = "" + t + (t !== "" ? dn : "") + r;
    return n.length > el ? t : n;
  }, "");
}
function nl(e) {
  return e.getAllEntries().map(function(t) {
    var r = tl(t, 2), n = r[0], i = r[1], o = encodeURIComponent(n) + "=" + encodeURIComponent(i.value);
    return i.metadata !== void 0 && (o += fn + i.metadata.toString()), o;
  });
}
function il(e) {
  var t = e.split(fn);
  if (!(t.length <= 0)) {
    var r = t.shift();
    if (r) {
      var n = r.indexOf(Jc);
      if (!(n <= 0)) {
        var i = decodeURIComponent(r.substring(0, n).trim()), o = decodeURIComponent(r.substring(n + 1).trim()), a;
        return t.length > 0 && (a = nc(t.join(fn))), { key: i, value: o, metadata: a };
      }
    }
  }
}
var Yo = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = z.getBaggage(t);
      if (!(!i || Hn(t))) {
        var o = nl(i).filter(function(u) {
          return u.length <= Qc;
        }).slice(0, Zc), a = rl(o);
        a.length > 0 && n.set(r, kr, a);
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, kr), o = Array.isArray(i) ? i.join(dn) : i;
      if (!o)
        return t;
      var a = {};
      if (o.length === 0)
        return t;
      var u = o.split(dn);
      return u.forEach(function(c) {
        var s = il(c);
        if (s) {
          var l = { value: s.value };
          s.metadata && (l.metadata = s.metadata), a[s.key] = l;
        }
      }), Object.entries(a).length === 0 ? t : z.setBaggage(t, z.createBaggage(a));
    }, e.prototype.fields = function() {
      return [kr];
    }, e;
  }()
), Jo = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ol = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Xt(e) {
  var t, r, n = {};
  if (typeof e != "object" || e == null)
    return n;
  try {
    for (var i = Jo(Object.entries(e)), o = i.next(); !o.done; o = i.next()) {
      var a = ol(o.value, 2), u = a[0], c = a[1];
      if (!al(u)) {
        m.warn("Invalid attribute key: " + u);
        continue;
      }
      if (!Zo(c)) {
        m.warn("Invalid attribute value set for key: " + u);
        continue;
      }
      Array.isArray(c) ? n[u] = c.slice() : n[u] = c;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
function al(e) {
  return typeof e == "string" && e.length > 0;
}
function Zo(e) {
  return e == null ? !0 : Array.isArray(e) ? sl(e) : Qo(e);
}
function sl(e) {
  var t, r, n;
  try {
    for (var i = Jo(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (a != null) {
        if (!n) {
          if (Qo(a)) {
            n = typeof a;
            continue;
          }
          return !1;
        }
        if (typeof a !== n)
          return !1;
      }
    }
  } catch (u) {
    t = { error: u };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return !0;
}
function Qo(e) {
  switch (typeof e) {
    case "number":
    case "boolean":
    case "string":
      return !0;
  }
  return !1;
}
function ul() {
  return function(e) {
    m.error(cl(e));
  };
}
function cl(e) {
  return typeof e == "string" ? e : JSON.stringify(ll(e));
}
function ll(e) {
  for (var t = {}, r = e; r !== null; )
    Object.getOwnPropertyNames(r).forEach(function(n) {
      if (!t[n]) {
        var i = r[n];
        i && (t[n] = String(i));
      }
    }), r = Object.getPrototypeOf(r);
  return t;
}
var fl = ul();
function ye(e) {
  try {
    fl(e);
  } catch (t) {
  }
}
var Z;
(function(e) {
  e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
})(Z || (Z = {}));
var dl = ",", pl = ["OTEL_SDK_DISABLED"];
function hl(e) {
  return pl.indexOf(e) > -1;
}
var _l = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function vl(e) {
  return _l.indexOf(e) > -1;
}
var yl = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS",
  "OTEL_SEMCONV_STABILITY_OPT_IN"
];
function ml(e) {
  return yl.indexOf(e) > -1;
}
var qt = 1 / 0, Wt = 128, gl = 128, El = 128, ea = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: M.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: qt,
  OTEL_ATTRIBUTE_COUNT_LIMIT: Wt,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: qt,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: Wt,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: qt,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: Wt,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: gl,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: El,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: Z.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative",
  OTEL_SEMCONV_STABILITY_OPT_IN: []
};
function Tl(e, t, r) {
  if (typeof r[e] != "undefined") {
    var n = String(r[e]);
    t[e] = n.toLowerCase() === "true";
  }
}
function Sl(e, t, r, n, i) {
  if (n === void 0 && (n = -1 / 0), i === void 0 && (i = 1 / 0), typeof r[e] != "undefined") {
    var o = Number(r[e]);
    isNaN(o) || (o < n ? t[e] = n : o > i ? t[e] = i : t[e] = o);
  }
}
function bl(e, t, r, n) {
  n === void 0 && (n = dl);
  var i = r[e];
  typeof i == "string" && (t[e] = i.split(n).map(function(o) {
    return o.trim();
  }));
}
var wl = {
  ALL: M.ALL,
  VERBOSE: M.VERBOSE,
  DEBUG: M.DEBUG,
  INFO: M.INFO,
  WARN: M.WARN,
  ERROR: M.ERROR,
  NONE: M.NONE
};
function Al(e, t, r) {
  var n = r[e];
  if (typeof n == "string") {
    var i = wl[n.toUpperCase()];
    i != null && (t[e] = i);
  }
}
function ta(e) {
  var t = {};
  for (var r in ea) {
    var n = r;
    switch (n) {
      case "OTEL_LOG_LEVEL":
        Al(n, t, e);
        break;
      default:
        if (hl(n))
          Tl(n, t, e);
        else if (vl(n))
          Sl(n, t, e);
        else if (ml(n))
          bl(n, t, e);
        else {
          var i = e[n];
          typeof i != "undefined" && i !== null && (t[n] = String(i));
        }
    }
  }
  return t;
}
var ft = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function Ke() {
  var e = ta(ft);
  return Object.assign({}, ea, e);
}
function Ol() {
  return ta(ft);
}
function Ei(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 97 && e <= 102 ? e - 87 : e - 55;
}
function Gn(e) {
  for (var t = new Uint8Array(e.length / 2), r = 0, n = 0; n < e.length; n += 2) {
    var i = Ei(e.charCodeAt(n)), o = Ei(e.charCodeAt(n + 1));
    t[r++] = i << 4 | o;
  }
  return t;
}
var q = performance, Rl = "1.30.1", Ll = "process.runtime.name", Pl = "telemetry.sdk.name", Nl = "telemetry.sdk.language", Cl = "telemetry.sdk.version", Ml = Ll, Il = Pl, xl = Nl, Dl = Cl, Ul = "webjs", kl = Ul, Fe, Br = (Fe = {}, Fe[Il] = "opentelemetry", Fe[Ml] = "browser", Fe[xl] = kl, Fe[Dl] = Rl, Fe), Bl = 9, Hl = 6, Gl = Math.pow(10, Hl), er = Math.pow(10, Bl);
function X(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * Gl);
  return [r, n];
}
function Fn() {
  var e = q.timeOrigin;
  if (typeof e != "number") {
    var t = q;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function Ce(e) {
  var t = X(Fn()), r = X(typeof e == "number" ? e : q.now());
  return ra(t, r);
}
function dt(e) {
  if (jn(e))
    return e;
  if (typeof e == "number")
    return e < Fn() ? Ce(e) : X(e);
  if (e instanceof Date)
    return X(e.getTime());
  throw TypeError("Invalid input type");
}
function Fl(e, t) {
  var r = t[0] - e[0], n = t[1] - e[1];
  return n < 0 && (r -= 1, n += er), [r, n];
}
function se(e) {
  return e[0] * er + e[1];
}
function Ct(e) {
  return e[0] * 1e6 + e[1] / 1e3;
}
function jn(e) {
  return Array.isArray(e) && e.length === 2 && typeof e[0] == "number" && typeof e[1] == "number";
}
function Ti(e) {
  return jn(e) || typeof e == "number" || e instanceof Date;
}
function ra(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= er && (r[1] -= er, r[0] += 1), r;
}
var N;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(N || (N = {}));
var jl = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, na = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r;
      this._propagators = (r = t.propagators) !== null && r !== void 0 ? r : [], this._fields = Array.from(new Set(this._propagators.map(function(n) {
        return typeof n.fields == "function" ? n.fields() : [];
      }).reduce(function(n, i) {
        return n.concat(i);
      }, [])));
    }
    return e.prototype.inject = function(t, r, n) {
      var i, o;
      try {
        for (var a = jl(this._propagators), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          try {
            c.inject(t, r, n);
          } catch (s) {
            m.warn("Failed to inject with " + c.constructor.name + ". Err: " + s.message);
          }
        }
      } catch (s) {
        i = { error: s };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
    }, e.prototype.extract = function(t, r, n) {
      return this._propagators.reduce(function(i, o) {
        try {
          return o.extract(i, r, n);
        } catch (a) {
          m.warn("Failed to extract with " + o.constructor.name + ". Err: " + a.message);
        }
        return i;
      }, t);
    }, e.prototype.fields = function() {
      return this._fields.slice();
    }, e;
  }()
), pn = "[_0-9a-z-*/]", Vl = "[a-z]" + pn + "{0,255}", $l = "[a-z0-9]" + pn + "{0,240}@[a-z]" + pn + "{0,13}", zl = new RegExp("^(?:" + Vl + "|" + $l + ")$"), Xl = /^[ -~]{0,255}[!-~]$/, ql = /,|=/;
function Wl(e) {
  return zl.test(e);
}
function Kl(e) {
  return Xl.test(e) && !ql.test(e);
}
var Si = 32, Yl = 512, bi = ",", wi = "=", Jl = (
  /** @class */
  function() {
    function e(t) {
      this._internalState = /* @__PURE__ */ new Map(), t && this._parse(t);
    }
    return e.prototype.set = function(t, r) {
      var n = this._clone();
      return n._internalState.has(t) && n._internalState.delete(t), n._internalState.set(t, r), n;
    }, e.prototype.unset = function(t) {
      var r = this._clone();
      return r._internalState.delete(t), r;
    }, e.prototype.get = function(t) {
      return this._internalState.get(t);
    }, e.prototype.serialize = function() {
      var t = this;
      return this._keys().reduce(function(r, n) {
        return r.push(n + wi + t.get(n)), r;
      }, []).join(bi);
    }, e.prototype._parse = function(t) {
      t.length > Yl || (this._internalState = t.split(bi).reverse().reduce(function(r, n) {
        var i = n.trim(), o = i.indexOf(wi);
        if (o !== -1) {
          var a = i.slice(0, o), u = i.slice(o + 1, n.length);
          Wl(a) && Kl(u) && r.set(a, u);
        }
        return r;
      }, /* @__PURE__ */ new Map()), this._internalState.size > Si && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, Si))));
    }, e.prototype._keys = function() {
      return Array.from(this._internalState.keys()).reverse();
    }, e.prototype._clone = function() {
      var t = new e();
      return t._internalState = new Map(this._internalState), t;
    }, e;
  }()
), Kt = "traceparent", Hr = "tracestate", Zl = "00", Ql = "(?!ff)[\\da-f]{2}", ef = "(?![0]{32})[\\da-f]{32}", tf = "(?![0]{16})[\\da-f]{16}", rf = "[\\da-f]{2}", nf = new RegExp("^\\s?(" + Ql + ")-(" + ef + ")-(" + tf + ")-(" + rf + ")(-.*)?\\s?$");
function of(e) {
  var t = nf.exec(e);
  return !t || t[1] === "00" && t[5] ? null : {
    traceId: t[2],
    spanId: t[3],
    traceFlags: parseInt(t[4], 16)
  };
}
var ia = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = L.getSpanContext(t);
      if (!(!i || Hn(t) || !_r(i))) {
        var o = Zl + "-" + i.traceId + "-" + i.spanId + "-0" + Number(i.traceFlags || ue.NONE).toString(16);
        n.set(r, Kt, o), i.traceState && n.set(r, Hr, i.traceState.serialize());
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, Kt);
      if (!i)
        return t;
      var o = Array.isArray(i) ? i[0] : i;
      if (typeof o != "string")
        return t;
      var a = of(o);
      if (!a)
        return t;
      a.isRemote = !0;
      var u = n.get(r, Hr);
      if (u) {
        var c = Array.isArray(u) ? u.join(",") : u;
        a.traceState = new Jl(typeof c == "string" ? c : void 0);
      }
      return L.setSpanContext(t, a);
    }, e.prototype.fields = function() {
      return [Kt, Hr];
    }, e;
  }()
), af = "[object Object]", sf = "[object Null]", uf = "[object Undefined]", cf = Function.prototype, oa = cf.toString, lf = oa.call(Object), ff = df(Object.getPrototypeOf, Object), aa = Object.prototype, sa = aa.hasOwnProperty, be = Symbol ? Symbol.toStringTag : void 0, ua = aa.toString;
function df(e, t) {
  return function(r) {
    return e(t(r));
  };
}
function Ai(e) {
  if (!pf(e) || hf(e) !== af)
    return !1;
  var t = ff(e);
  if (t === null)
    return !0;
  var r = sa.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && oa.call(r) === lf;
}
function pf(e) {
  return e != null && typeof e == "object";
}
function hf(e) {
  return e == null ? e === void 0 ? uf : sf : be && be in Object(e) ? _f(e) : vf(e);
}
function _f(e) {
  var t = sa.call(e, be), r = e[be], n = !1;
  try {
    e[be] = void 0, n = !0;
  } catch (o) {
  }
  var i = ua.call(e);
  return n && (t ? e[be] = r : delete e[be]), i;
}
function vf(e) {
  return ua.call(e);
}
var yf = 20;
function ca() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r = e.shift(), n = /* @__PURE__ */ new WeakMap(); e.length > 0; )
    r = la(r, e.shift(), 0, n);
  return r;
}
function Gr(e) {
  return tr(e) ? e.slice() : e;
}
function la(e, t, r, n) {
  r === void 0 && (r = 0);
  var i;
  if (!(r > yf)) {
    if (r++, Yt(e) || Yt(t) || fa(t))
      i = Gr(t);
    else if (tr(e)) {
      if (i = e.slice(), tr(t))
        for (var o = 0, a = t.length; o < a; o++)
          i.push(Gr(t[o]));
      else if (ot(t))
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o];
          i[c] = Gr(t[c]);
        }
    } else if (ot(e))
      if (ot(t)) {
        if (!mf(e, t))
          return t;
        i = Object.assign({}, e);
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o], s = t[c];
          if (Yt(s))
            typeof s == "undefined" ? delete i[c] : i[c] = s;
          else {
            var l = i[c], f = s;
            if (Oi(e, c, n) || Oi(t, c, n))
              delete i[c];
            else {
              if (ot(l) && ot(f)) {
                var d = n.get(l) || [], h = n.get(f) || [];
                d.push({ obj: e, key: c }), h.push({ obj: t, key: c }), n.set(l, d), n.set(f, h);
              }
              i[c] = la(i[c], s, r, n);
            }
          }
        }
      } else
        i = t;
    return i;
  }
}
function Oi(e, t, r) {
  for (var n = r.get(e[t]) || [], i = 0, o = n.length; i < o; i++) {
    var a = n[i];
    if (a.key === t && a.obj === e)
      return !0;
  }
  return !1;
}
function tr(e) {
  return Array.isArray(e);
}
function fa(e) {
  return typeof e == "function";
}
function ot(e) {
  return !Yt(e) && !tr(e) && !fa(e) && typeof e == "object";
}
function Yt(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "undefined" || e instanceof Date || e instanceof RegExp || e === null;
}
function mf(e, t) {
  return !(!Ai(e) || !Ai(t));
}
var gf = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function da(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
function pa(e, t) {
  var r, n;
  if (!t)
    return !1;
  try {
    for (var i = gf(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (da(e, a))
        return !0;
    }
  } catch (u) {
    r = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !1;
}
var Ef = (
  /** @class */
  function() {
    function e() {
      var t = this;
      this._promise = new Promise(function(r, n) {
        t._resolve = r, t._reject = n;
      });
    }
    return Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.resolve = function(t) {
      this._resolve(t);
    }, e.prototype.reject = function(t) {
      this._reject(t);
    }, e;
  }()
), Tf = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Sf = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, bf = (
  /** @class */
  function() {
    function e(t, r) {
      this._callback = t, this._that = r, this._isCalled = !1, this._deferred = new Ef();
    }
    return Object.defineProperty(e.prototype, "isCalled", {
      get: function() {
        return this._isCalled;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._deferred.promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.call = function() {
      for (var t, r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      if (!this._isCalled) {
        this._isCalled = !0;
        try {
          Promise.resolve((t = this._callback).call.apply(t, Sf([this._that], Tf(n), !1))).then(function(o) {
            return r._deferred.resolve(o);
          }, function(o) {
            return r._deferred.reject(o);
          });
        } catch (o) {
          this._deferred.reject(o);
        }
      }
      return this._deferred.promise;
    }, e;
  }()
);
function wf(e, t) {
  return new Promise(function(r) {
    O.with(Ko(O.active()), function() {
      e.export(t, function(n) {
        r(n);
      });
    });
  });
}
var Af = {
  _export: wf
}, ha = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.emit = function(t) {
    }, e;
  }()
), Of = new ha(), Rf = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      return new ha();
    }, e;
  }()
), _a = new Rf(), Lf = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.emit = function(t) {
      this._getLogger().emit(t);
    }, e.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : Of;
    }, e;
  }()
), Ri = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      var i;
      return (i = this.getDelegateLogger(t, r, n)) !== null && i !== void 0 ? i : new Lf(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : _a;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateLogger = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(t, r, n);
    }, e;
  }()
), Pf = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, Mt = Symbol.for("io.opentelemetry.js.api.logs"), at = Pf;
function Nf(e, t, r) {
  return function(n) {
    return n === e ? t : r;
  };
}
var Li = 1, Cf = (
  /** @class */
  function() {
    function e() {
      this._proxyLoggerProvider = new Ri();
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalLoggerProvider = function(t) {
      return at[Mt] ? this.getLoggerProvider() : (at[Mt] = Nf(Li, t, _a), this._proxyLoggerProvider.setDelegate(t), t);
    }, e.prototype.getLoggerProvider = function() {
      var t, r;
      return (r = (t = at[Mt]) === null || t === void 0 ? void 0 : t.call(at, Li)) !== null && r !== void 0 ? r : this._proxyLoggerProvider;
    }, e.prototype.getLogger = function(t, r, n) {
      return this.getLoggerProvider().getLogger(t, r, n);
    }, e.prototype.disable = function() {
      delete at[Mt], this._proxyLoggerProvider = new Ri();
    }, e;
  }()
), va = Cf.getInstance();
function Mf(e, t, r, n) {
  for (var i = 0, o = e.length; i < o; i++) {
    var a = e[i];
    t && a.setTracerProvider(t), r && a.setMeterProvider(r), n && a.setLoggerProvider && a.setLoggerProvider(n), a.getConfig().enabled || a.enable();
  }
}
function If(e) {
  e.forEach(function(t) {
    return t.disable();
  });
}
function xf(e) {
  var t, r, n = e.tracerProvider || L.getTracerProvider(), i = e.meterProvider || kn.getMeterProvider(), o = e.loggerProvider || va.getLoggerProvider(), a = (r = (t = e.instrumentations) === null || t === void 0 ? void 0 : t.flat()) !== null && r !== void 0 ? r : [];
  return Mf(a, n, i, o), function() {
    If(a);
  };
}
function hn(e) {
  return typeof e == "function";
}
var H = console.error.bind(console);
function st(e, t, r) {
  var n = !!e[t] && e.propertyIsEnumerable(t);
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: n,
    writable: !0,
    value: r
  });
}
function At(e) {
  e && e.logger && (hn(e.logger) ? H = e.logger : H("new logger isn't a function, not replacing"));
}
function ya(e, t, r) {
  if (!e || !e[t]) {
    H("no original function " + t + " to wrap");
    return;
  }
  if (!r) {
    H("no wrapper function"), H(new Error().stack);
    return;
  }
  if (!hn(e[t]) || !hn(r)) {
    H("original object and wrapper must be functions");
    return;
  }
  var n = e[t], i = r(n, t);
  return st(i, "__original", n), st(i, "__unwrap", function() {
    e[t] === i && st(e, t, n);
  }), st(i, "__wrapped", !0), st(e, t, i), i;
}
function Df(e, t, r) {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    H("must provide one or more modules to patch"), H(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    H("must provide one or more functions to wrap on modules");
    return;
  }
  e.forEach(function(n) {
    t.forEach(function(i) {
      ya(n, i, r);
    });
  });
}
function ma(e, t) {
  if (!e || !e[t]) {
    H("no function to unwrap."), H(new Error().stack);
    return;
  }
  if (!e[t].__unwrap)
    H("no original to unwrap to -- has " + t + " already been unwrapped?");
  else
    return e[t].__unwrap();
}
function Uf(e, t) {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    H("must provide one or more modules to patch"), H(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    H("must provide one or more functions to unwrap on modules");
    return;
  }
  e.forEach(function(r) {
    t.forEach(function(n) {
      ma(r, n);
    });
  });
}
At.wrap = ya;
At.massWrap = Df;
At.unwrap = ma;
At.massUnwrap = Uf;
var It = At, _n = function() {
  return _n = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, _n.apply(this, arguments);
}, kf = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = It.wrap, this._unwrap = It.unwrap, this._massWrap = It.massWrap, this._massUnwrap = It.massUnwrap, this.setConfig(n), this._diag = m.createComponentLogger({
        namespace: t
      }), this._tracer = L.getTracer(t, r), this._meter = kn.getMeter(t, r), this._logger = va.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = _n({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), Bf = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Ot = (
  /** @class */
  function(e) {
    Bf(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(kf)
);
function rr(e, t, r) {
  var n, i;
  try {
    i = e();
  } catch (o) {
    n = o;
  } finally {
    return t(n, i), i;
  }
}
function x(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var Hf = "exception.type", Gf = "exception.message", Ff = "exception.stacktrace", Fr = Hf, jr = Gf, jf = Ff, Vf = "exception", vn = function() {
  return vn = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, vn.apply(this, arguments);
}, $f = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Pi = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, zf = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Xf = (
  /** @class */
  function() {
    function e(t, r, n, i, o, a, u, c, s, l) {
      u === void 0 && (u = []), this.attributes = {}, this.links = [], this.events = [], this._droppedAttributesCount = 0, this._droppedEventsCount = 0, this._droppedLinksCount = 0, this.status = {
        code: Qt.UNSET
      }, this.endTime = [0, 0], this._ended = !1, this._duration = [-1, -1], this.name = n, this._spanContext = i, this.parentSpanId = a, this.kind = o, this.links = u;
      var f = Date.now();
      this._performanceStartTime = q.now(), this._performanceOffset = f - (this._performanceStartTime + Fn()), this._startTimeProvided = c != null, this.startTime = this._getTime(c != null ? c : f), this.resource = t.resource, this.instrumentationLibrary = t.instrumentationLibrary, this._spanLimits = t.getSpanLimits(), this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0, l != null && this.setAttributes(l), this._spanProcessor = t.getActiveSpanProcessor(), this._spanProcessor.onStart(this, r);
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, r) {
      return r == null || this._isSpanEnded() ? this : t.length === 0 ? (m.warn("Invalid attribute key: " + t), this) : Zo(r) ? Object.keys(this.attributes).length >= this._spanLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, t) ? (this._droppedAttributesCount++, this) : (this.attributes[t] = this._truncateToSize(r), this) : (m.warn("Invalid attribute value set for key: " + t), this);
    }, e.prototype.setAttributes = function(t) {
      var r, n;
      try {
        for (var i = $f(Object.entries(t)), o = i.next(); !o.done; o = i.next()) {
          var a = Pi(o.value, 2), u = a[0], c = a[1];
          this.setAttribute(u, c);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r) throw r.error;
        }
      }
      return this;
    }, e.prototype.addEvent = function(t, r, n) {
      if (this._isSpanEnded())
        return this;
      if (this._spanLimits.eventCountLimit === 0)
        return m.warn("No events allowed."), this._droppedEventsCount++, this;
      this.events.length >= this._spanLimits.eventCountLimit && (this._droppedEventsCount === 0 && m.debug("Dropping extra events."), this.events.shift(), this._droppedEventsCount++), Ti(r) && (Ti(n) || (n = r), r = void 0);
      var i = Xt(r);
      return this.events.push({
        name: t,
        attributes: i,
        time: this._getTime(n),
        droppedAttributesCount: 0
      }), this;
    }, e.prototype.addLink = function(t) {
      return this.links.push(t), this;
    }, e.prototype.addLinks = function(t) {
      var r;
      return (r = this.links).push.apply(r, zf([], Pi(t), !1)), this;
    }, e.prototype.setStatus = function(t) {
      return this._isSpanEnded() ? this : (this.status = vn({}, t), this.status.message != null && typeof t.message != "string" && (m.warn("Dropping invalid status.message of type '" + typeof t.message + "', expected 'string'"), delete this.status.message), this);
    }, e.prototype.updateName = function(t) {
      return this._isSpanEnded() ? this : (this.name = t, this);
    }, e.prototype.end = function(t) {
      if (this._isSpanEnded()) {
        m.error(this.name + " " + this._spanContext.traceId + "-" + this._spanContext.spanId + " - You can only call end() on a span once.");
        return;
      }
      this._ended = !0, this.endTime = this._getTime(t), this._duration = Fl(this.startTime, this.endTime), this._duration[0] < 0 && (m.warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime), this.endTime = this.startTime.slice(), this._duration = [0, 0]), this._droppedEventsCount > 0 && m.warn("Dropped " + this._droppedEventsCount + " events because eventCountLimit reached"), this._spanProcessor.onEnd(this);
    }, e.prototype._getTime = function(t) {
      if (typeof t == "number" && t <= q.now())
        return Ce(t + this._performanceOffset);
      if (typeof t == "number")
        return X(t);
      if (t instanceof Date)
        return X(t.getTime());
      if (jn(t))
        return t;
      if (this._startTimeProvided)
        return X(Date.now());
      var r = q.now() - this._performanceStartTime;
      return ra(this.startTime, X(r));
    }, e.prototype.isRecording = function() {
      return this._ended === !1;
    }, e.prototype.recordException = function(t, r) {
      var n = {};
      typeof t == "string" ? n[jr] = t : t && (t.code ? n[Fr] = t.code.toString() : t.name && (n[Fr] = t.name), t.message && (n[jr] = t.message), t.stack && (n[jf] = t.stack)), n[Fr] || n[jr] ? this.addEvent(Vf, n, r) : m.warn("Failed to record an exception " + t);
    }, Object.defineProperty(e.prototype, "duration", {
      get: function() {
        return this._duration;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "ended", {
      get: function() {
        return this._ended;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedAttributesCount", {
      get: function() {
        return this._droppedAttributesCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedEventsCount", {
      get: function() {
        return this._droppedEventsCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedLinksCount", {
      get: function() {
        return this._droppedLinksCount;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._isSpanEnded = function() {
      return this._ended && m.warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}"), this._ended;
    }, e.prototype._truncateToLimitUtil = function(t, r) {
      return t.length <= r ? t : t.substring(0, r);
    }, e.prototype._truncateToSize = function(t) {
      var r = this, n = this._attributeValueLengthLimit;
      return n <= 0 ? (m.warn("Attribute value limit must be positive, got " + n), t) : typeof t == "string" ? this._truncateToLimitUtil(t, n) : Array.isArray(t) ? t.map(function(i) {
        return typeof i == "string" ? r._truncateToLimitUtil(i, n) : i;
      }) : t;
    }, e;
  }()
), Ye;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(Ye || (Ye = {}));
var nr = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.shouldSample = function() {
      return {
        decision: Ye.NOT_RECORD
      };
    }, e.prototype.toString = function() {
      return "AlwaysOffSampler";
    }, e;
  }()
), Xe = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.shouldSample = function() {
      return {
        decision: Ye.RECORD_AND_SAMPLED
      };
    }, e.prototype.toString = function() {
      return "AlwaysOnSampler";
    }, e;
  }()
), Vr = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i, o;
      this._root = t.root, this._root || (ye(new Error("ParentBasedSampler must have a root sampler configured")), this._root = new Xe()), this._remoteParentSampled = (r = t.remoteParentSampled) !== null && r !== void 0 ? r : new Xe(), this._remoteParentNotSampled = (n = t.remoteParentNotSampled) !== null && n !== void 0 ? n : new nr(), this._localParentSampled = (i = t.localParentSampled) !== null && i !== void 0 ? i : new Xe(), this._localParentNotSampled = (o = t.localParentNotSampled) !== null && o !== void 0 ? o : new nr();
    }
    return e.prototype.shouldSample = function(t, r, n, i, o, a) {
      var u = L.getSpanContext(t);
      return !u || !_r(u) ? this._root.shouldSample(t, r, n, i, o, a) : u.isRemote ? u.traceFlags & ue.SAMPLED ? this._remoteParentSampled.shouldSample(t, r, n, i, o, a) : this._remoteParentNotSampled.shouldSample(t, r, n, i, o, a) : u.traceFlags & ue.SAMPLED ? this._localParentSampled.shouldSample(t, r, n, i, o, a) : this._localParentNotSampled.shouldSample(t, r, n, i, o, a);
    }, e.prototype.toString = function() {
      return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    }, e;
  }()
), Ni = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = 0), this._ratio = t, this._ratio = this._normalize(t), this._upperBound = Math.floor(this._ratio * 4294967295);
    }
    return e.prototype.shouldSample = function(t, r) {
      return {
        decision: zo(r) && this._accumulate(r) < this._upperBound ? Ye.RECORD_AND_SAMPLED : Ye.NOT_RECORD
      };
    }, e.prototype.toString = function() {
      return "TraceIdRatioBased{" + this._ratio + "}";
    }, e.prototype._normalize = function(t) {
      return typeof t != "number" || isNaN(t) ? 0 : t >= 1 ? 1 : t <= 0 ? 0 : t;
    }, e.prototype._accumulate = function(t) {
      for (var r = 0, n = 0; n < t.length / 8; n++) {
        var i = n * 8, o = parseInt(t.slice(i, i + 8), 16);
        r = (r ^ o) >>> 0;
      }
      return r;
    }, e;
  }()
), qf = Z.AlwaysOn, je = 1;
function ga() {
  var e = Ke();
  return {
    sampler: Ea(e),
    forceFlushTimeoutMillis: 3e4,
    generalLimits: {
      attributeValueLengthLimit: e.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: e.OTEL_ATTRIBUTE_COUNT_LIMIT
    },
    spanLimits: {
      attributeValueLengthLimit: e.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: e.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT,
      linkCountLimit: e.OTEL_SPAN_LINK_COUNT_LIMIT,
      eventCountLimit: e.OTEL_SPAN_EVENT_COUNT_LIMIT,
      attributePerEventCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
      attributePerLinkCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT
    },
    mergeResourceWithDefaults: !0
  };
}
function Ea(e) {
  switch (e === void 0 && (e = Ke()), e.OTEL_TRACES_SAMPLER) {
    case Z.AlwaysOn:
      return new Xe();
    case Z.AlwaysOff:
      return new nr();
    case Z.ParentBasedAlwaysOn:
      return new Vr({
        root: new Xe()
      });
    case Z.ParentBasedAlwaysOff:
      return new Vr({
        root: new nr()
      });
    case Z.TraceIdRatio:
      return new Ni(Ci(e));
    case Z.ParentBasedTraceIdRatio:
      return new Vr({
        root: new Ni(Ci(e))
      });
    default:
      return m.error('OTEL_TRACES_SAMPLER value "' + e.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + qf + '".'), new Xe();
  }
}
function Ci(e) {
  if (e.OTEL_TRACES_SAMPLER_ARG === void 0 || e.OTEL_TRACES_SAMPLER_ARG === "")
    return m.error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to " + je + "."), je;
  var t = Number(e.OTEL_TRACES_SAMPLER_ARG);
  return isNaN(t) ? (m.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to " + je + "."), je) : t < 0 || t > 1 ? (m.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to " + je + "."), je) : t;
}
function Wf(e) {
  var t = {
    sampler: Ea()
  }, r = ga(), n = Object.assign({}, r, t, e);
  return n.generalLimits = Object.assign({}, r.generalLimits, e.generalLimits || {}), n.spanLimits = Object.assign({}, r.spanLimits, e.spanLimits || {}), n;
}
function Kf(e) {
  var t, r, n, i, o, a, u, c, s, l, f, d, h = Object.assign({}, e.spanLimits), _ = Ol();
  return h.attributeCountLimit = (a = (o = (i = (r = (t = e.spanLimits) === null || t === void 0 ? void 0 : t.attributeCountLimit) !== null && r !== void 0 ? r : (n = e.generalLimits) === null || n === void 0 ? void 0 : n.attributeCountLimit) !== null && i !== void 0 ? i : _.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) !== null && o !== void 0 ? o : _.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && a !== void 0 ? a : Wt, h.attributeValueLengthLimit = (d = (f = (l = (c = (u = e.spanLimits) === null || u === void 0 ? void 0 : u.attributeValueLengthLimit) !== null && c !== void 0 ? c : (s = e.generalLimits) === null || s === void 0 ? void 0 : s.attributeValueLengthLimit) !== null && l !== void 0 ? l : _.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && f !== void 0 ? f : _.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && d !== void 0 ? d : qt, Object.assign({}, e, { spanLimits: h });
}
var Yf = (
  /** @class */
  function() {
    function e(t, r) {
      this._exporter = t, this._isExporting = !1, this._finishedSpans = [], this._droppedSpansCount = 0;
      var n = Ke();
      this._maxExportBatchSize = typeof (r == null ? void 0 : r.maxExportBatchSize) == "number" ? r.maxExportBatchSize : n.OTEL_BSP_MAX_EXPORT_BATCH_SIZE, this._maxQueueSize = typeof (r == null ? void 0 : r.maxQueueSize) == "number" ? r.maxQueueSize : n.OTEL_BSP_MAX_QUEUE_SIZE, this._scheduledDelayMillis = typeof (r == null ? void 0 : r.scheduledDelayMillis) == "number" ? r.scheduledDelayMillis : n.OTEL_BSP_SCHEDULE_DELAY, this._exportTimeoutMillis = typeof (r == null ? void 0 : r.exportTimeoutMillis) == "number" ? r.exportTimeoutMillis : n.OTEL_BSP_EXPORT_TIMEOUT, this._shutdownOnce = new bf(this._shutdown, this), this._maxExportBatchSize > this._maxQueueSize && (m.warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize"), this._maxExportBatchSize = this._maxQueueSize);
    }
    return e.prototype.forceFlush = function() {
      return this._shutdownOnce.isCalled ? this._shutdownOnce.promise : this._flushAll();
    }, e.prototype.onStart = function(t, r) {
    }, e.prototype.onEnd = function(t) {
      this._shutdownOnce.isCalled || (t.spanContext().traceFlags & ue.SAMPLED) !== 0 && this._addToBuffer(t);
    }, e.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, e.prototype._shutdown = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.onShutdown();
      }).then(function() {
        return t._flushAll();
      }).then(function() {
        return t._exporter.shutdown();
      });
    }, e.prototype._addToBuffer = function(t) {
      if (this._finishedSpans.length >= this._maxQueueSize) {
        this._droppedSpansCount === 0 && m.debug("maxQueueSize reached, dropping spans"), this._droppedSpansCount++;
        return;
      }
      this._droppedSpansCount > 0 && (m.warn("Dropped " + this._droppedSpansCount + " spans because maxQueueSize reached"), this._droppedSpansCount = 0), this._finishedSpans.push(t), this._maybeStartTimer();
    }, e.prototype._flushAll = function() {
      var t = this;
      return new Promise(function(r, n) {
        for (var i = [], o = Math.ceil(t._finishedSpans.length / t._maxExportBatchSize), a = 0, u = o; a < u; a++)
          i.push(t._flushOneBatch());
        Promise.all(i).then(function() {
          r();
        }).catch(n);
      });
    }, e.prototype._flushOneBatch = function() {
      var t = this;
      return this._clearTimer(), this._finishedSpans.length === 0 ? Promise.resolve() : new Promise(function(r, n) {
        var i = setTimeout(function() {
          n(new Error("Timeout"));
        }, t._exportTimeoutMillis);
        O.with(Ko(O.active()), function() {
          var o;
          t._finishedSpans.length <= t._maxExportBatchSize ? (o = t._finishedSpans, t._finishedSpans = []) : o = t._finishedSpans.splice(0, t._maxExportBatchSize);
          for (var a = function() {
            return t._exporter.export(o, function(f) {
              var d;
              clearTimeout(i), f.code === N.SUCCESS ? r() : n((d = f.error) !== null && d !== void 0 ? d : new Error("BatchSpanProcessor: span export failed"));
            });
          }, u = null, c = 0, s = o.length; c < s; c++) {
            var l = o[c];
            l.resource.asyncAttributesPending && l.resource.waitForAsyncAttributes && (u != null || (u = []), u.push(l.resource.waitForAsyncAttributes()));
          }
          u === null ? a() : Promise.all(u).then(a, function(f) {
            ye(f), n(f);
          });
        });
      });
    }, e.prototype._maybeStartTimer = function() {
      var t = this;
      if (!this._isExporting) {
        var r = function() {
          t._isExporting = !0, t._flushOneBatch().finally(function() {
            t._isExporting = !1, t._finishedSpans.length > 0 && (t._clearTimer(), t._maybeStartTimer());
          }).catch(function(n) {
            t._isExporting = !1, ye(n);
          });
        };
        if (this._finishedSpans.length >= this._maxExportBatchSize)
          return r();
        this._timer === void 0 && (this._timer = setTimeout(function() {
          return r();
        }, this._scheduledDelayMillis));
      }
    }, e.prototype._clearTimer = function() {
      this._timer !== void 0 && (clearTimeout(this._timer), this._timer = void 0);
    }, e;
  }()
), Jf = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Ta = (
  /** @class */
  function(e) {
    Jf(t, e);
    function t(r, n) {
      var i = e.call(this, r, n) || this;
      return i.onInit(n), i;
    }
    return t.prototype.onInit = function(r) {
      var n = this;
      (r == null ? void 0 : r.disableAutoFlushOnDocumentHide) !== !0 && typeof document != "undefined" && (this._visibilityChangeListener = function() {
        document.visibilityState === "hidden" && n.forceFlush().catch(function(i) {
          ye(i);
        });
      }, this._pageHideListener = function() {
        n.forceFlush().catch(function(i) {
          ye(i);
        });
      }, document.addEventListener("visibilitychange", this._visibilityChangeListener), document.addEventListener("pagehide", this._pageHideListener));
    }, t.prototype.onShutdown = function() {
      typeof document != "undefined" && (this._visibilityChangeListener && document.removeEventListener("visibilitychange", this._visibilityChangeListener), this._pageHideListener && document.removeEventListener("pagehide", this._pageHideListener));
    }, t;
  }(Yf)
), Zf = 8, Qf = 16, ed = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
      this.generateTraceId = Mi(Qf), this.generateSpanId = Mi(Zf);
    }
    return e;
  }()
), xt = Array(32);
function Mi(e) {
  return function() {
    for (var r = 0; r < e * 2; r++)
      xt[r] = Math.floor(Math.random() * 16) + 48, xt[r] >= 58 && (xt[r] += 39);
    return String.fromCharCode.apply(null, xt.slice(0, e * 2));
  };
}
var td = (
  /** @class */
  function() {
    function e(t, r, n) {
      this._tracerProvider = n;
      var i = Wf(r);
      this._sampler = i.sampler, this._generalLimits = i.generalLimits, this._spanLimits = i.spanLimits, this._idGenerator = r.idGenerator || new ed(), this.resource = n.resource, this.instrumentationLibrary = t;
    }
    return e.prototype.startSpan = function(t, r, n) {
      var i, o, a;
      r === void 0 && (r = {}), n === void 0 && (n = O.active()), r.root && (n = L.deleteSpan(n));
      var u = L.getSpan(n);
      if (Hn(n)) {
        m.debug("Instrumentation suppressed, returning Noop Span");
        var c = L.wrapSpanContext(Vo);
        return c;
      }
      var s = u == null ? void 0 : u.spanContext(), l = this._idGenerator.generateSpanId(), f, d, h;
      !s || !L.isSpanContextValid(s) ? f = this._idGenerator.generateTraceId() : (f = s.traceId, d = s.traceState, h = s.spanId);
      var _ = (i = r.kind) !== null && i !== void 0 ? i : yt.INTERNAL, p = ((o = r.links) !== null && o !== void 0 ? o : []).map(function(P) {
        return {
          context: P.context,
          attributes: Xt(P.attributes)
        };
      }), v = Xt(r.attributes), y = this._sampler.shouldSample(n, f, t, _, v, p);
      d = (a = y.traceState) !== null && a !== void 0 ? a : d;
      var g = y.decision === Zt.RECORD_AND_SAMPLED ? ue.SAMPLED : ue.NONE, w = { traceId: f, spanId: l, traceFlags: g, traceState: d };
      if (y.decision === Zt.NOT_RECORD) {
        m.debug("Recording is off, propagating context in a non-recording span");
        var c = L.wrapSpanContext(w);
        return c;
      }
      var A = Xt(Object.assign(v, y.attributes)), R = new Xf(this, n, t, w, _, h, p, r.startTime, void 0, A);
      return R;
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o, a, u;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? u = r : arguments.length === 3 ? (o = r, u = n) : (o = r, a = n, u = i);
        var c = a != null ? a : O.active(), s = this.startSpan(t, o, c), l = L.setSpan(c, s);
        return O.with(l, u, void 0, s);
      }
    }, e.prototype.getGeneralLimits = function() {
      return this._generalLimits;
    }, e.prototype.getSpanLimits = function() {
      return this._spanLimits;
    }, e.prototype.getActiveSpanProcessor = function() {
      return this._tracerProvider.getActiveSpanProcessor();
    }, e;
  }()
), rd = "service.name", nd = "telemetry.sdk.name", id = "telemetry.sdk.language", od = "telemetry.sdk.version", ad = rd, Ii = nd, xi = id, Di = od;
function sd() {
  return "unknown_service";
}
var pe = function() {
  return pe = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, pe.apply(this, arguments);
}, ud = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, cd = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, ld = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, mt = (
  /** @class */
  function() {
    function e(t, r) {
      var n = this, i;
      this._attributes = t, this.asyncAttributesPending = r != null, this._syncAttributes = (i = this._attributes) !== null && i !== void 0 ? i : {}, this._asyncAttributesPromise = r == null ? void 0 : r.then(function(o) {
        return n._attributes = Object.assign({}, n._attributes, o), n.asyncAttributesPending = !1, o;
      }, function(o) {
        return m.debug("a resource's async attributes promise rejected: %s", o), n.asyncAttributesPending = !1, {};
      });
    }
    return e.empty = function() {
      return e.EMPTY;
    }, e.default = function() {
      var t;
      return new e((t = {}, t[ad] = sd(), t[xi] = Br[xi], t[Ii] = Br[Ii], t[Di] = Br[Di], t));
    }, Object.defineProperty(e.prototype, "attributes", {
      get: function() {
        var t;
        return this.asyncAttributesPending && m.error("Accessing resource attributes before async attributes settled"), (t = this._attributes) !== null && t !== void 0 ? t : {};
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.waitForAsyncAttributes = function() {
      return ud(this, void 0, void 0, function() {
        return cd(this, function(t) {
          switch (t.label) {
            case 0:
              return this.asyncAttributesPending ? [4, this._asyncAttributesPromise] : [3, 2];
            case 1:
              t.sent(), t.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.merge = function(t) {
      var r = this, n;
      if (!t)
        return this;
      var i = pe(pe({}, this._syncAttributes), (n = t._syncAttributes) !== null && n !== void 0 ? n : t.attributes);
      if (!this._asyncAttributesPromise && !t._asyncAttributesPromise)
        return new e(i);
      var o = Promise.all([
        this._asyncAttributesPromise,
        t._asyncAttributesPromise
      ]).then(function(a) {
        var u, c = ld(a, 2), s = c[0], l = c[1];
        return pe(pe(pe(pe({}, r._syncAttributes), s), (u = t._syncAttributes) !== null && u !== void 0 ? u : t.attributes), l);
      });
      return new e(i, o);
    }, e.EMPTY = new e({}), e;
  }()
), Dt = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Ui = (
  /** @class */
  function() {
    function e(t) {
      this._spanProcessors = t;
    }
    return e.prototype.forceFlush = function() {
      var t, r, n = [];
      try {
        for (var i = Dt(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.forceFlush());
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(u) {
        Promise.all(n).then(function() {
          u();
        }).catch(function(c) {
          ye(c || new Error("MultiSpanProcessor: forceFlush failed")), u();
        });
      });
    }, e.prototype.onStart = function(t, r) {
      var n, i;
      try {
        for (var o = Dt(this._spanProcessors), a = o.next(); !a.done; a = o.next()) {
          var u = a.value;
          u.onStart(t, r);
        }
      } catch (c) {
        n = { error: c };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
    }, e.prototype.onEnd = function(t) {
      var r, n;
      try {
        for (var i = Dt(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          a.onEnd(t);
        }
      } catch (u) {
        r = { error: u };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r) throw r.error;
        }
      }
    }, e.prototype.shutdown = function() {
      var t, r, n = [];
      try {
        for (var i = Dt(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.shutdown());
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(u, c) {
        Promise.all(n).then(function() {
          u();
        }, c);
      });
    }, e;
  }()
), fd = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.onStart = function(t, r) {
    }, e.prototype.onEnd = function(t) {
    }, e.prototype.shutdown = function() {
      return Promise.resolve();
    }, e.prototype.forceFlush = function() {
      return Promise.resolve();
    }, e;
  }()
), dd = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, pd = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, we;
(function(e) {
  e[e.resolved = 0] = "resolved", e[e.timeout = 1] = "timeout", e[e.error = 2] = "error", e[e.unresolved = 3] = "unresolved";
})(we || (we = {}));
var hd = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r, n;
      this._registeredSpanProcessors = [], this._tracers = /* @__PURE__ */ new Map();
      var i = ca({}, ga(), Kf(t));
      if (this.resource = (r = i.resource) !== null && r !== void 0 ? r : mt.empty(), i.mergeResourceWithDefaults && (this.resource = mt.default().merge(this.resource)), this._config = Object.assign({}, i, {
        resource: this.resource
      }), !((n = t.spanProcessors) === null || n === void 0) && n.length)
        this._registeredSpanProcessors = pd([], dd(t.spanProcessors), !1), this.activeSpanProcessor = new Ui(this._registeredSpanProcessors);
      else {
        var o = this._buildExporterFromEnv();
        if (o !== void 0) {
          var a = new Ta(o);
          this.activeSpanProcessor = a;
        } else
          this.activeSpanProcessor = new fd();
      }
    }
    return e.prototype.getTracer = function(t, r, n) {
      var i = t + "@" + (r || "") + ":" + ((n == null ? void 0 : n.schemaUrl) || "");
      return this._tracers.has(i) || this._tracers.set(i, new td({ name: t, version: r, schemaUrl: n == null ? void 0 : n.schemaUrl }, this._config, this)), this._tracers.get(i);
    }, e.prototype.addSpanProcessor = function(t) {
      this._registeredSpanProcessors.length === 0 && this.activeSpanProcessor.shutdown().catch(function(r) {
        return m.error("Error while trying to shutdown current span processor", r);
      }), this._registeredSpanProcessors.push(t), this.activeSpanProcessor = new Ui(this._registeredSpanProcessors);
    }, e.prototype.getActiveSpanProcessor = function() {
      return this.activeSpanProcessor;
    }, e.prototype.register = function(t) {
      t === void 0 && (t = {}), L.setGlobalTracerProvider(this), t.propagator === void 0 && (t.propagator = this._buildPropagatorFromEnv()), t.contextManager && O.setGlobalContextManager(t.contextManager), t.propagator && z.setGlobalPropagator(t.propagator);
    }, e.prototype.forceFlush = function() {
      var t = this._config.forceFlushTimeoutMillis, r = this._registeredSpanProcessors.map(function(n) {
        return new Promise(function(i) {
          var o, a = setTimeout(function() {
            i(new Error("Span processor did not completed within timeout period of " + t + " ms")), o = we.timeout;
          }, t);
          n.forceFlush().then(function() {
            clearTimeout(a), o !== we.timeout && (o = we.resolved, i(o));
          }).catch(function(u) {
            clearTimeout(a), o = we.error, i(u);
          });
        });
      });
      return new Promise(function(n, i) {
        Promise.all(r).then(function(o) {
          var a = o.filter(function(u) {
            return u !== we.resolved;
          });
          a.length > 0 ? i(a) : n();
        }).catch(function(o) {
          return i([o]);
        });
      });
    }, e.prototype.shutdown = function() {
      return this.activeSpanProcessor.shutdown();
    }, e.prototype._getPropagator = function(t) {
      var r;
      return (r = this.constructor._registeredPropagators.get(t)) === null || r === void 0 ? void 0 : r();
    }, e.prototype._getSpanExporter = function(t) {
      var r;
      return (r = this.constructor._registeredExporters.get(t)) === null || r === void 0 ? void 0 : r();
    }, e.prototype._buildPropagatorFromEnv = function() {
      var t = this, r = Array.from(new Set(Ke().OTEL_PROPAGATORS)), n = r.map(function(o) {
        var a = t._getPropagator(o);
        return a || m.warn('Propagator "' + o + '" requested through environment variable is unavailable.'), a;
      }), i = n.reduce(function(o, a) {
        return a && o.push(a), o;
      }, []);
      if (i.length !== 0)
        return r.length === 1 ? i[0] : new na({
          propagators: i
        });
    }, e.prototype._buildExporterFromEnv = function() {
      var t = Ke().OTEL_TRACES_EXPORTER;
      if (!(t === "none" || t === "")) {
        var r = this._getSpanExporter(t);
        return r || m.error('Exporter "' + t + '" requested through environment variable is unavailable.'), r;
      }
    }, e._registeredPropagators = /* @__PURE__ */ new Map([
      ["tracecontext", function() {
        return new ia();
      }],
      ["baggage", function() {
        return new Yo();
      }]
    ]), e._registeredExporters = /* @__PURE__ */ new Map(), e;
  }()
), _d = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, vd = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Sa = (
  /** @class */
  function() {
    function e() {
      this._enabled = !1, this._currentContext = Se;
    }
    return e.prototype._bindFunction = function(t, r) {
      t === void 0 && (t = Se);
      var n = this, i = function() {
        for (var o = this, a = [], u = 0; u < arguments.length; u++)
          a[u] = arguments[u];
        return n.with(t, function() {
          return r.apply(o, a);
        });
      };
      return Object.defineProperty(i, "length", {
        enumerable: !1,
        configurable: !0,
        writable: !1,
        value: r.length
      }), i;
    }, e.prototype.active = function() {
      return this._currentContext;
    }, e.prototype.bind = function(t, r) {
      return t === void 0 && (t = this.active()), typeof r == "function" ? this._bindFunction(t, r) : r;
    }, e.prototype.disable = function() {
      return this._currentContext = Se, this._enabled = !1, this;
    }, e.prototype.enable = function() {
      return this._enabled ? this : (this._enabled = !0, this._currentContext = Se, this);
    }, e.prototype.with = function(t, r, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      var a = this._currentContext;
      this._currentContext = t || Se;
      try {
        return r.call.apply(r, vd([n], _d(i), !1));
      } finally {
        this._currentContext = a;
      }
    }, e;
  }()
), yd = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), md = (
  /** @class */
  function(e) {
    yd(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, r) || this;
      if (r.contextManager)
        throw "contextManager should be defined in register method not in constructor";
      if (r.propagator)
        throw "propagator should be defined in register method not in constructor";
      return n;
    }
    return t.prototype.register = function(r) {
      r === void 0 && (r = {}), r.contextManager === void 0 && (r.contextManager = new Sa()), r.contextManager && r.contextManager.enable(), e.prototype.register.call(this, r);
    }, t;
  }(hd)
), T;
(function(e) {
  e.CONNECT_END = "connectEnd", e.CONNECT_START = "connectStart", e.DECODED_BODY_SIZE = "decodedBodySize", e.DOM_COMPLETE = "domComplete", e.DOM_CONTENT_LOADED_EVENT_END = "domContentLoadedEventEnd", e.DOM_CONTENT_LOADED_EVENT_START = "domContentLoadedEventStart", e.DOM_INTERACTIVE = "domInteractive", e.DOMAIN_LOOKUP_END = "domainLookupEnd", e.DOMAIN_LOOKUP_START = "domainLookupStart", e.ENCODED_BODY_SIZE = "encodedBodySize", e.FETCH_START = "fetchStart", e.LOAD_EVENT_END = "loadEventEnd", e.LOAD_EVENT_START = "loadEventStart", e.NAVIGATION_START = "navigationStart", e.REDIRECT_END = "redirectEnd", e.REDIRECT_START = "redirectStart", e.REQUEST_START = "requestStart", e.RESPONSE_END = "responseEnd", e.RESPONSE_START = "responseStart", e.SECURE_CONNECTION_START = "secureConnectionStart", e.UNLOAD_EVENT_END = "unloadEventEnd", e.UNLOAD_EVENT_START = "unloadEventStart";
})(T || (T = {}));
var gd = "http.response_content_length", Ed = "http.response_content_length_uncompressed", Td = gd, Sd = Ed, $r;
function bd() {
  return $r || ($r = document.createElement("a")), $r;
}
function me(e, t) {
  return t in e;
}
function D(e, t, r, n) {
  var i = void 0, o = void 0;
  me(r, t) && typeof r[t] == "number" && (i = r[t]);
  var a = T.FETCH_START;
  if (me(r, a) && typeof r[a] == "number" && (o = r[a]), i !== void 0 && o !== void 0 && i >= o)
    return e.addEvent(t, i), e;
}
function Je(e, t, r) {
  r === void 0 && (r = !1), r || (D(e, T.FETCH_START, t), D(e, T.DOMAIN_LOOKUP_START, t), D(e, T.DOMAIN_LOOKUP_END, t), D(e, T.CONNECT_START, t), me(t, "name") && t.name.startsWith("https:") && D(e, T.SECURE_CONNECTION_START, t), D(e, T.CONNECT_END, t), D(e, T.REQUEST_START, t), D(e, T.RESPONSE_START, t), D(e, T.RESPONSE_END, t));
  var n = t[T.ENCODED_BODY_SIZE];
  n !== void 0 && e.setAttribute(Td, n);
  var i = t[T.DECODED_BODY_SIZE];
  i !== void 0 && n !== i && e.setAttribute(Sd, i);
}
function wd(e) {
  return e.slice().sort(function(t, r) {
    var n = t[T.FETCH_START], i = r[T.FETCH_START];
    return n > i ? 1 : n < i ? -1 : 0;
  });
}
function ba() {
  return typeof location != "undefined" ? location.origin : void 0;
}
function wa(e, t, r, n, i, o) {
  i === void 0 && (i = /* @__PURE__ */ new WeakSet());
  var a = ae(e);
  e = a.toString();
  var u = Od(e, t, r, n, i, o);
  if (u.length === 0)
    return {
      mainRequest: void 0
    };
  if (u.length === 1)
    return {
      mainRequest: u[0]
    };
  var c = wd(u);
  if (a.origin !== ba() && c.length > 1) {
    var s = c[0], l = Ad(c, s[T.RESPONSE_END], r), f = s[T.RESPONSE_END], d = l[T.FETCH_START];
    return d < f && (l = s, s = void 0), {
      corsPreFlightRequest: s,
      mainRequest: l
    };
  } else
    return {
      mainRequest: u[0]
    };
}
function Ad(e, t, r) {
  for (var n = se(r), i = se(dt(t)), o = e[1], a, u = e.length, c = 1; c < u; c++) {
    var s = e[c], l = se(dt(s[T.FETCH_START])), f = se(dt(s[T.RESPONSE_END])), d = n - f;
    l >= i && (!a || d < a) && (a = d, o = s);
  }
  return o;
}
function Od(e, t, r, n, i, o) {
  var a = se(t), u = se(r), c = n.filter(function(s) {
    var l = se(dt(s[T.FETCH_START])), f = se(dt(s[T.RESPONSE_END]));
    return s.initiatorType.toLowerCase() === (o || "xmlhttprequest") && s.name === e && l >= a && f <= u;
  });
  return c.length > 0 && (c = c.filter(function(s) {
    return !i.has(s);
  })), c;
}
function ae(e) {
  if (typeof URL == "function")
    return new URL(e, typeof document != "undefined" ? document.baseURI : typeof location != "undefined" ? location.href : void 0);
  var t = bd();
  return t.href = e, t;
}
function Aa(e, t) {
  if (e.nodeType === Node.DOCUMENT_NODE)
    return "/";
  var r = Ld(e, t);
  if (t && r.indexOf("@id") > 0)
    return r;
  var n = "";
  return e.parentNode && (n += Aa(e.parentNode, !1)), n += r, n;
}
function Rd(e) {
  if (!e.parentNode)
    return 0;
  var t = [e.nodeType];
  e.nodeType === Node.CDATA_SECTION_NODE && t.push(Node.TEXT_NODE);
  var r = Array.from(e.parentNode.childNodes);
  return r = r.filter(function(n) {
    var i = n.localName;
    return t.indexOf(n.nodeType) >= 0 && i === e.localName;
  }), r.length >= 1 ? r.indexOf(e) + 1 : 0;
}
function Ld(e, t) {
  var r = e.nodeType, n = Rd(e), i = "";
  if (r === Node.ELEMENT_NODE) {
    var o = e.getAttribute("id");
    if (t && o)
      return '//*[@id="' + o + '"]';
    i = e.localName;
  } else if (r === Node.TEXT_NODE || r === Node.CDATA_SECTION_NODE)
    i = "text()";
  else if (r === Node.COMMENT_NODE)
    i = "comment()";
  else
    return "";
  return i && n > 1 ? "/" + i + "[" + n + "]" : "/" + i;
}
function Oa(e, t) {
  var r = t || [];
  (typeof r == "string" || r instanceof RegExp) && (r = [r]);
  var n = ae(e);
  return n.origin === ba() ? !0 : r.some(function(i) {
    return da(e, i);
  });
}
var pt;
(function(e) {
  e.DOCUMENT_LOAD = "documentLoad", e.DOCUMENT_FETCH = "documentFetch", e.RESOURCE_FETCH = "resourceFetch";
})(pt || (pt = {}));
var Pd = "0.44.0", Nd = "@opentelemetry/instrumentation-document-load";
const Cd = "http.url", Md = "http.user_agent", qe = Cd, Id = Md;
var ir;
(function(e) {
  e.FIRST_PAINT = "firstPaint", e.FIRST_CONTENTFUL_PAINT = "firstContentfulPaint";
})(ir || (ir = {}));
var xd = function() {
  var e, t, r = {}, n = (t = (e = q).getEntriesByType) === null || t === void 0 ? void 0 : t.call(e, "navigation")[0];
  if (n) {
    var i = Object.values(T);
    i.forEach(function(u) {
      if (me(n, u)) {
        var c = n[u];
        typeof c == "number" && (r[u] = c);
      }
    });
  } else {
    var o = q, a = o.timing;
    if (a) {
      var i = Object.values(T);
      i.forEach(function(c) {
        if (me(a, c)) {
          var s = a[c];
          typeof s == "number" && (r[c] = s);
        }
      });
    }
  }
  return r;
}, ki = {
  "first-paint": ir.FIRST_PAINT,
  "first-contentful-paint": ir.FIRST_CONTENTFUL_PAINT
}, Dd = function(e) {
  var t, r, n = (r = (t = q).getEntriesByType) === null || r === void 0 ? void 0 : r.call(t, "paint");
  n && n.forEach(function(i) {
    var o = i.name, a = i.startTime;
    me(ki, o) && e.addEvent(ki[o], a);
  });
}, Ud = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), kd = (
  /** @class */
  function(e) {
    Ud(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, Nd, Pd, r) || this;
      return n.component = "document-load", n.version = "1", n.moduleName = n.component, n;
    }
    return t.prototype.init = function() {
    }, t.prototype._onDocumentLoaded = function() {
      var r = this;
      window.setTimeout(function() {
        r._collectPerformance();
      });
    }, t.prototype._addResourcesSpans = function(r) {
      var n = this, i, o, a = (o = (i = q).getEntriesByType) === null || o === void 0 ? void 0 : o.call(i, "resource");
      a && a.forEach(function(u) {
        n._initResourceSpan(u, r);
      });
    }, t.prototype._collectPerformance = function() {
      var r = this, n = Array.from(document.getElementsByTagName("meta")).find(function(a) {
        return a.getAttribute("name") === Kt;
      }), i = xd(), o = n && n.content || "";
      O.with(z.extract(Se, { traceparent: o }), function() {
        var a, u = r._startSpan(pt.DOCUMENT_LOAD, T.FETCH_START, i);
        u && (O.with(L.setSpan(O.active(), u), function() {
          var c = r._startSpan(pt.DOCUMENT_FETCH, T.FETCH_START, i);
          c && (c.setAttribute(qe, location.href), O.with(L.setSpan(O.active(), c), function() {
            var s;
            r.getConfig().ignoreNetworkEvents || Je(c, i), r._addCustomAttributesOnSpan(c, (s = r.getConfig().applyCustomAttributesOnSpan) === null || s === void 0 ? void 0 : s.documentFetch), r._endSpan(c, T.RESPONSE_END, i);
          }));
        }), u.setAttribute(qe, location.href), u.setAttribute(Id, navigator.userAgent), r._addResourcesSpans(u), r.getConfig().ignoreNetworkEvents || (D(u, T.FETCH_START, i), D(u, T.UNLOAD_EVENT_START, i), D(u, T.UNLOAD_EVENT_END, i), D(u, T.DOM_INTERACTIVE, i), D(u, T.DOM_CONTENT_LOADED_EVENT_START, i), D(u, T.DOM_CONTENT_LOADED_EVENT_END, i), D(u, T.DOM_COMPLETE, i), D(u, T.LOAD_EVENT_START, i), D(u, T.LOAD_EVENT_END, i)), r.getConfig().ignorePerformancePaintEvents || Dd(u), r._addCustomAttributesOnSpan(u, (a = r.getConfig().applyCustomAttributesOnSpan) === null || a === void 0 ? void 0 : a.documentLoad), r._endSpan(u, T.LOAD_EVENT_END, i));
      });
    }, t.prototype._endSpan = function(r, n, i) {
      r && (me(i, n) ? r.end(i[n]) : r.end());
    }, t.prototype._initResourceSpan = function(r, n) {
      var i, o = this._startSpan(pt.RESOURCE_FETCH, T.FETCH_START, r, n);
      o && (o.setAttribute(qe, r.name), this.getConfig().ignoreNetworkEvents || Je(o, r), this._addCustomAttributesOnResourceSpan(o, r, (i = this.getConfig().applyCustomAttributesOnSpan) === null || i === void 0 ? void 0 : i.resourceFetch), this._endSpan(o, T.RESPONSE_END, r));
    }, t.prototype._startSpan = function(r, n, i, o) {
      if (me(i, n) && typeof i[n] == "number") {
        var a = this.tracer.startSpan(r, {
          startTime: i[n]
        }, o ? L.setSpan(O.active(), o) : void 0);
        return a;
      }
    }, t.prototype._waitForPageLoad = function() {
      window.document.readyState === "complete" ? this._onDocumentLoaded() : (this._onDocumentLoaded = this._onDocumentLoaded.bind(this), window.addEventListener("load", this._onDocumentLoaded));
    }, t.prototype._addCustomAttributesOnSpan = function(r, n) {
      var i = this;
      n && rr(function() {
        return n(r);
      }, function(o) {
        o && i._diag.error("addCustomAttributesOnSpan", o);
      });
    }, t.prototype._addCustomAttributesOnResourceSpan = function(r, n, i) {
      var o = this;
      i && rr(function() {
        return i(r, n);
      }, function(a) {
        a && o._diag.error("addCustomAttributesOnResourceSpan", a);
      });
    }, t.prototype.enable = function() {
      window.removeEventListener("load", this._onDocumentLoaded), this._waitForPageLoad();
    }, t.prototype.disable = function() {
      window.removeEventListener("load", this._onDocumentLoaded);
    }, t;
  }(Ot)
), or;
(function(e) {
  e.COMPONENT = "component", e.HTTP_ERROR_NAME = "http.error_name", e.HTTP_STATUS_TEXT = "http.status_text";
})(or || (or = {}));
var Bd = "http.method", Hd = "http.url", Gd = "http.host", Fd = "http.scheme", jd = "http.status_code", Vd = "http.user_agent", $d = "http.request_content_length_uncompressed", zd = Bd, Xd = Hd, qd = Gd, Wd = Fd, Kd = jd, Yd = Vd, Jd = $d, Zd = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Qd = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, ep = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, tp = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ra = m.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-fetch/utils"
});
function rp() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  if (e[0] instanceof URL || typeof e[0] == "string") {
    var r = e[1];
    if (!(r != null && r.body))
      return Promise.resolve();
    if (r.body instanceof ReadableStream) {
      var n = np(r.body), i = n.body, o = n.length;
      return r.body = i, o;
    } else
      return Promise.resolve(ip(r.body));
  } else {
    var a = e[0];
    return a != null && a.body ? a.clone().text().then(function(u) {
      return yn(u);
    }) : Promise.resolve();
  }
}
function np(e) {
  if (!e.pipeThrough)
    return Ra.warn("Platform has ReadableStream but not pipeThrough!"), {
      body: e,
      length: Promise.resolve(void 0)
    };
  var t = 0, r, n = new Promise(function(o) {
    r = o;
  }), i = new TransformStream({
    start: function() {
    },
    transform: function(o, a) {
      return Zd(this, void 0, void 0, function() {
        var u;
        return Qd(this, function(c) {
          switch (c.label) {
            case 0:
              return [4, o];
            case 1:
              return u = c.sent(), t += u.byteLength, a.enqueue(o), [
                2
                /*return*/
              ];
          }
        });
      });
    },
    flush: function() {
      r(t);
    }
  });
  return {
    body: e.pipeThrough(i),
    length: n
  };
}
function ip(e) {
  if (typeof Document != "undefined" && e instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (e instanceof Blob)
    return e.size;
  if (e.byteLength !== void 0)
    return e.byteLength;
  if (e instanceof FormData)
    return ap(e);
  if (e instanceof URLSearchParams)
    return yn(e.toString());
  if (typeof e == "string")
    return yn(e);
  Ra.warn("unknown body type");
}
var op = new TextEncoder();
function yn(e) {
  return op.encode(e).byteLength;
}
function ap(e) {
  var t, r, n = 0;
  try {
    for (var i = ep(e.entries()), o = i.next(); !o.done; o = i.next()) {
      var a = tp(o.value, 2), u = a[0], c = a[1];
      n += u.length, c instanceof Blob ? n += c.size : n += c.length;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
var Bi = "0.57.2", sp = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), up = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, cp = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, zr, lp = 300, Hi = typeof process == "object" && ((zr = process.release) === null || zr === void 0 ? void 0 : zr.name) === "node", fp = (
  /** @class */
  function(e) {
    sp(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, "@opentelemetry/instrumentation-fetch", Bi, r) || this;
      return n.component = "fetch", n.version = Bi, n.moduleName = n.component, n._usedResources = /* @__PURE__ */ new WeakSet(), n._tasksCount = 0, n;
    }
    return t.prototype.init = function() {
    }, t.prototype._addChildSpan = function(r, n) {
      var i = this.tracer.startSpan("CORS Preflight", {
        startTime: n[T.FETCH_START]
      }, L.setSpan(O.active(), r));
      Je(i, n, this.getConfig().ignoreNetworkEvents), i.end(n[T.RESPONSE_END]);
    }, t.prototype._addFinalSpanAttributes = function(r, n) {
      var i = ae(n.url);
      r.setAttribute(Kd, n.status), n.statusText != null && r.setAttribute(or.HTTP_STATUS_TEXT, n.statusText), r.setAttribute(qd, i.host), r.setAttribute(Wd, i.protocol.replace(":", "")), typeof navigator != "undefined" && r.setAttribute(Yd, navigator.userAgent);
    }, t.prototype._addHeaders = function(r, n) {
      if (!Oa(n, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var i = {};
        z.inject(O.active(), i), Object.keys(i).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      if (r instanceof Request)
        z.inject(O.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else if (r.headers instanceof Headers)
        z.inject(O.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else if (r.headers instanceof Map)
        z.inject(O.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else {
        var i = {};
        z.inject(O.active(), i), r.headers = Object.assign({}, i, r.headers || {});
      }
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (performance.clearResourceTimings(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._createSpan = function(r, n) {
      var i;
      if (n === void 0 && (n = {}), pa(r, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var o = (n.method || "GET").toUpperCase(), a = "HTTP " + o;
      return this.tracer.startSpan(a, {
        kind: yt.CLIENT,
        attributes: (i = {}, i[or.COMPONENT] = this.moduleName, i[zd] = o, i[Xd] = r, i)
      });
    }, t.prototype._findResourceAndAddNetworkEvents = function(r, n, i) {
      var o = n.entries;
      if (!o.length) {
        if (!performance.getEntriesByType)
          return;
        o = performance.getEntriesByType("resource");
      }
      var a = wa(n.spanUrl, n.startTime, i, o, this._usedResources, "fetch");
      if (a.mainRequest) {
        var u = a.mainRequest;
        this._markResourceAsUsed(u);
        var c = a.corsPreFlightRequest;
        c && (this._addChildSpan(r, c), this._markResourceAsUsed(c)), Je(r, u, this.getConfig().ignoreNetworkEvents);
      }
    }, t.prototype._markResourceAsUsed = function(r) {
      this._usedResources.add(r);
    }, t.prototype._endSpan = function(r, n, i) {
      var o = this, a = X(Date.now()), u = Ce();
      this._addFinalSpanAttributes(r, i), setTimeout(function() {
        var c;
        (c = n.observer) === null || c === void 0 || c.disconnect(), o._findResourceAndAddNetworkEvents(r, n, u), o._tasksCount--, o._clearResources(), r.end(a);
      }, lp);
    }, t.prototype._patchConstructor = function() {
      var r = this;
      return function(n) {
        var i = r;
        return function() {
          for (var a = [], u = 0; u < arguments.length; u++)
            a[u] = arguments[u];
          var c = this, s = ae(a[0] instanceof Request ? a[0].url : String(a[0])).href, l = a[0] instanceof Request ? a[0] : a[1] || {}, f = i._createSpan(s, l);
          if (!f)
            return n.apply(this, a);
          var d = i._prepareSpanData(s);
          i.getConfig().measureRequestSize && rp.apply(void 0, cp([], up(a), !1)).then(function(y) {
            y && f.setAttribute(Jd, y);
          }).catch(function(y) {
            i._diag.warn("getFetchBodyLength", y);
          });
          function h(y, g) {
            i._applyAttributesAfterFetch(y, l, g), i._endSpan(y, d, {
              status: g.status || 0,
              statusText: g.message,
              url: s
            });
          }
          function _(y, g) {
            i._applyAttributesAfterFetch(y, l, g), g.status >= 200 && g.status < 400 ? i._endSpan(y, d, g) : i._endSpan(y, d, {
              status: g.status,
              statusText: g.statusText,
              url: s
            });
          }
          function p(y, g, w) {
            try {
              var A = w.clone(), R = w.clone(), P = A.body;
              if (P) {
                var G = P.getReader(), C = function() {
                  G.read().then(function(F) {
                    var ne = F.done;
                    ne ? _(y, R) : C();
                  }, function(F) {
                    h(y, F);
                  });
                };
                C();
              } else
                _(y, w);
            } finally {
              g(w);
            }
          }
          function v(y, g, w) {
            try {
              h(y, w);
            } finally {
              g(w);
            }
          }
          return new Promise(function(y, g) {
            return O.with(L.setSpan(O.active(), f), function() {
              return i._addHeaders(l, s), i._tasksCount++, n.apply(c, l instanceof Request ? [l] : [s, l]).then(p.bind(c, f, y), v.bind(c, f, g));
            });
          });
        };
      };
    }, t.prototype._applyAttributesAfterFetch = function(r, n, i) {
      var o = this, a = this.getConfig().applyCustomAttributesOnSpan;
      a && rr(function() {
        return a(r, n, i);
      }, function(u) {
        u && o._diag.error("applyCustomAttributesOnSpan", u);
      });
    }, t.prototype._prepareSpanData = function(r) {
      var n = Ce(), i = [];
      if (typeof PerformanceObserver != "function")
        return { entries: i, startTime: n, spanUrl: r };
      var o = new PerformanceObserver(function(a) {
        var u = a.getEntries();
        u.forEach(function(c) {
          c.initiatorType === "fetch" && c.name === r && i.push(c);
        });
      });
      return o.observe({
        entryTypes: ["resource"]
      }), { entries: i, observer: o, startTime: n, spanUrl: r };
    }, t.prototype.enable = function() {
      if (Hi) {
        this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
        return;
      }
      x(fetch) && (this._unwrap(ft, "fetch"), this._diag.debug("removing previous patch for constructor")), this._wrap(ft, "fetch", this._patchConstructor());
    }, t.prototype.disable = function() {
      Hi || (this._unwrap(ft, "fetch"), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t;
  }(Ot)
), dp = "http.method", pp = "http.url", hp = "http.host", _p = "http.scheme", vp = "http.status_code", yp = "http.user_agent", mp = "http.request_content_length_uncompressed", gp = dp, Ep = pp, Tp = hp, Sp = _p, bp = vp, wp = yp, Ap = mp, oe;
(function(e) {
  e.METHOD_OPEN = "open", e.METHOD_SEND = "send", e.EVENT_ABORT = "abort", e.EVENT_ERROR = "error", e.EVENT_LOAD = "loaded", e.EVENT_TIMEOUT = "timeout";
})(oe || (oe = {}));
var Op = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Rp = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Lp = m.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-xml-http-request/utils"
});
function Pp(e) {
  if (typeof Document != "undefined" && e instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (e instanceof Blob)
    return e.size;
  if (e.byteLength !== void 0)
    return e.byteLength;
  if (e instanceof FormData)
    return Cp(e);
  if (e instanceof URLSearchParams)
    return Gi(e.toString());
  if (typeof e == "string")
    return Gi(e);
  Lp.warn("unknown body type");
}
var Np = new TextEncoder();
function Gi(e) {
  return Np.encode(e).byteLength;
}
function Cp(e) {
  var t, r, n = 0;
  try {
    for (var i = Op(e.entries()), o = i.next(); !o.done; o = i.next()) {
      var a = Rp(o.value, 2), u = a[0], c = a[1];
      n += u.length, c instanceof Blob ? n += c.size : n += c.length;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
var Fi = "0.57.2", mn;
(function(e) {
  e.HTTP_STATUS_TEXT = "http.status_text";
})(mn || (mn = {}));
var Mp = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Ip = 300, xp = (
  /** @class */
  function(e) {
    Mp(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, "@opentelemetry/instrumentation-xml-http-request", Fi, r) || this;
      return n.component = "xml-http-request", n.version = Fi, n.moduleName = n.component, n._tasksCount = 0, n._xhrMem = /* @__PURE__ */ new WeakMap(), n._usedResources = /* @__PURE__ */ new WeakSet(), n;
    }
    return t.prototype.init = function() {
    }, t.prototype._addHeaders = function(r, n) {
      var i = ae(n).href;
      if (!Oa(i, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var o = {};
        z.inject(O.active(), o), Object.keys(o).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      var a = {};
      z.inject(O.active(), a), Object.keys(a).forEach(function(u) {
        r.setRequestHeader(u, String(a[u]));
      });
    }, t.prototype._addChildSpan = function(r, n) {
      var i = this;
      O.with(L.setSpan(O.active(), r), function() {
        var o = i.tracer.startSpan("CORS Preflight", {
          startTime: n[T.FETCH_START]
        });
        Je(o, n, i.getConfig().ignoreNetworkEvents), o.end(n[T.RESPONSE_END]);
      });
    }, t.prototype._addFinalSpanAttributes = function(r, n, i) {
      if (typeof i == "string") {
        var o = ae(i);
        n.status !== void 0 && r.setAttribute(bp, n.status), n.statusText !== void 0 && r.setAttribute(mn.HTTP_STATUS_TEXT, n.statusText), r.setAttribute(Tp, o.host), r.setAttribute(Sp, o.protocol.replace(":", "")), r.setAttribute(wp, navigator.userAgent);
      }
    }, t.prototype._applyAttributesAfterXHR = function(r, n) {
      var i = this, o = this.getConfig().applyCustomAttributesOnSpan;
      typeof o == "function" && rr(function() {
        return o(r, n);
      }, function(a) {
        a && i._diag.error("applyCustomAttributesOnSpan", a);
      });
    }, t.prototype._addResourceObserver = function(r, n) {
      var i = this._xhrMem.get(r);
      !i || typeof PerformanceObserver != "function" || typeof PerformanceResourceTiming != "function" || (i.createdResources = {
        observer: new PerformanceObserver(function(o) {
          var a = o.getEntries(), u = ae(n);
          a.forEach(function(c) {
            c.initiatorType === "xmlhttprequest" && c.name === u.href && i.createdResources && i.createdResources.entries.push(c);
          });
        }),
        entries: []
      }, i.createdResources.observer.observe({
        entryTypes: ["resource"]
      }));
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (q.clearResourceTimings(), this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._findResourceAndAddNetworkEvents = function(r, n, i, o, a) {
      if (!(!i || !o || !a || !r.createdResources)) {
        var u = r.createdResources.entries;
        (!u || !u.length) && (u = q.getEntriesByType("resource"));
        var c = wa(ae(i).href, o, a, u, this._usedResources);
        if (c.mainRequest) {
          var s = c.mainRequest;
          this._markResourceAsUsed(s);
          var l = c.corsPreFlightRequest;
          l && (this._addChildSpan(n, l), this._markResourceAsUsed(l)), Je(n, s, this.getConfig().ignoreNetworkEvents);
        }
      }
    }, t.prototype._cleanPreviousSpanInformation = function(r) {
      var n = this._xhrMem.get(r);
      if (n) {
        var i = n.callbackToRemoveEvents;
        i && i(), this._xhrMem.delete(r);
      }
    }, t.prototype._createSpan = function(r, n, i) {
      var o;
      if (pa(n, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var a = i.toUpperCase(), u = this.tracer.startSpan(a, {
        kind: yt.CLIENT,
        attributes: (o = {}, o[gp] = i, o[Ep] = ae(n).toString(), o)
      });
      return u.addEvent(oe.METHOD_OPEN), this._cleanPreviousSpanInformation(r), this._xhrMem.set(r, {
        span: u,
        spanUrl: n
      }), u;
    }, t.prototype._markResourceAsUsed = function(r) {
      this._usedResources.add(r);
    }, t.prototype._patchOpen = function() {
      var r = this;
      return function(n) {
        var i = r;
        return function() {
          for (var a = [], u = 0; u < arguments.length; u++)
            a[u] = arguments[u];
          var c = a[0], s = a[1];
          return i._createSpan(this, s, c), n.apply(this, a);
        };
      };
    }, t.prototype._patchSend = function() {
      var r = this;
      function n(l, f, d, h) {
        var _ = f.callbackToRemoveEvents;
        typeof _ == "function" && _();
        var p = f.span, v = f.spanUrl, y = f.sendStartTime;
        p && (r._findResourceAndAddNetworkEvents(f, p, v, y, d), p.addEvent(l, h), r._addFinalSpanAttributes(p, f, v), p.end(h), r._tasksCount--), r._clearResources();
      }
      function i(l, f) {
        var d = r._xhrMem.get(f);
        if (d) {
          d.status = f.status, d.statusText = f.statusText, r._xhrMem.delete(f), d.span && r._applyAttributesAfterXHR(d.span, f);
          var h = Ce(), _ = Date.now();
          setTimeout(function() {
            n(l, d, h, _);
          }, Ip);
        }
      }
      function o() {
        i(oe.EVENT_ERROR, this);
      }
      function a() {
        i(oe.EVENT_ABORT, this);
      }
      function u() {
        i(oe.EVENT_TIMEOUT, this);
      }
      function c() {
        this.status < 299 ? i(oe.EVENT_LOAD, this) : i(oe.EVENT_ERROR, this);
      }
      function s(l) {
        l.removeEventListener("abort", a), l.removeEventListener("error", o), l.removeEventListener("load", c), l.removeEventListener("timeout", u);
        var f = r._xhrMem.get(l);
        f && (f.callbackToRemoveEvents = void 0);
      }
      return function(l) {
        return function() {
          for (var d = this, h = [], _ = 0; _ < arguments.length; _++)
            h[_] = arguments[_];
          var p = r._xhrMem.get(this);
          if (!p)
            return l.apply(this, h);
          var v = p.span, y = p.spanUrl;
          if (v && y) {
            if (r.getConfig().measureRequestSize && (h != null && h[0])) {
              var g = h[0], w = Pp(g);
              w !== void 0 && v.setAttribute(Ap, w);
            }
            O.with(L.setSpan(O.active(), v), function() {
              r._tasksCount++, p.sendStartTime = Ce(), v.addEvent(oe.METHOD_SEND), d.addEventListener("abort", a), d.addEventListener("error", o), d.addEventListener("load", c), d.addEventListener("timeout", u), p.callbackToRemoveEvents = function() {
                s(d), p.createdResources && p.createdResources.observer.disconnect();
              }, r._addHeaders(d, y), r._addResourceObserver(d, y);
            });
          }
          return l.apply(this, h);
        };
      };
    }, t.prototype.enable = function() {
      this._diag.debug("applying patch to", this.moduleName, this.version), x(XMLHttpRequest.prototype.open) && (this._unwrap(XMLHttpRequest.prototype, "open"), this._diag.debug("removing previous patch from method open")), x(XMLHttpRequest.prototype.send) && (this._unwrap(XMLHttpRequest.prototype, "send"), this._diag.debug("removing previous patch from method send")), this._wrap(XMLHttpRequest.prototype, "open", this._patchOpen()), this._wrap(XMLHttpRequest.prototype, "send", this._patchSend());
    }, t.prototype.disable = function() {
      this._diag.debug("removing patch from", this.moduleName, this.version), this._unwrap(XMLHttpRequest.prototype, "open"), this._unwrap(XMLHttpRequest.prototype, "send"), this._tasksCount = 0, this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet();
    }, t;
  }(Ot)
);
const Xr = /\b(query|mutation|subscription)\b\s*([A-Za-z_]\w*)?/g;
function Dp(e) {
  var s;
  const t = kp(e);
  if (t === null || typeof t != "object")
    return null;
  const r = Array.isArray(t) ? t[0] : t;
  if (!r || typeof r != "object")
    return null;
  const n = r, i = typeof n.query == "string" ? n.query : void 0, o = typeof n.operationName == "string" ? n.operationName : void 0;
  if (i === void 0 && o === void 0)
    return null;
  const a = i ? Up(i, o) : null, u = (s = a == null ? void 0 : a[1]) != null ? s : Bp(i), c = o != null ? o : a == null ? void 0 : a[2];
  return c === void 0 && u === void 0 ? null : { name: c, type: u };
}
function Up(e, t) {
  Xr.lastIndex = 0;
  let r = null;
  for (let n = Xr.exec(e); n !== null; n = Xr.exec(e)) {
    if (t === void 0 || n[2] === t)
      return n;
    r === null && (r = n);
  }
  return r;
}
function kp(e) {
  if (e == null)
    return null;
  if (typeof e == "object")
    return e;
  if (typeof e != "string")
    return null;
  try {
    return JSON.parse(e);
  } catch (t) {
    return null;
  }
}
function Bp(e) {
  if (e !== void 0 && /^\s*\{/.test(e))
    return "query";
}
const Hp = 0, ji = 2e3;
class Gp {
  /**
   * @param windowMillis The dedupe window in milliseconds. A value of `0` (or
   * negative) disables deduplication, so every exposure is recorded.
   * @param maxSize The maximum number of exposure keys to track. When exceeded,
   * the least recently recorded keys are evicted. A value of `0` (or negative)
   * falls back to the default.
   */
  constructor(t = Hp, r = ji) {
    this.lastRecordedAt = /* @__PURE__ */ new Map(), this.windowMillis = t, this.maxSize = r > 0 ? r : ji;
  }
  /**
   * Returns `true` if an exposure for the given key should be recorded (i.e. no
   * exposure for the same key was recorded within the window). Returns `false`
   * if it should be suppressed.
   *
   * This is a pure query and does NOT update the window. Call
   * {@link markRecorded} only after the exposure has actually been emitted, so
   * that a failure to emit doesn't suppress subsequent exposures.
   *
   * @param key A stable key identifying the exposure (e.g. flag key, value,
   * variation, reason, and context).
   * @param now The current time in milliseconds. Defaults to `Date.now()`.
   */
  shouldRecord(t, r = Date.now()) {
    if (this.windowMillis <= 0)
      return !0;
    const n = this.lastRecordedAt.get(t);
    return n === void 0 || n <= r - this.windowMillis;
  }
  /**
   * Marks an exposure for the given key as recorded at `now`, starting a new
   * dedupe window. Call this only after the exposure has been successfully
   * emitted.
   *
   * @param key A stable key identifying the exposure.
   * @param now The current time in milliseconds. Defaults to `Date.now()`.
   */
  markRecorded(t, r = Date.now()) {
    if (!(this.windowMillis <= 0))
      for (this.lastRecordedAt.delete(t), this.lastRecordedAt.set(t, r); this.lastRecordedAt.size > this.maxSize; ) {
        const n = this.lastRecordedAt.keys().next().value;
        if (n === void 0)
          break;
        this.lastRecordedAt.delete(n);
      }
  }
  /**
   * Clears all recorded exposures. Call when the evaluation context changes
   * (e.g. after `identify`).
   */
  reset() {
    this.lastRecordedAt.clear();
  }
}
const Vi = (e, t, r) => {
  const n = vr(
    t,
    e.headers,
    r
  );
  return I(E({}, e), {
    headers: n
  });
}, vr = (e, t, r) => {
  var i, o;
  const n = E({}, t);
  return r ? ((i = Object.keys(n)) == null || i.forEach((a) => {
    [...r].includes(a == null ? void 0 : a.toLowerCase()) || (n[a] = "[REDACTED]");
  }), n) : ((o = Object.keys(n)) == null || o.forEach((a) => {
    [...Fp, ...e].includes(
      a == null ? void 0 : a.toLowerCase()
    ) && (n[a] = "[REDACTED]");
  }), n);
}, Fp = [
  "authorization",
  "cookie",
  "proxy-authorization",
  "set-cookie",
  "token"
], jp = [
  "https://www.googleapis.com/identitytoolkit",
  "https://securetoken.googleapis.com",
  // Intake endpoints of other telemetry vendors. Their batched payloads are
  // large, frequent and never interesting as spans; on one POS deployment
  // they were 20% of all request spans and gigabytes of captured bodies.
  "browser-intake-datadoghq.com",
  "browser-intake-datadoghq.eu",
  "browser-intake-us3-datadoghq.com",
  "browser-intake-us5-datadoghq.com",
  "browser-intake-ap1-datadoghq.com",
  "browser-intake-ddog-gov.com",
  "r.lr-ingest.io",
  "r.lr-in-prod.com",
  "r.logrocket.io",
  "data.pendo.io",
  "ingest.sentry.io",
  "ingest.us.sentry.io",
  "ingest.de.sentry.io",
  "bam.nr-data.net",
  "bam-cell.nr-data.net",
  "rs.fullstory.com",
  "in.hotjar.com",
  "api2.amplitude.com",
  "api.mixpanel.com",
  "api.segment.io/v1",
  "google-analytics.com/g/collect",
  "analytics.google.com/g/collect"
], Vp = [
  "awsaccesskeyid",
  "signature",
  "sig",
  "x-goog-signature",
  "access_token",
  "id_token",
  "token",
  "code",
  "refresh_token",
  "session_state"
], $p = [
  "access_token",
  "id_token",
  "token",
  "code",
  "refresh_token",
  "session_state"
], La = (e) => {
  var t, r;
  try {
    return new URL(e);
  } catch (n) {
    return new URL(e, (r = (t = globalThis.location) == null ? void 0 : t.origin) != null ? r : "http://example.com");
  }
}, zp = (e) => {
  if (!e || e === "#") return "";
  const t = e.slice(1);
  if (!t.includes("=")) return e;
  const r = t.indexOf("?"), n = r >= 0 ? t.slice(r + 1) : t, i = new URLSearchParams(n);
  for (const o of i.keys())
    if ($p.includes(o.toLowerCase()))
      return "";
  return e;
}, gn = (e) => {
  try {
    const t = La(e);
    (t.username || t.password) && (t.username = "REDACTED", t.password = "REDACTED");
    const r = t.searchParams;
    Vp.forEach((i) => {
      for (const o of Array.from(r.keys()))
        o.toLowerCase() === i && r.set(o, "REDACTED");
    });
    const n = zp(t.hash);
    if (t.hash = n, !e.includes("://") && !e.startsWith("//"))
      return t.pathname + t.search + n;
    if (e.startsWith("//")) {
      let i = "//";
      return (t.username || t.password) && (i += t.username + ":" + t.password + "@"), i += t.host + t.pathname + t.search + n, i;
    }
    return t.toString();
  } catch (t) {
    return e;
  }
}, Xp = new RegExp("sdk\\/evalx\\/[^/]+\\/contexts\\/(?<context>[^/?]*)\\??.*?"), qp = new RegExp("\\/eval\\/[^/]+\\/(?<context>[^/?]*)\\??.*?");
function Wp(e) {
  return !!(e.includes("/sdk/evalx") && e.match(Xp) || e.includes("/eval/") && e.match(qp));
}
const Pa = "X-Highlight-Request", $i = (e) => {
  let t = e;
  return !e.startsWith("https://") && !e.startsWith("http://") && (t = `${window.location.origin}${t}`), t.replace(/\/+$/, "");
}, Kp = (e, {
  headersToRedact: t,
  headersToRecord: r,
  requestResponseSanitizer: n
}) => {
  var c, s;
  let i = e;
  if (n) {
    let f = !0;
    try {
      i.request.body = JSON.parse(i.request.body);
    } catch (h) {
      f = !1;
    }
    let d = !0;
    try {
      i.response.body = JSON.parse(
        i.response.body
      );
    } catch (h) {
      d = !1;
    }
    try {
      i = n(i);
    } catch (h) {
    } finally {
      f = f && !!((c = i == null ? void 0 : i.request) != null && c.body), d = d && !!((s = i == null ? void 0 : i.response) != null && s.body), f && (i.request.body = JSON.stringify(
        i.request.body
      )), d && (i.response.body = JSON.stringify(
        i.response.body
      ));
    }
    if (!i)
      return null;
  }
  const l = i, { request: o, response: a } = l, u = br(l, ["request", "response"]);
  return E({
    request: Vi(o, t, r),
    response: Vi(a, t, r)
  }, u);
}, Bm = (e, t, r, n) => {
  e.sort((c, s) => c.responseEnd - s.responseEnd);
  const i = {
    xmlhttprequest: {},
    others: {},
    fetch: {}
  }, o = e.reduce((c, s) => {
    const l = $i(s.name);
    return s.initiatorType === r ? c[r][l] = [
      ...c[r][l] || [],
      s
    ] : c.others[l] = [
      ...c.others[l] || [],
      s
    ], c;
  }, i);
  let a = {};
  a = t.reduce(
    (c, s) => {
      const l = $i(s.request.url);
      return c[l] = [...c[l] || [], s], c;
    },
    a
  );
  for (let c in o[r]) {
    const s = o[r][c], l = a[c];
    if (!l)
      continue;
    const f = Math.max(
      s.length - l.length,
      0
    );
    for (let d = f; d < s.length; d++)
      s[d] && (s[d].requestResponsePair = l[d - f]);
  }
  let u = [];
  for (let c in o)
    for (let s in o[c])
      u = u.concat(o[c][s]);
  return u.sort((c, s) => c.fetchStart - s.fetchStart).reduce(
    (c, s) => {
      let l = s.requestResponsePair;
      return l && (l = Kp(
        s.requestResponsePair,
        n
      ), !l) || (s.toJSON = function() {
        const f = window.performance.timeOrigin;
        return {
          initiatorType: this.initiatorType,
          startTimeAbs: f + this.startTime,
          connectStartAbs: f + this.connectStart,
          connectEndAbs: f + this.connectEnd,
          domainLookupStartAbs: f + this.domainLookupStart,
          domainLookupEndAbs: f + this.domainLookupEnd,
          fetchStartAbs: f + this.fetchStart,
          redirectStartAbs: f + this.redirectStart,
          redirectEndAbs: f + this.redirectEnd,
          requestStartAbs: f + this.requestStart,
          responseStartAbs: f + this.responseStart,
          responseEndAbs: f + this.responseEnd,
          secureConnectionStartAbs: f + this.secureConnectionStart,
          workerStartAbs: f + this.workerStart,
          name: this.name,
          transferSize: this.transferSize,
          encodedBodySize: this.encodedBodySize,
          decodedBodySize: this.decodedBodySize,
          nextHopProtocol: this.nextHopProtocol,
          requestResponsePairs: l
        };
      }, c.push(s)), c;
    },
    []
  );
}, Yp = (e) => ["events.ld.catamorphic.com", "events.launchdarkly.com"].some(
  (t) => e.toLocaleLowerCase().includes(t)
), Jp = (e) => Wp(e), Zp = (e, t) => t.some(
  (r) => e.toLocaleLowerCase().includes(r)
), Vn = (e, t, r) => !Zp(e, t) && !Jp(e) && !Yp(e), $n = (e, t, r) => {
  var a;
  if (r.some(
    (u) => e.toLowerCase().includes(u)
  ))
    return !1;
  let n = [];
  t === !0 ? (n = ["localhost", /^\//], (a = window == null ? void 0 : window.location) != null && a.host && n.push(Na(window.location.host))) : t instanceof Array && (n = t);
  const i = eh(e);
  let o = !1;
  return n.forEach((u) => {
    i.match(u) && (o = !0);
  }), o;
}, Qp = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), Na = (e) => new RegExp("^https?://([^/]+\\.)?" + Qp(e) + "([:/?#]|$)"), eh = (e) => {
  if (e.startsWith("/") && !e.startsWith("//"))
    return e;
  try {
    return new URL(e).origin;
  } catch (t) {
    return e;
  }
};
function th(e) {
  for (var t = "", r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", n = r.length, i = 0; i < e; i++)
    t += r.charAt(
      Math.floor(Math.random() * n)
    );
  return t;
}
const Ca = () => {
  const e = th(10), t = xy(), r = t == null ? void 0 : t.spanContext().traceId;
  return [de(), r != null ? r : e];
}, Ma = (e, t) => e + "/" + t, Hm = (e, t, r, n, i, o) => {
  const a = XMLHttpRequest.prototype, u = a.open, c = a.send, s = a.setRequestHeader;
  return a.open = function(l, f) {
    return typeof f == "string" ? this._url = f : this._url = f.toString(), this._method = l, this._requestHeaders = {}, this._shouldRecordHeaderAndBody = !n.some(
      (d) => this._url.toLowerCase().includes(d)
    ), u.apply(this, arguments);
  }, a.setRequestHeader = function(l, f) {
    return this._requestHeaders[l] = f, s.apply(this, arguments);
  }, a.send = function(l) {
    if (!Vn(
      this._url,
      t
    ))
      return c.apply(this, arguments);
    const [f, d] = Ca();
    $n(
      this._url,
      r,
      n
    ) && this.setRequestHeader(
      Pa,
      Ma(f, d)
    );
    const h = this._shouldRecordHeaderAndBody, _ = {
      sessionSecureID: f,
      id: d,
      url: this._url,
      verb: this._method,
      headers: h ? this._requestHeaders : {},
      body: void 0
    };
    if (h && l) {
      const p = En(l, _.url);
      p && (this._body = p, _.body = ee(
        p,
        i,
        o,
        _.headers
      ));
    }
    return this.addEventListener("load", function() {
      return U(this, null, function* () {
        const p = {
          status: this.status,
          headers: {},
          body: void 0
        };
        if (h) {
          const g = this.getAllResponseHeaders().trim().split(/[\r\n]+/), w = {};
          if (g.forEach(function(A) {
            const R = A.split(": "), P = R.shift();
            w[P] = R.join(": ");
          }), p.headers = w, l) {
            const A = En(l, _.url);
            A && (_.body = ee(
              A,
              i,
              o,
              p.headers
            ));
          }
          if (this.responseType === "" || this.responseType === "text")
            p.body = ee(
              this.responseText,
              i,
              o,
              p.headers
            ), p.size = this.responseText.length * 8;
          else if (this.responseType === "blob") {
            if (this.response instanceof Blob)
              try {
                const A = yield this.response.text();
                p.body = ee(
                  A,
                  i,
                  o,
                  p.headers
                ), p.size = this.response.size;
              } catch (A) {
              }
          } else
            try {
              p.body = ee(
                this.response,
                i,
                o,
                p.headers
              );
            } catch (A) {
            }
        }
        e({
          request: _,
          response: p,
          urlBlocked: !h
        });
      });
    }), this.addEventListener("error", function() {
      return U(this, null, function* () {
        const p = {
          status: this.status,
          headers: void 0,
          body: void 0
        };
        e({
          request: _,
          response: p,
          urlBlocked: !1
        });
      });
    }), c.apply(this, arguments);
  }, () => {
    a.open = u, a.send = c, a.setRequestHeader = s;
  };
}, rh = /^\[object (ArrayBuffer|SharedArrayBuffer|DataView|(?:Ui|I)nt(?:8|16|32)Array|Uint8ClampedArray|Float(?:16|32|64)Array|Big(?:Ui|I)nt64Array|Blob|File|FormData|URLSearchParams|ReadableStream)\]$/, nh = (e) => typeof e == "object" && e !== null && rh.test(Object.prototype.toString.call(e)), ih = (e) => {
  var r, n;
  return typeof Blob != "undefined" && e instanceof Blob ? `[Blob type="${e.type}" size=${e.size}]` : typeof FormData != "undefined" && e instanceof FormData ? "[FormData]" : typeof URLSearchParams != "undefined" && e instanceof URLSearchParams ? e.toString().slice(0, Tn) : `[binary size=${(n = (r = e == null ? void 0 : e.byteLength) != null ? r : e == null ? void 0 : e.size) != null ? n : 0}]`;
}, En = (e, t) => {
  if (nh(e))
    return ih(e);
  if (typeof e == "string") {
    if (!((t != null && t.includes("localhost") || t != null && t.includes("highlight.run")) && (e.includes("pushPayload") || e.includes("pushSessionEvents"))))
      return e;
  } else if (typeof e == "object" || typeof e == "number" || typeof e == "boolean")
    return We(e);
  return null;
}, Tn = 64 * 1024, oh = {
  "application/json": 256 * 1024,
  // 256 KiB
  "text/plain": 256 * 1024
  // 256 KiB
}, Ia = (e, t) => `[body omitted: ${e} bytes exceeds the ${t} byte limit]`, zn = (e) => {
  var r, n;
  if (!e)
    return Tn;
  let t = "";
  if (typeof e.get == "function")
    t = (r = e.get("content-type")) != null ? r : "";
  else {
    const i = e, o = Object.keys(i).find(
      (a) => a.toLowerCase() === "content-type"
    );
    t = o && i[o] || "";
  }
  try {
    t = t.split(";")[0].trim();
  } catch (i) {
  }
  return (n = oh[t]) != null ? n : Tn;
}, ee = (e, t, r, n) => {
  const i = zn(n);
  if (typeof e == "string" && e.length > i)
    return Ia(e.length, i);
  if (e) {
    if (t)
      try {
        const o = JSON.parse(e);
        Array.isArray(o) ? o.forEach((a) => {
          Object.keys(a).forEach((u) => {
            t.includes(
              u.toLocaleLowerCase()
            ) && (a[u] = "[REDACTED]");
          });
        }) : Object.keys(o).forEach((a) => {
          t.includes(a.toLocaleLowerCase()) && (o[a] = "[REDACTED]");
        }), e = JSON.stringify(o);
      } catch (o) {
      }
    if (r)
      try {
        const o = JSON.parse(e);
        Object.keys(o).forEach((a) => {
          r.includes(a.toLocaleLowerCase()) || (o[a] = "[REDACTED]");
        }), e = JSON.stringify(o);
      } catch (o) {
      }
  }
  try {
    e = e.slice(0, i);
  } catch (o) {
  }
  return e;
}, Gm = (e, t, r, n, i, o) => {
  const a = window._fetchProxy;
  return window._fetchProxy = function(u, c) {
    const { method: s, url: l } = ah(u, c);
    if (!Vn(
      l,
      t
    ))
      return a.call(this, u, c);
    const [f, d] = Ca();
    if ($n(l, r, n)) {
      c = c || {};
      let v = new Headers(c.headers);
      u instanceof Request && [...u.headers].forEach(
        ([y, g]) => v.set(y, g)
      ), v.set(
        Pa,
        Ma(f, d)
      ), c.headers = Object.fromEntries(v.entries());
    }
    const h = {
      sessionSecureID: f,
      id: d,
      headers: {},
      body: void 0,
      url: l,
      verb: s
    }, _ = !n.some(
      (v) => l.toLowerCase().includes(v)
    );
    _ && (h.headers = Object.fromEntries(
      new Headers(c == null ? void 0 : c.headers).entries()
    ), h.body = ee(
      c == null ? void 0 : c.body,
      i,
      o,
      c == null ? void 0 : c.headers
    ));
    let p = a.call(this, u, c);
    return sh(
      p,
      h,
      e,
      _,
      i,
      o
    ), p;
  }, () => {
    window._fetchProxy = a;
  };
}, ah = (e, t) => {
  const r = t && t.method || typeof e == "object" && "method" in e && e.method || "GET";
  let n;
  return typeof e == "object" ? "url" in e && e.url ? n = e.url : n = e.toString() : n = e, {
    method: r,
    url: n
  };
}, sh = (e, t, r, n, i, o) => {
  const a = (u) => U(void 0, null, function* () {
    let c = {
      body: void 0,
      headers: void 0,
      status: 0,
      size: 0
    }, s = !1, l = !n;
    "stack" in u || u instanceof Error ? (c = I(E({}, c), {
      body: u.message,
      status: 0,
      size: void 0
    }), s = !0) : "status" in u && (c = I(E({}, c), {
      status: u.status
    }), n && (c.body = yield xa(
      u,
      o,
      i
    ), c.headers = Object.fromEntries(
      u.headers.entries()
    ), c.size = c.body.length * 8), (u.type === "opaque" || u.type === "opaqueredirect") && (l = !0, c = I(E({}, c), {
      body: "CORS blocked request"
    })), s = !0), s && r({
      request: t,
      response: c,
      urlBlocked: l
    });
  });
  e.then(a).catch(() => {
  });
}, xa = (e, t, r) => U(void 0, null, function* () {
  let n;
  try {
    const o = e.clone().body;
    if (o) {
      let a = o.getReader(), u = new TextDecoder(), c;
      const s = zn(e.headers);
      let l = "", f = !1;
      for (; !(c = yield a.read()).done; ) {
        let d = c.value;
        if (l += u.decode(d), l.length > s) {
          f = !0, a.cancel().catch(() => {
          });
          break;
        }
      }
      n = f ? Ia(
        Number(e.headers.get("content-length")) || l.length,
        s
      ) : l, n = ee(
        n,
        r,
        t,
        e.headers
      );
    } else
      n = "";
  } catch (i) {
    n = `Unable to clone response: ${i}`;
  }
  return n;
});
var Da = (
  /** @class */
  function() {
    function e(t) {
      this._delegate = t;
    }
    return e.prototype.export = function(t, r) {
      this._delegate.export(t, r);
    }, e.prototype.forceFlush = function() {
      return this._delegate.forceFlush();
    }, e.prototype.shutdown = function() {
      return this._delegate.shutdown();
    }, e;
  }()
), uh = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), zi = (
  /** @class */
  function(e) {
    uh(t, e);
    function t(r, n, i) {
      var o = e.call(this, r) || this;
      return o.name = "OTLPExporterError", o.data = i, o.code = n, o;
    }
    return t;
  }(Error)
);
function ch(e) {
  if (!Number.isNaN(e) && Number.isFinite(e) && e > 0)
    return e;
  throw new Error("Configuration: timeoutMillis is invalid, expected number greater than 0 (actual: '" + e + "')");
}
function lh(e) {
  if (e != null)
    return function() {
      return e;
    };
}
function fh(e, t, r) {
  var n, i, o, a, u, c;
  return {
    timeoutMillis: ch((i = (n = e.timeoutMillis) !== null && n !== void 0 ? n : t.timeoutMillis) !== null && i !== void 0 ? i : r.timeoutMillis),
    concurrencyLimit: (a = (o = e.concurrencyLimit) !== null && o !== void 0 ? o : t.concurrencyLimit) !== null && a !== void 0 ? a : r.concurrencyLimit,
    compression: (c = (u = e.compression) !== null && u !== void 0 ? u : t.compression) !== null && c !== void 0 ? c : r.compression
  };
}
function dh() {
  return {
    timeoutMillis: 1e4,
    concurrencyLimit: 30,
    compression: "none"
  };
}
var ph = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, hh = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, _h = (
  /** @class */
  function() {
    function e(t) {
      this._sendingPromises = [], this._concurrencyLimit = t;
    }
    return e.prototype.pushPromise = function(t) {
      var r = this;
      if (this.hasReachedLimit())
        throw new Error("Concurrency Limit reached");
      this._sendingPromises.push(t);
      var n = function() {
        var i = r._sendingPromises.indexOf(t);
        r._sendingPromises.splice(i, 1);
      };
      t.then(n, n);
    }, e.prototype.hasReachedLimit = function() {
      return this._sendingPromises.length >= this._concurrencyLimit;
    }, e.prototype.awaitAll = function() {
      return ph(this, void 0, void 0, function() {
        return hh(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, Promise.all(this._sendingPromises)];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function vh(e) {
  return new _h(e.concurrencyLimit);
}
function yh(e) {
  return Object.prototype.hasOwnProperty.call(e, "partialSuccess");
}
function mh() {
  return {
    handleResponse: function(e) {
      e == null || !yh(e) || e.partialSuccess == null || Object.keys(e.partialSuccess).length === 0 || m.warn("Received Partial Success response:", JSON.stringify(e.partialSuccess));
    }
  };
}
var gh = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Eh = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Th = (
  /** @class */
  function() {
    function e(t, r, n, i, o) {
      this._transport = t, this._serializer = r, this._responseHandler = n, this._promiseQueue = i, this._timeout = o, this._diagLogger = m.createComponentLogger({
        namespace: "OTLPExportDelegate"
      });
    }
    return e.prototype.export = function(t, r) {
      var n = this;
      if (this._diagLogger.debug("items to be sent", t), this._promiseQueue.hasReachedLimit()) {
        r({
          code: N.FAILED,
          error: new Error("Concurrent export limit reached")
        });
        return;
      }
      var i = this._serializer.serializeRequest(t);
      if (i == null) {
        r({
          code: N.FAILED,
          error: new Error("Nothing to send")
        });
        return;
      }
      this._promiseQueue.pushPromise(this._transport.send(i, this._timeout).then(function(o) {
        if (o.status === "success") {
          if (o.data != null)
            try {
              n._responseHandler.handleResponse(n._serializer.deserializeResponse(o.data));
            } catch (a) {
              n._diagLogger.warn("Export succeeded but could not deserialize response - is the response specification compliant?", a, o.data);
            }
          r({
            code: N.SUCCESS
          });
          return;
        } else if (o.status === "failure" && o.error) {
          r({
            code: N.FAILED,
            error: o.error
          });
          return;
        } else o.status === "retryable" ? r({
          code: N.FAILED,
          error: new zi("Export failed with retryable status")
        }) : r({
          code: N.FAILED,
          error: new zi("Export failed with unknown error")
        });
      }, function(o) {
        return r({
          code: N.FAILED,
          error: o
        });
      }));
    }, e.prototype.forceFlush = function() {
      return this._promiseQueue.awaitAll();
    }, e.prototype.shutdown = function() {
      return gh(this, void 0, void 0, function() {
        return Eh(this, function(t) {
          switch (t.label) {
            case 0:
              return this._diagLogger.debug("shutdown started"), [4, this.forceFlush()];
            case 1:
              return t.sent(), this._transport.shutdown(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function Sh(e, t) {
  return new Th(e.transport, e.serializer, mh(), e.promiseHandler, t.timeout);
}
function Ua(e, t, r) {
  return Sh({
    transport: r,
    serializer: t,
    promiseHandler: vh(e)
  }, { timeout: e.timeoutMillis });
}
function ka(e) {
  var t = BigInt(1e9);
  return BigInt(e[0]) * t + BigInt(e[1]);
}
function bh(e) {
  var t = Number(BigInt.asUintN(32, e)), r = Number(BigInt.asUintN(32, e >> BigInt(32)));
  return { low: t, high: r };
}
function Ba(e) {
  var t = ka(e);
  return bh(t);
}
function wh(e) {
  var t = ka(e);
  return t.toString();
}
var Ah = typeof BigInt != "undefined" ? wh : se;
function Xi(e) {
  return e;
}
function Ha(e) {
  if (e !== void 0)
    return Gn(e);
}
var Oh = {
  encodeHrTime: Ba,
  encodeSpanContext: Gn,
  encodeOptionalSpanContext: Ha
};
function Ga(e) {
  var t, r;
  if (e === void 0)
    return Oh;
  var n = (t = e.useLongBits) !== null && t !== void 0 ? t : !0, i = (r = e.useHex) !== null && r !== void 0 ? r : !1;
  return {
    encodeHrTime: n ? Ba : Ah,
    encodeSpanContext: i ? Xi : Gn,
    encodeOptionalSpanContext: i ? Xi : Ha
  };
}
var Rh = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Fa(e) {
  return {
    attributes: De(e.attributes),
    droppedAttributesCount: 0
  };
}
function ja(e) {
  return {
    name: e.name,
    version: e.version
  };
}
function De(e) {
  return Object.keys(e).map(function(t) {
    return Va(t, e[t]);
  });
}
function Va(e, t) {
  return {
    key: e,
    value: $a(t)
  };
}
function $a(e) {
  var t = typeof e;
  return t === "string" ? { stringValue: e } : t === "number" ? Number.isInteger(e) ? { intValue: e } : { doubleValue: e } : t === "boolean" ? { boolValue: e } : e instanceof Uint8Array ? { bytesValue: e } : Array.isArray(e) ? { arrayValue: { values: e.map($a) } } : t === "object" && e != null ? {
    kvlistValue: {
      values: Object.entries(e).map(function(r) {
        var n = Rh(r, 2), i = n[0], o = n[1];
        return Va(i, o);
      })
    }
  } : {};
}
var Y;
(function(e) {
  e[e.DELTA = 0] = "DELTA", e[e.CUMULATIVE = 1] = "CUMULATIVE";
})(Y || (Y = {}));
var te;
(function(e) {
  e[e.HISTOGRAM = 0] = "HISTOGRAM", e[e.EXPONENTIAL_HISTOGRAM = 1] = "EXPONENTIAL_HISTOGRAM", e[e.GAUGE = 2] = "GAUGE", e[e.SUM = 3] = "SUM";
})(te || (te = {}));
var Lh = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), qi = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Wi = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Ph = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Nh = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Ch = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function Mh(e) {
  return e != null;
}
function za(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "" : (t = t.sort(), JSON.stringify(t.map(function(r) {
    return [r, e[r]];
  })));
}
function Ih(e) {
  var t, r;
  return e.name + ":" + ((t = e.version) !== null && t !== void 0 ? t : "") + ":" + ((r = e.schemaUrl) !== null && r !== void 0 ? r : "");
}
var Xa = (
  /** @class */
  function(e) {
    Lh(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return Object.setPrototypeOf(n, t.prototype), n;
    }
    return t;
  }(Error)
);
function gt(e, t) {
  var r, n = new Promise(function(o, a) {
    r = setTimeout(function() {
      a(new Xa("Operation timed out."));
    }, t);
  });
  return Promise.race([e, n]).then(function(i) {
    return clearTimeout(r), i;
  }, function(i) {
    throw clearTimeout(r), i;
  });
}
function xh(e) {
  return qi(this, void 0, void 0, function() {
    var t = this;
    return Wi(this, function(r) {
      return [2, Promise.all(e.map(function(n) {
        return qi(t, void 0, void 0, function() {
          var i, o;
          return Wi(this, function(a) {
            switch (a.label) {
              case 0:
                return a.trys.push([0, 2, , 3]), [4, n];
              case 1:
                return i = a.sent(), [2, {
                  status: "fulfilled",
                  value: i
                }];
              case 2:
                return o = a.sent(), [2, {
                  status: "rejected",
                  reason: o
                }];
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }))];
    });
  });
}
function Dh(e) {
  return e.status === "rejected";
}
function Ki(e, t) {
  var r = [];
  return e.forEach(function(n) {
    r.push.apply(r, Nh([], Ph(t(n)), !1));
  }), r;
}
function Uh(e, t) {
  var r, n;
  if (e.size !== t.size)
    return !1;
  try {
    for (var i = Ch(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (!t.has(a))
        return !1;
    }
  } catch (u) {
    r = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !0;
}
function kh(e, t) {
  for (var r = 0, n = e.length - 1, i = e.length; n >= r; ) {
    var o = r + Math.trunc((n - r) / 2);
    e[o] < t ? r = o + 1 : (i = o, n = o - 1);
  }
  return i;
}
function Bh(e, t) {
  return e.toLowerCase() === t.toLowerCase();
}
var Me;
(function(e) {
  e[e.DROP = 0] = "DROP", e[e.SUM = 1] = "SUM", e[e.LAST_VALUE = 2] = "LAST_VALUE", e[e.HISTOGRAM = 3] = "HISTOGRAM", e[e.EXPONENTIAL_HISTOGRAM = 4] = "EXPONENTIAL_HISTOGRAM";
})(Me || (Me = {}));
var Hh = (
  /** @class */
  function() {
    function e() {
      this.kind = Me.DROP;
    }
    return e.prototype.createAccumulation = function() {
    }, e.prototype.merge = function(t, r) {
    }, e.prototype.diff = function(t, r) {
    }, e.prototype.toMetricData = function(t, r, n, i) {
    }, e;
  }()
), S;
(function(e) {
  e.COUNTER = "COUNTER", e.GAUGE = "GAUGE", e.HISTOGRAM = "HISTOGRAM", e.UP_DOWN_COUNTER = "UP_DOWN_COUNTER", e.OBSERVABLE_COUNTER = "OBSERVABLE_COUNTER", e.OBSERVABLE_GAUGE = "OBSERVABLE_GAUGE", e.OBSERVABLE_UP_DOWN_COUNTER = "OBSERVABLE_UP_DOWN_COUNTER";
})(S || (S = {}));
function fe(e, t, r) {
  var n, i, o, a;
  return Vh(e) || m.warn('Invalid metric name: "' + e + '". The metric name should be a ASCII string with a length no greater than 255 characters.'), {
    name: e,
    type: t,
    description: (n = r == null ? void 0 : r.description) !== null && n !== void 0 ? n : "",
    unit: (i = r == null ? void 0 : r.unit) !== null && i !== void 0 ? i : "",
    valueType: (o = r == null ? void 0 : r.valueType) !== null && o !== void 0 ? o : ve.DOUBLE,
    advice: (a = r == null ? void 0 : r.advice) !== null && a !== void 0 ? a : {}
  };
}
function Gh(e, t) {
  var r, n;
  return {
    name: (r = e.name) !== null && r !== void 0 ? r : t.name,
    description: (n = e.description) !== null && n !== void 0 ? n : t.description,
    type: t.type,
    unit: t.unit,
    valueType: t.valueType,
    advice: t.advice
  };
}
function Fh(e, t) {
  return Bh(e.name, t.name) && e.unit === t.unit && e.type === t.type && e.valueType === t.valueType;
}
var jh = /^[a-z][a-z0-9_.\-/]{0,254}$/i;
function Vh(e) {
  return e.match(jh) != null;
}
var $h = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function zh(e) {
  var t = e.map(function() {
    return 0;
  });
  return t.push(0), {
    buckets: {
      boundaries: e,
      counts: t
    },
    sum: 0,
    count: 0,
    hasMinMax: !1,
    min: 1 / 0,
    max: -1 / 0
  };
}
var qr = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      n === void 0 && (n = !0), i === void 0 && (i = zh(r)), this.startTime = t, this._boundaries = r, this._recordMinMax = n, this._current = i;
    }
    return e.prototype.record = function(t) {
      if (!Number.isNaN(t)) {
        this._current.count += 1, this._current.sum += t, this._recordMinMax && (this._current.min = Math.min(t, this._current.min), this._current.max = Math.max(t, this._current.max), this._current.hasMinMax = !0);
        var r = kh(this._boundaries, t);
        this._current.buckets.counts[r] += 1;
      }
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), qa = (
  /** @class */
  function() {
    function e(t, r) {
      this._boundaries = t, this._recordMinMax = r, this.kind = Me.HISTOGRAM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new qr(t, this._boundaries, this._recordMinMax);
    }, e.prototype.merge = function(t, r) {
      for (var n = t.toPointValue(), i = r.toPointValue(), o = n.buckets.counts, a = i.buckets.counts, u = new Array(o.length), c = 0; c < o.length; c++)
        u[c] = o[c] + a[c];
      var s = 1 / 0, l = -1 / 0;
      return this._recordMinMax && (n.hasMinMax && i.hasMinMax ? (s = Math.min(n.min, i.min), l = Math.max(n.max, i.max)) : n.hasMinMax ? (s = n.min, l = n.max) : i.hasMinMax && (s = i.min, l = i.max)), new qr(t.startTime, n.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: n.buckets.boundaries,
          counts: u
        },
        count: n.count + i.count,
        sum: n.sum + i.sum,
        hasMinMax: this._recordMinMax && (n.hasMinMax || i.hasMinMax),
        min: s,
        max: l
      });
    }, e.prototype.diff = function(t, r) {
      for (var n = t.toPointValue(), i = r.toPointValue(), o = n.buckets.counts, a = i.buckets.counts, u = new Array(o.length), c = 0; c < o.length; c++)
        u[c] = a[c] - o[c];
      return new qr(r.startTime, n.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: n.buckets.boundaries,
          counts: u
        },
        count: i.count - n.count,
        sum: i.sum - n.sum,
        hasMinMax: !1,
        min: 1 / 0,
        max: -1 / 0
      });
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: te.HISTOGRAM,
        dataPoints: n.map(function(o) {
          var a = $h(o, 2), u = a[0], c = a[1], s = c.toPointValue(), l = t.type === S.GAUGE || t.type === S.UP_DOWN_COUNTER || t.type === S.OBSERVABLE_GAUGE || t.type === S.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: {
              min: s.hasMinMax ? s.min : void 0,
              max: s.hasMinMax ? s.max : void 0,
              sum: l ? void 0 : s.sum,
              buckets: s.buckets,
              count: s.count
            }
          };
        })
      };
    }, e;
  }()
), Wr = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Kr = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Yi = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      t === void 0 && (t = new Xh()), r === void 0 && (r = 0), n === void 0 && (n = 0), i === void 0 && (i = 0), this.backing = t, this.indexBase = r, this.indexStart = n, this.indexEnd = i;
    }
    return Object.defineProperty(e.prototype, "offset", {
      /**
       * Offset is the bucket index of the smallest entry in the counts array
       * @returns {number}
       */
      get: function() {
        return this.indexStart;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "length", {
      /**
       * Buckets is a view into the backing array.
       * @returns {number}
       */
      get: function() {
        return this.backing.length === 0 || this.indexEnd === this.indexStart && this.at(0) === 0 ? 0 : this.indexEnd - this.indexStart + 1;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.counts = function() {
      var t = this;
      return Array.from({ length: this.length }, function(r, n) {
        return t.at(n);
      });
    }, e.prototype.at = function(t) {
      var r = this.indexBase - this.indexStart;
      return t < r && (t += this.backing.length), t -= r, this.backing.countAt(t);
    }, e.prototype.incrementBucket = function(t, r) {
      this.backing.increment(t, r);
    }, e.prototype.decrementBucket = function(t, r) {
      this.backing.decrement(t, r);
    }, e.prototype.trim = function() {
      for (var t = 0; t < this.length; t++)
        if (this.at(t) !== 0) {
          this.indexStart += t;
          break;
        } else if (t === this.length - 1) {
          this.indexStart = this.indexEnd = this.indexBase = 0;
          return;
        }
      for (var t = this.length - 1; t >= 0; t--)
        if (this.at(t) !== 0) {
          this.indexEnd -= this.length - t - 1;
          break;
        }
      this._rotate();
    }, e.prototype.downscale = function(t) {
      this._rotate();
      for (var r = 1 + this.indexEnd - this.indexStart, n = 1 << t, i = 0, o = 0, a = this.indexStart; a <= this.indexEnd; ) {
        var u = a % n;
        u < 0 && (u += n);
        for (var c = u; c < n && i < r; c++)
          this._relocateBucket(o, i), i++, a++;
        o++;
      }
      this.indexStart >>= t, this.indexEnd >>= t, this.indexBase = this.indexStart;
    }, e.prototype.clone = function() {
      return new e(this.backing.clone(), this.indexBase, this.indexStart, this.indexEnd);
    }, e.prototype._rotate = function() {
      var t = this.indexBase - this.indexStart;
      t !== 0 && (t > 0 ? (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, t), this.backing.reverse(t, this.backing.length)) : (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, this.backing.length + t)), this.indexBase = this.indexStart);
    }, e.prototype._relocateBucket = function(t, r) {
      t !== r && this.incrementBucket(t, this.backing.emptyBucket(r));
    }, e;
  }()
), Xh = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = [0]), this._counts = t;
    }
    return Object.defineProperty(e.prototype, "length", {
      /**
       * length returns the physical size of the backing array, which
       * is >= buckets.length()
       */
      get: function() {
        return this._counts.length;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.countAt = function(t) {
      return this._counts[t];
    }, e.prototype.growTo = function(t, r, n) {
      var i = new Array(t).fill(0);
      i.splice.apply(i, Kr([
        n,
        this._counts.length - r
      ], Wr(this._counts.slice(r)), !1)), i.splice.apply(i, Kr([0, r], Wr(this._counts.slice(0, r)), !1)), this._counts = i;
    }, e.prototype.reverse = function(t, r) {
      for (var n = Math.floor((t + r) / 2) - t, i = 0; i < n; i++) {
        var o = this._counts[t + i];
        this._counts[t + i] = this._counts[r - i - 1], this._counts[r - i - 1] = o;
      }
    }, e.prototype.emptyBucket = function(t) {
      var r = this._counts[t];
      return this._counts[t] = 0, r;
    }, e.prototype.increment = function(t, r) {
      this._counts[t] += r;
    }, e.prototype.decrement = function(t, r) {
      this._counts[t] >= r ? this._counts[t] -= r : this._counts[t] = 0;
    }, e.prototype.clone = function() {
      return new e(Kr([], Wr(this._counts), !1));
    }, e;
  }()
), qh = 52, Wh = 2146435072, Kh = 1048575, Xn = 1023, Wa = -Xn + 1, Ka = Xn, Sn = Math.pow(2, -1022);
function Ya(e) {
  var t = new DataView(new ArrayBuffer(8));
  t.setFloat64(0, e);
  var r = t.getUint32(0), n = (r & Wh) >> 20;
  return n - Xn;
}
function Ja(e) {
  var t = new DataView(new ArrayBuffer(8));
  t.setFloat64(0, e);
  var r = t.getUint32(0), n = t.getUint32(4), i = (r & Kh) * Math.pow(2, 32);
  return i + n;
}
function bn(e, t) {
  return e === 0 || e === Number.POSITIVE_INFINITY || e === Number.NEGATIVE_INFINITY || Number.isNaN(e) ? e : e * Math.pow(2, t);
}
function Yh(e) {
  return e--, e |= e >> 1, e |= e >> 2, e |= e >> 4, e |= e >> 8, e |= e >> 16, e++, e;
}
var Jh = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Et = (
  /** @class */
  function(e) {
    Jh(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Error)
), Zh = (
  /** @class */
  function() {
    function e(t) {
      this._shift = -t;
    }
    return e.prototype.mapToIndex = function(t) {
      if (t < Sn)
        return this._minNormalLowerBoundaryIndex();
      var r = Ya(t), n = this._rightShift(Ja(t) - 1, qh);
      return r + n >> this._shift;
    }, e.prototype.lowerBoundary = function(t) {
      var r = this._minNormalLowerBoundaryIndex();
      if (t < r)
        throw new Et("underflow: " + t + " is < minimum lower boundary: " + r);
      var n = this._maxNormalLowerBoundaryIndex();
      if (t > n)
        throw new Et("overflow: " + t + " is > maximum lower boundary: " + n);
      return bn(1, t << this._shift);
    }, Object.defineProperty(e.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._shift === 0 ? 0 : -this._shift;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._minNormalLowerBoundaryIndex = function() {
      var t = Wa >> this._shift;
      return this._shift < 2 && t--, t;
    }, e.prototype._maxNormalLowerBoundaryIndex = function() {
      return Ka >> this._shift;
    }, e.prototype._rightShift = function(t, r) {
      return Math.floor(t * Math.pow(2, -r));
    }, e;
  }()
), Qh = (
  /** @class */
  function() {
    function e(t) {
      this._scale = t, this._scaleFactor = bn(Math.LOG2E, t), this._inverseFactor = bn(Math.LN2, -t);
    }
    return e.prototype.mapToIndex = function(t) {
      if (t <= Sn)
        return this._minNormalLowerBoundaryIndex() - 1;
      if (Ja(t) === 0) {
        var r = Ya(t);
        return (r << this._scale) - 1;
      }
      var n = Math.floor(Math.log(t) * this._scaleFactor), i = this._maxNormalLowerBoundaryIndex();
      return n >= i ? i : n;
    }, e.prototype.lowerBoundary = function(t) {
      var r = this._maxNormalLowerBoundaryIndex();
      if (t >= r) {
        if (t === r)
          return 2 * Math.exp((t - (1 << this._scale)) / this._scaleFactor);
        throw new Et("overflow: " + t + " is > maximum lower boundary: " + r);
      }
      var n = this._minNormalLowerBoundaryIndex();
      if (t <= n) {
        if (t === n)
          return Sn;
        if (t === n - 1)
          return Math.exp((t + (1 << this._scale)) / this._scaleFactor) / 2;
        throw new Et("overflow: " + t + " is < minimum lower boundary: " + n);
      }
      return Math.exp(t * this._inverseFactor);
    }, Object.defineProperty(e.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._scale;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._minNormalLowerBoundaryIndex = function() {
      return Wa << this._scale;
    }, e.prototype._maxNormalLowerBoundaryIndex = function() {
      return (Ka + 1 << this._scale) - 1;
    }, e;
  }()
), Ji = -10, Zi = 20, e_ = Array.from({ length: 31 }, function(e, t) {
  return t > 10 ? new Qh(t - 10) : new Zh(t - 10);
});
function Qi(e) {
  if (e > Zi || e < Ji)
    throw new Et("expected scale >= " + Ji + " && <= " + Zi + ", got: " + e);
  return e_[e + 10];
}
var t_ = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ut = (
  /** @class */
  function() {
    function e(t, r) {
      this.low = t, this.high = r;
    }
    return e.combine = function(t, r) {
      return new e(Math.min(t.low, r.low), Math.max(t.high, r.high));
    }, e;
  }()
), r_ = 20, n_ = 160, Yr = 2, i_ = (
  /** @class */
  function() {
    function e(t, r, n, i, o, a, u, c, s, l, f) {
      t === void 0 && (t = t), r === void 0 && (r = n_), n === void 0 && (n = !0), i === void 0 && (i = 0), o === void 0 && (o = 0), a === void 0 && (a = 0), u === void 0 && (u = Number.POSITIVE_INFINITY), c === void 0 && (c = Number.NEGATIVE_INFINITY), s === void 0 && (s = new Yi()), l === void 0 && (l = new Yi()), f === void 0 && (f = Qi(r_)), this.startTime = t, this._maxSize = r, this._recordMinMax = n, this._sum = i, this._count = o, this._zeroCount = a, this._min = u, this._max = c, this._positive = s, this._negative = l, this._mapping = f, this._maxSize < Yr && (m.warn("Exponential Histogram Max Size set to " + this._maxSize + ",                 changing to the minimum size of: " + Yr), this._maxSize = Yr);
    }
    return e.prototype.record = function(t) {
      this.updateByIncrement(t, 1);
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return {
        hasMinMax: this._recordMinMax,
        min: this.min,
        max: this.max,
        sum: this.sum,
        positive: {
          offset: this.positive.offset,
          bucketCounts: this.positive.counts()
        },
        negative: {
          offset: this.negative.offset,
          bucketCounts: this.negative.counts()
        },
        count: this.count,
        scale: this.scale,
        zeroCount: this.zeroCount
      };
    }, Object.defineProperty(e.prototype, "sum", {
      /**
       * @returns {Number} The sum of values recorded by this accumulation
       */
      get: function() {
        return this._sum;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "min", {
      /**
       * @returns {Number} The minimum value recorded by this accumulation
       */
      get: function() {
        return this._min;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "max", {
      /**
       * @returns {Number} The maximum value recorded by this accumulation
       */
      get: function() {
        return this._max;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "count", {
      /**
       * @returns {Number} The count of values recorded by this accumulation
       */
      get: function() {
        return this._count;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "zeroCount", {
      /**
       * @returns {Number} The number of 0 values recorded by this accumulation
       */
      get: function() {
        return this._zeroCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "scale", {
      /**
       * @returns {Number} The scale used by this accumulation
       */
      get: function() {
        return this._count === this._zeroCount ? 0 : this._mapping.scale;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "positive", {
      /**
       * positive holds the positive values
       * @returns {Buckets}
       */
      get: function() {
        return this._positive;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "negative", {
      /**
       * negative holds the negative values by their absolute value
       * @returns {Buckets}
       */
      get: function() {
        return this._negative;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.updateByIncrement = function(t, r) {
      if (!Number.isNaN(t)) {
        if (t > this._max && (this._max = t), t < this._min && (this._min = t), this._count += r, t === 0) {
          this._zeroCount += r;
          return;
        }
        this._sum += t * r, t > 0 ? this._updateBuckets(this._positive, t, r) : this._updateBuckets(this._negative, -t, r);
      }
    }, e.prototype.merge = function(t) {
      this._count === 0 ? (this._min = t.min, this._max = t.max) : t.count !== 0 && (t.min < this.min && (this._min = t.min), t.max > this.max && (this._max = t.max)), this.startTime = t.startTime, this._sum += t.sum, this._count += t.count, this._zeroCount += t.zeroCount;
      var r = this._minScale(t);
      this._downscale(this.scale - r), this._mergeBuckets(this.positive, t, t.positive, r), this._mergeBuckets(this.negative, t, t.negative, r);
    }, e.prototype.diff = function(t) {
      this._min = 1 / 0, this._max = -1 / 0, this._sum -= t.sum, this._count -= t.count, this._zeroCount -= t.zeroCount;
      var r = this._minScale(t);
      this._downscale(this.scale - r), this._diffBuckets(this.positive, t, t.positive, r), this._diffBuckets(this.negative, t, t.negative, r);
    }, e.prototype.clone = function() {
      return new e(this.startTime, this._maxSize, this._recordMinMax, this._sum, this._count, this._zeroCount, this._min, this._max, this.positive.clone(), this.negative.clone(), this._mapping);
    }, e.prototype._updateBuckets = function(t, r, n) {
      var i = this._mapping.mapToIndex(r), o = !1, a = 0, u = 0;
      if (t.length === 0 ? (t.indexStart = i, t.indexEnd = t.indexStart, t.indexBase = t.indexStart) : i < t.indexStart && t.indexEnd - i >= this._maxSize ? (o = !0, u = i, a = t.indexEnd) : i > t.indexEnd && i - t.indexStart >= this._maxSize && (o = !0, u = t.indexStart, a = i), o) {
        var c = this._changeScale(a, u);
        this._downscale(c), i = this._mapping.mapToIndex(r);
      }
      this._incrementIndexBy(t, i, n);
    }, e.prototype._incrementIndexBy = function(t, r, n) {
      if (n !== 0) {
        if (t.length === 0 && (t.indexStart = t.indexEnd = t.indexBase = r), r < t.indexStart) {
          var i = t.indexEnd - r;
          i >= t.backing.length && this._grow(t, i + 1), t.indexStart = r;
        } else if (r > t.indexEnd) {
          var i = r - t.indexStart;
          i >= t.backing.length && this._grow(t, i + 1), t.indexEnd = r;
        }
        var o = r - t.indexBase;
        o < 0 && (o += t.backing.length), t.incrementBucket(o, n);
      }
    }, e.prototype._grow = function(t, r) {
      var n = t.backing.length, i = t.indexBase - t.indexStart, o = n - i, a = Yh(r);
      a > this._maxSize && (a = this._maxSize);
      var u = a - i;
      t.backing.growTo(a, o, u);
    }, e.prototype._changeScale = function(t, r) {
      for (var n = 0; t - r >= this._maxSize; )
        t >>= 1, r >>= 1, n++;
      return n;
    }, e.prototype._downscale = function(t) {
      if (t !== 0) {
        if (t < 0)
          throw new Error("impossible change of scale: " + this.scale);
        var r = this._mapping.scale - t;
        this._positive.downscale(t), this._negative.downscale(t), this._mapping = Qi(r);
      }
    }, e.prototype._minScale = function(t) {
      var r = Math.min(this.scale, t.scale), n = Ut.combine(this._highLowAtScale(this.positive, this.scale, r), this._highLowAtScale(t.positive, t.scale, r)), i = Ut.combine(this._highLowAtScale(this.negative, this.scale, r), this._highLowAtScale(t.negative, t.scale, r));
      return Math.min(r - this._changeScale(n.high, n.low), r - this._changeScale(i.high, i.low));
    }, e.prototype._highLowAtScale = function(t, r, n) {
      if (t.length === 0)
        return new Ut(0, -1);
      var i = r - n;
      return new Ut(t.indexStart >> i, t.indexEnd >> i);
    }, e.prototype._mergeBuckets = function(t, r, n, i) {
      for (var o = n.offset, a = r.scale - i, u = 0; u < n.length; u++)
        this._incrementIndexBy(t, o + u >> a, n.at(u));
    }, e.prototype._diffBuckets = function(t, r, n, i) {
      for (var o = n.offset, a = r.scale - i, u = 0; u < n.length; u++) {
        var c = o + u >> a, s = c - t.indexBase;
        s < 0 && (s += t.backing.length), t.decrementBucket(s, n.at(u));
      }
      t.trim();
    }, e;
  }()
), o_ = (
  /** @class */
  function() {
    function e(t, r) {
      this._maxSize = t, this._recordMinMax = r, this.kind = Me.EXPONENTIAL_HISTOGRAM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new i_(t, this._maxSize, this._recordMinMax);
    }, e.prototype.merge = function(t, r) {
      var n = r.clone();
      return n.merge(t), n;
    }, e.prototype.diff = function(t, r) {
      var n = r.clone();
      return n.diff(t), n;
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: te.EXPONENTIAL_HISTOGRAM,
        dataPoints: n.map(function(o) {
          var a = t_(o, 2), u = a[0], c = a[1], s = c.toPointValue(), l = t.type === S.GAUGE || t.type === S.UP_DOWN_COUNTER || t.type === S.OBSERVABLE_GAUGE || t.type === S.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: {
              min: s.hasMinMax ? s.min : void 0,
              max: s.hasMinMax ? s.max : void 0,
              sum: l ? void 0 : s.sum,
              positive: {
                offset: s.positive.offset,
                bucketCounts: s.positive.bucketCounts
              },
              negative: {
                offset: s.negative.offset,
                bucketCounts: s.negative.bucketCounts
              },
              count: s.count,
              scale: s.scale,
              zeroCount: s.zeroCount
            }
          };
        })
      };
    }, e;
  }()
), a_ = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Jr = (
  /** @class */
  function() {
    function e(t, r, n) {
      r === void 0 && (r = 0), n === void 0 && (n = [0, 0]), this.startTime = t, this._current = r, this.sampleTime = n;
    }
    return e.prototype.record = function(t) {
      this._current = t, this.sampleTime = X(Date.now());
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), s_ = (
  /** @class */
  function() {
    function e() {
      this.kind = Me.LAST_VALUE;
    }
    return e.prototype.createAccumulation = function(t) {
      return new Jr(t);
    }, e.prototype.merge = function(t, r) {
      var n = Ct(r.sampleTime) >= Ct(t.sampleTime) ? r : t;
      return new Jr(t.startTime, n.toPointValue(), n.sampleTime);
    }, e.prototype.diff = function(t, r) {
      var n = Ct(r.sampleTime) >= Ct(t.sampleTime) ? r : t;
      return new Jr(r.startTime, n.toPointValue(), n.sampleTime);
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: te.GAUGE,
        dataPoints: n.map(function(o) {
          var a = a_(o, 2), u = a[0], c = a[1];
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: c.toPointValue()
          };
        })
      };
    }, e;
  }()
), u_ = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ut = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      n === void 0 && (n = 0), i === void 0 && (i = !1), this.startTime = t, this.monotonic = r, this._current = n, this.reset = i;
    }
    return e.prototype.record = function(t) {
      this.monotonic && t < 0 || (this._current += t);
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), eo = (
  /** @class */
  function() {
    function e(t) {
      this.monotonic = t, this.kind = Me.SUM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new ut(t, this.monotonic);
    }, e.prototype.merge = function(t, r) {
      var n = t.toPointValue(), i = r.toPointValue();
      return r.reset ? new ut(r.startTime, this.monotonic, i, r.reset) : new ut(t.startTime, this.monotonic, n + i);
    }, e.prototype.diff = function(t, r) {
      var n = t.toPointValue(), i = r.toPointValue();
      return this.monotonic && n > i ? new ut(r.startTime, this.monotonic, i, !0) : new ut(r.startTime, this.monotonic, i - n);
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: te.SUM,
        dataPoints: n.map(function(o) {
          var a = u_(o, 2), u = a[0], c = a[1];
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: c.toPointValue()
          };
        }),
        isMonotonic: this.monotonic
      };
    }, e;
  }()
), Ue = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ce = (
  /** @class */
  function() {
    function e() {
    }
    return e.Drop = function() {
      return Za;
    }, e.Sum = function() {
      return Qa;
    }, e.LastValue = function() {
      return es;
    }, e.Histogram = function() {
      return ts;
    }, e.ExponentialHistogram = function() {
      return v_;
    }, e.Default = function() {
      return y_;
    }, e;
  }()
), c_ = (
  /** @class */
  function(e) {
    Ue(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new Hh(), t;
  }(ce)
), l_ = (
  /** @class */
  function(e) {
    Ue(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      switch (r.type) {
        case S.COUNTER:
        case S.OBSERVABLE_COUNTER:
        case S.HISTOGRAM:
          return t.MONOTONIC_INSTANCE;
        default:
          return t.NON_MONOTONIC_INSTANCE;
      }
    }, t.MONOTONIC_INSTANCE = new eo(!0), t.NON_MONOTONIC_INSTANCE = new eo(!1), t;
  }(ce)
), f_ = (
  /** @class */
  function(e) {
    Ue(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new s_(), t;
  }(ce)
), d_ = (
  /** @class */
  function(e) {
    Ue(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new qa([0, 5, 10, 25, 50, 75, 100, 250, 500, 750, 1e3, 2500, 5e3, 7500, 1e4], !0), t;
  }(ce)
), p_ = (
  /** @class */
  function(e) {
    Ue(t, e);
    function t(r, n) {
      n === void 0 && (n = !0);
      var i = e.call(this) || this;
      if (i._recordMinMax = n, r == null)
        throw new Error("ExplicitBucketHistogramAggregation should be created with explicit boundaries, if a single bucket histogram is required, please pass an empty array");
      r = r.concat(), r = r.sort(function(u, c) {
        return u - c;
      });
      var o = r.lastIndexOf(-1 / 0), a = r.indexOf(1 / 0);
      return a === -1 && (a = void 0), i._boundaries = r.slice(o + 1, a), i;
    }
    return t.prototype.createAggregator = function(r) {
      return new qa(this._boundaries, this._recordMinMax);
    }, t;
  }(ce)
), h_ = (
  /** @class */
  function(e) {
    Ue(t, e);
    function t(r, n) {
      r === void 0 && (r = 160), n === void 0 && (n = !0);
      var i = e.call(this) || this;
      return i._maxSize = r, i._recordMinMax = n, i;
    }
    return t.prototype.createAggregator = function(r) {
      return new o_(this._maxSize, this._recordMinMax);
    }, t;
  }(ce)
), __ = (
  /** @class */
  function(e) {
    Ue(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype._resolve = function(r) {
      switch (r.type) {
        case S.COUNTER:
        case S.UP_DOWN_COUNTER:
        case S.OBSERVABLE_COUNTER:
        case S.OBSERVABLE_UP_DOWN_COUNTER:
          return Qa;
        case S.GAUGE:
        case S.OBSERVABLE_GAUGE:
          return es;
        case S.HISTOGRAM:
          return r.advice.explicitBucketBoundaries ? new p_(r.advice.explicitBucketBoundaries) : ts;
      }
      return m.warn("Unable to recognize instrument type: " + r.type), Za;
    }, t.prototype.createAggregator = function(r) {
      return this._resolve(r).createAggregator(r);
    }, t;
  }(ce)
), Za = new c_(), Qa = new l_(), es = new f_(), ts = new d_(), v_ = new h_(), y_ = new __(), m_ = function(e) {
  return ce.Default();
}, g_ = function(e) {
  return Y.CUMULATIVE;
}, Zr = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Qr = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, to = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, E_ = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, T_ = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i;
      this._shutdown = !1, this._aggregationSelector = (r = t == null ? void 0 : t.aggregationSelector) !== null && r !== void 0 ? r : m_, this._aggregationTemporalitySelector = (n = t == null ? void 0 : t.aggregationTemporalitySelector) !== null && n !== void 0 ? n : g_, this._metricProducers = (i = t == null ? void 0 : t.metricProducers) !== null && i !== void 0 ? i : [], this._cardinalitySelector = t == null ? void 0 : t.cardinalitySelector;
    }
    return e.prototype.setMetricProducer = function(t) {
      if (this._sdkMetricProducer)
        throw new Error("MetricReader can not be bound to a MeterProvider again.");
      this._sdkMetricProducer = t, this.onInitialized();
    }, e.prototype.selectAggregation = function(t) {
      return this._aggregationSelector(t);
    }, e.prototype.selectAggregationTemporality = function(t) {
      return this._aggregationTemporalitySelector(t);
    }, e.prototype.selectCardinalityLimit = function(t) {
      return this._cardinalitySelector ? this._cardinalitySelector(t) : 2e3;
    }, e.prototype.onInitialized = function() {
    }, e.prototype.collect = function(t) {
      return Zr(this, void 0, void 0, function() {
        var r, n, i, o, a, u;
        return Qr(this, function(c) {
          switch (c.label) {
            case 0:
              if (this._sdkMetricProducer === void 0)
                throw new Error("MetricReader is not bound to a MetricProducer");
              if (this._shutdown)
                throw new Error("MetricReader is shutdown");
              return [4, Promise.all(E_([
                this._sdkMetricProducer.collect({
                  timeoutMillis: t == null ? void 0 : t.timeoutMillis
                })
              ], to(this._metricProducers.map(function(s) {
                return s.collect({
                  timeoutMillis: t == null ? void 0 : t.timeoutMillis
                });
              })), !1))];
            case 1:
              return r = to.apply(void 0, [c.sent()]), n = r[0], i = r.slice(1), o = n.errors.concat(Ki(i, function(s) {
                return s.errors;
              })), a = n.resourceMetrics.resource, u = n.resourceMetrics.scopeMetrics.concat(Ki(i, function(s) {
                return s.resourceMetrics.scopeMetrics;
              })), [2, {
                resourceMetrics: {
                  resource: a,
                  scopeMetrics: u
                },
                errors: o
              }];
          }
        });
      });
    }, e.prototype.shutdown = function(t) {
      return Zr(this, void 0, void 0, function() {
        return Qr(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (m.error("Cannot call shutdown twice."), [
                2
                /*return*/
              ]) : (t == null ? void 0 : t.timeoutMillis) != null ? [3, 2] : [4, this.onShutdown()];
            case 1:
              return r.sent(), [3, 4];
            case 2:
              return [4, gt(this.onShutdown(), t.timeoutMillis)];
            case 3:
              r.sent(), r.label = 4;
            case 4:
              return this._shutdown = !0, [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return Zr(this, void 0, void 0, function() {
        return Qr(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (m.warn("Cannot forceFlush on already shutdown MetricReader."), [
                2
                /*return*/
              ]) : (t == null ? void 0 : t.timeoutMillis) != null ? [3, 2] : [4, this.onForceFlush()];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
            case 2:
              return [4, gt(this.onForceFlush(), t.timeoutMillis)];
            case 3:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
), S_ = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), kt = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Bt = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, b_ = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, w_ = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, A_ = (
  /** @class */
  function(e) {
    S_(t, e);
    function t(r) {
      var n, i, o, a, u = e.call(this, {
        aggregationSelector: (n = r.exporter.selectAggregation) === null || n === void 0 ? void 0 : n.bind(r.exporter),
        aggregationTemporalitySelector: (i = r.exporter.selectAggregationTemporality) === null || i === void 0 ? void 0 : i.bind(r.exporter),
        metricProducers: r.metricProducers
      }) || this;
      if (r.exportIntervalMillis !== void 0 && r.exportIntervalMillis <= 0)
        throw Error("exportIntervalMillis must be greater than 0");
      if (r.exportTimeoutMillis !== void 0 && r.exportTimeoutMillis <= 0)
        throw Error("exportTimeoutMillis must be greater than 0");
      if (r.exportTimeoutMillis !== void 0 && r.exportIntervalMillis !== void 0 && r.exportIntervalMillis < r.exportTimeoutMillis)
        throw Error("exportIntervalMillis must be greater than or equal to exportTimeoutMillis");
      return u._exportInterval = (o = r.exportIntervalMillis) !== null && o !== void 0 ? o : 6e4, u._exportTimeout = (a = r.exportTimeoutMillis) !== null && a !== void 0 ? a : 3e4, u._exporter = r.exporter, u;
    }
    return t.prototype._runOnce = function() {
      return kt(this, void 0, void 0, function() {
        var r;
        return Bt(this, function(n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 2, , 3]), [4, gt(this._doRun(), this._exportTimeout)];
            case 1:
              return n.sent(), [3, 3];
            case 2:
              return r = n.sent(), r instanceof Xa ? (m.error("Export took longer than %s milliseconds and timed out.", this._exportTimeout), [
                2
                /*return*/
              ]) : (ye(r), [3, 3]);
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype._doRun = function() {
      var r, n;
      return kt(this, void 0, void 0, function() {
        var i, o, a, u, c, s;
        return Bt(this, function(l) {
          switch (l.label) {
            case 0:
              return [4, this.collect({
                timeoutMillis: this._exportTimeout
              })];
            case 1:
              if (i = l.sent(), o = i.resourceMetrics, a = i.errors, a.length > 0 && (s = m).error.apply(s, w_(["PeriodicExportingMetricReader: metrics collection errors"], b_(a), !1)), !o.resource.asyncAttributesPending) return [3, 5];
              l.label = 2;
            case 2:
              return l.trys.push([2, 4, , 5]), [4, (n = (r = o.resource).waitForAsyncAttributes) === null || n === void 0 ? void 0 : n.call(r)];
            case 3:
              return l.sent(), [3, 5];
            case 4:
              return u = l.sent(), m.debug("Error while resolving async portion of resource: ", u), ye(u), [3, 5];
            case 5:
              return o.scopeMetrics.length === 0 ? [
                2
                /*return*/
              ] : [4, Af._export(this._exporter, o)];
            case 6:
              if (c = l.sent(), c.code !== N.SUCCESS)
                throw new Error("PeriodicExportingMetricReader: metrics export failed (error " + c.error + ")");
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.onInitialized = function() {
      var r = this;
      this._interval = setInterval(function() {
        r._runOnce();
      }, this._exportInterval);
    }, t.prototype.onForceFlush = function() {
      return kt(this, void 0, void 0, function() {
        return Bt(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._runOnce()];
            case 1:
              return r.sent(), [4, this._exporter.forceFlush()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.onShutdown = function() {
      return kt(this, void 0, void 0, function() {
        return Bt(this, function(r) {
          switch (r.label) {
            case 0:
              return this._interval && clearInterval(this._interval), [4, this.onForceFlush()];
            case 1:
              return r.sent(), [4, this._exporter.shutdown()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }(T_)
), O_ = (
  /** @class */
  function() {
    function e() {
      this._registeredViews = [];
    }
    return e.prototype.addView = function(t) {
      this._registeredViews.push(t);
    }, e.prototype.findViews = function(t, r) {
      var n = this, i = this._registeredViews.filter(function(o) {
        return n._matchInstrument(o.instrumentSelector, t) && n._matchMeter(o.meterSelector, r);
      });
      return i;
    }, e.prototype._matchInstrument = function(t, r) {
      return (t.getType() === void 0 || r.type === t.getType()) && t.getNameFilter().match(r.name) && t.getUnitFilter().match(r.unit);
    }, e.prototype._matchMeter = function(t, r) {
      return t.getNameFilter().match(r.name) && (r.version === void 0 || t.getVersionFilter().match(r.version)) && (r.schemaUrl === void 0 || t.getSchemaUrlFilter().match(r.schemaUrl));
    }, e;
  }()
), ke = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), yr = (
  /** @class */
  function() {
    function e(t, r) {
      this._writableMetricStorage = t, this._descriptor = r;
    }
    return e.prototype._record = function(t, r, n) {
      if (r === void 0 && (r = {}), n === void 0 && (n = O.active()), typeof t != "number") {
        m.warn("non-number value provided to metric " + this._descriptor.name + ": " + t);
        return;
      }
      this._descriptor.valueType === ve.INT && !Number.isInteger(t) && (m.warn("INT value type cannot accept a floating-point value for " + this._descriptor.name + ", ignoring the fractional digits."), t = Math.trunc(t), !Number.isInteger(t)) || this._writableMetricStorage.record(t, r, n, X(Date.now()));
    }, e;
  }()
), R_ = (
  /** @class */
  function(e) {
    ke(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n, i) {
      this._record(r, n, i);
    }, t;
  }(yr)
), L_ = (
  /** @class */
  function(e) {
    ke(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n, i) {
      if (r < 0) {
        m.warn("negative value provided to counter " + this._descriptor.name + ": " + r);
        return;
      }
      this._record(r, n, i);
    }, t;
  }(yr)
), P_ = (
  /** @class */
  function(e) {
    ke(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n, i) {
      this._record(r, n, i);
    }, t;
  }(yr)
), N_ = (
  /** @class */
  function(e) {
    ke(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n, i) {
      if (r < 0) {
        m.warn("negative value provided to histogram " + this._descriptor.name + ": " + r);
        return;
      }
      this._record(r, n, i);
    }, t;
  }(yr)
), mr = (
  /** @class */
  function() {
    function e(t, r, n) {
      this._observableRegistry = n, this._descriptor = t, this._metricStorages = r;
    }
    return e.prototype.addCallback = function(t) {
      this._observableRegistry.addCallback(t, this);
    }, e.prototype.removeCallback = function(t) {
      this._observableRegistry.removeCallback(t, this);
    }, e;
  }()
), C_ = (
  /** @class */
  function(e) {
    ke(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(mr)
), M_ = (
  /** @class */
  function(e) {
    ke(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(mr)
), I_ = (
  /** @class */
  function(e) {
    ke(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(mr)
);
function wn(e) {
  return e instanceof mr;
}
var x_ = (
  /** @class */
  function() {
    function e(t) {
      this._meterSharedState = t;
    }
    return e.prototype.createGauge = function(t, r) {
      var n = fe(t, S.GAUGE, r), i = this._meterSharedState.registerMetricStorage(n);
      return new P_(i, n);
    }, e.prototype.createHistogram = function(t, r) {
      var n = fe(t, S.HISTOGRAM, r), i = this._meterSharedState.registerMetricStorage(n);
      return new N_(i, n);
    }, e.prototype.createCounter = function(t, r) {
      var n = fe(t, S.COUNTER, r), i = this._meterSharedState.registerMetricStorage(n);
      return new L_(i, n);
    }, e.prototype.createUpDownCounter = function(t, r) {
      var n = fe(t, S.UP_DOWN_COUNTER, r), i = this._meterSharedState.registerMetricStorage(n);
      return new R_(i, n);
    }, e.prototype.createObservableGauge = function(t, r) {
      var n = fe(t, S.OBSERVABLE_GAUGE, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new M_(n, i, this._meterSharedState.observableRegistry);
    }, e.prototype.createObservableCounter = function(t, r) {
      var n = fe(t, S.OBSERVABLE_COUNTER, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new C_(n, i, this._meterSharedState.observableRegistry);
    }, e.prototype.createObservableUpDownCounter = function(t, r) {
      var n = fe(t, S.OBSERVABLE_UP_DOWN_COUNTER, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new I_(n, i, this._meterSharedState.observableRegistry);
    }, e.prototype.addBatchObservableCallback = function(t, r) {
      this._meterSharedState.observableRegistry.addBatchCallback(t, r);
    }, e.prototype.removeBatchObservableCallback = function(t, r) {
      this._meterSharedState.observableRegistry.removeBatchCallback(t, r);
    }, e;
  }()
), rs = (
  /** @class */
  function() {
    function e(t) {
      this._instrumentDescriptor = t;
    }
    return e.prototype.getInstrumentDescriptor = function() {
      return this._instrumentDescriptor;
    }, e.prototype.updateDescription = function(t) {
      this._instrumentDescriptor = fe(this._instrumentDescriptor.name, this._instrumentDescriptor.type, {
        description: t,
        valueType: this._instrumentDescriptor.valueType,
        unit: this._instrumentDescriptor.unit,
        advice: this._instrumentDescriptor.advice
      });
    }, e;
  }()
), D_ = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ro = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, U_ = (
  /** @class */
  function() {
    function e(t) {
      this._hash = t, this._valueMap = /* @__PURE__ */ new Map(), this._keyMap = /* @__PURE__ */ new Map();
    }
    return e.prototype.get = function(t, r) {
      return r != null || (r = this._hash(t)), this._valueMap.get(r);
    }, e.prototype.getOrDefault = function(t, r) {
      var n = this._hash(t);
      if (this._valueMap.has(n))
        return this._valueMap.get(n);
      var i = r();
      return this._keyMap.has(n) || this._keyMap.set(n, t), this._valueMap.set(n, i), i;
    }, e.prototype.set = function(t, r, n) {
      n != null || (n = this._hash(t)), this._keyMap.has(n) || this._keyMap.set(n, t), this._valueMap.set(n, r);
    }, e.prototype.has = function(t, r) {
      return r != null || (r = this._hash(t)), this._valueMap.has(r);
    }, e.prototype.keys = function() {
      var t, r;
      return ro(this, function(n) {
        switch (n.label) {
          case 0:
            t = this._keyMap.entries(), r = t.next(), n.label = 1;
          case 1:
            return r.done === !0 ? [3, 3] : [4, [r.value[1], r.value[0]]];
          case 2:
            return n.sent(), r = t.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, e.prototype.entries = function() {
      var t, r;
      return ro(this, function(n) {
        switch (n.label) {
          case 0:
            t = this._valueMap.entries(), r = t.next(), n.label = 1;
          case 1:
            return r.done === !0 ? [3, 3] : [4, [this._keyMap.get(r.value[0]), r.value[1], r.value[0]]];
          case 2:
            return n.sent(), r = t.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, Object.defineProperty(e.prototype, "size", {
      get: function() {
        return this._valueMap.size;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
), Le = (
  /** @class */
  function(e) {
    D_(t, e);
    function t() {
      return e.call(this, za) || this;
    }
    return t;
  }(U_)
), k_ = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ns = (
  /** @class */
  function() {
    function e(t, r) {
      this._aggregator = t, this._activeCollectionStorage = new Le(), this._cumulativeMemoStorage = new Le(), this._overflowAttributes = { "otel.metric.overflow": !0 }, this._cardinalityLimit = (r != null ? r : 2e3) - 1, this._overflowHashCode = za(this._overflowAttributes);
    }
    return e.prototype.record = function(t, r, n, i) {
      var o = this, a = this._activeCollectionStorage.get(r);
      if (!a) {
        if (this._activeCollectionStorage.size >= this._cardinalityLimit) {
          var u = this._activeCollectionStorage.getOrDefault(this._overflowAttributes, function() {
            return o._aggregator.createAccumulation(i);
          });
          u == null || u.record(t);
          return;
        }
        a = this._aggregator.createAccumulation(i), this._activeCollectionStorage.set(r, a);
      }
      a == null || a.record(t);
    }, e.prototype.batchCumulate = function(t, r) {
      var n = this;
      Array.from(t.entries()).forEach(function(i) {
        var o = k_(i, 3), a = o[0], u = o[1], c = o[2], s = n._aggregator.createAccumulation(r);
        s == null || s.record(u);
        var l = s;
        if (n._cumulativeMemoStorage.has(a, c)) {
          var f = n._cumulativeMemoStorage.get(a, c);
          l = n._aggregator.diff(f, s);
        } else if (n._cumulativeMemoStorage.size >= n._cardinalityLimit && (a = n._overflowAttributes, c = n._overflowHashCode, n._cumulativeMemoStorage.has(a, c))) {
          var f = n._cumulativeMemoStorage.get(a, c);
          l = n._aggregator.diff(f, s);
        }
        if (n._activeCollectionStorage.has(a, c)) {
          var d = n._activeCollectionStorage.get(a, c);
          l = n._aggregator.merge(d, l);
        }
        n._cumulativeMemoStorage.set(a, s, c), n._activeCollectionStorage.set(a, l, c);
      });
    }, e.prototype.collect = function() {
      var t = this._activeCollectionStorage;
      return this._activeCollectionStorage = new Le(), t;
    }, e;
  }()
), en = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, no = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, is = (
  /** @class */
  function() {
    function e(t, r) {
      var n = this;
      this._aggregator = t, this._unreportedAccumulations = /* @__PURE__ */ new Map(), this._reportHistory = /* @__PURE__ */ new Map(), r.forEach(function(i) {
        n._unreportedAccumulations.set(i, []);
      });
    }
    return e.prototype.buildMetrics = function(t, r, n, i) {
      this._stashAccumulations(n);
      var o = this._getMergedUnreportedAccumulations(t), a = o, u;
      if (this._reportHistory.has(t)) {
        var c = this._reportHistory.get(t), s = c.collectionTime;
        u = c.aggregationTemporality, u === Y.CUMULATIVE ? a = e.merge(c.accumulations, o, this._aggregator) : a = e.calibrateStartTime(c.accumulations, o, s);
      } else
        u = t.selectAggregationTemporality(r.type);
      this._reportHistory.set(t, {
        accumulations: a,
        collectionTime: i,
        aggregationTemporality: u
      });
      var l = B_(a);
      if (l.length !== 0)
        return this._aggregator.toMetricData(
          r,
          u,
          l,
          /* endTime */
          i
        );
    }, e.prototype._stashAccumulations = function(t) {
      var r, n, i = this._unreportedAccumulations.keys();
      try {
        for (var o = en(i), a = o.next(); !a.done; a = o.next()) {
          var u = a.value, c = this._unreportedAccumulations.get(u);
          c === void 0 && (c = [], this._unreportedAccumulations.set(u, c)), c.push(t);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (r) throw r.error;
        }
      }
    }, e.prototype._getMergedUnreportedAccumulations = function(t) {
      var r, n, i = new Le(), o = this._unreportedAccumulations.get(t);
      if (this._unreportedAccumulations.set(t, []), o === void 0)
        return i;
      try {
        for (var a = en(o), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          i = e.merge(i, c, this._aggregator);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          u && !u.done && (n = a.return) && n.call(a);
        } finally {
          if (r) throw r.error;
        }
      }
      return i;
    }, e.merge = function(t, r, n) {
      for (var i = t, o = r.entries(), a = o.next(); a.done !== !0; ) {
        var u = no(a.value, 3), c = u[0], s = u[1], l = u[2];
        if (t.has(c, l)) {
          var f = t.get(c, l), d = n.merge(f, s);
          i.set(c, d, l);
        } else
          i.set(c, s, l);
        a = o.next();
      }
      return i;
    }, e.calibrateStartTime = function(t, r, n) {
      var i, o;
      try {
        for (var a = en(t.keys()), u = a.next(); !u.done; u = a.next()) {
          var c = no(u.value, 2), s = c[0], l = c[1], f = r.get(s, l);
          f == null || f.setStartTime(n);
        }
      } catch (d) {
        i = { error: d };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
      return r;
    }, e;
  }()
);
function B_(e) {
  return Array.from(e.entries());
}
var H_ = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), G_ = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, F_ = (
  /** @class */
  function(e) {
    H_(t, e);
    function t(r, n, i, o, a) {
      var u = e.call(this, r) || this;
      return u._attributesProcessor = i, u._aggregationCardinalityLimit = a, u._deltaMetricStorage = new ns(n, u._aggregationCardinalityLimit), u._temporalMetricStorage = new is(n, o), u;
    }
    return t.prototype.record = function(r, n) {
      var i = this, o = new Le();
      Array.from(r.entries()).forEach(function(a) {
        var u = G_(a, 2), c = u[0], s = u[1];
        o.set(i._attributesProcessor.process(c), s);
      }), this._deltaMetricStorage.batchCumulate(o, n);
    }, t.prototype.collect = function(r, n) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(r, this._instrumentDescriptor, i, n);
    }, t;
  }(rs)
);
function io(e, t) {
  var r = "";
  return e.unit !== t.unit && (r += "	- Unit '" + e.unit + "' does not match '" + t.unit + `'
`), e.type !== t.type && (r += "	- Type '" + e.type + "' does not match '" + t.type + `'
`), e.valueType !== t.valueType && (r += "	- Value Type '" + e.valueType + "' does not match '" + t.valueType + `'
`), e.description !== t.description && (r += "	- Description '" + e.description + "' does not match '" + t.description + `'
`), r;
}
function j_(e, t) {
  return "	- use valueType '" + e.valueType + "' on instrument creation or use an instrument name other than '" + t.name + "'";
}
function V_(e, t) {
  return "	- use unit '" + e.unit + "' on instrument creation or use an instrument name other than '" + t.name + "'";
}
function $_(e, t) {
  var r = {
    name: t.name,
    type: t.type,
    unit: t.unit
  }, n = JSON.stringify(r);
  return "	- create a new view with a name other than '" + e.name + "' and InstrumentSelector '" + n + "'";
}
function z_(e, t) {
  var r = {
    name: t.name,
    type: t.type,
    unit: t.unit
  }, n = JSON.stringify(r);
  return "	- create a new view with a name other than '" + e.name + "' and InstrumentSelector '" + n + `'
    	- OR - create a new view with the name ` + e.name + " and description '" + e.description + "' and InstrumentSelector " + n + `
    	- OR - create a new view with the name ` + t.name + " and description '" + e.description + "' and InstrumentSelector " + n;
}
function oo(e, t) {
  return e.valueType !== t.valueType ? j_(e, t) : e.unit !== t.unit ? V_(e, t) : e.type !== t.type ? $_(e, t) : e.description !== t.description ? z_(e, t) : "";
}
var tn = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, X_ = (
  /** @class */
  function() {
    function e() {
      this._sharedRegistry = /* @__PURE__ */ new Map(), this._perCollectorRegistry = /* @__PURE__ */ new Map();
    }
    return e.create = function() {
      return new e();
    }, e.prototype.getStorages = function(t) {
      var r, n, i, o, a = [];
      try {
        for (var u = tn(this._sharedRegistry.values()), c = u.next(); !c.done; c = u.next()) {
          var s = c.value;
          a = a.concat(s);
        }
      } catch (h) {
        r = { error: h };
      } finally {
        try {
          c && !c.done && (n = u.return) && n.call(u);
        } finally {
          if (r) throw r.error;
        }
      }
      var l = this._perCollectorRegistry.get(t);
      if (l != null)
        try {
          for (var f = tn(l.values()), d = f.next(); !d.done; d = f.next()) {
            var s = d.value;
            a = a.concat(s);
          }
        } catch (h) {
          i = { error: h };
        } finally {
          try {
            d && !d.done && (o = f.return) && o.call(f);
          } finally {
            if (i) throw i.error;
          }
        }
      return a;
    }, e.prototype.register = function(t) {
      this._registerStorage(t, this._sharedRegistry);
    }, e.prototype.registerForCollector = function(t, r) {
      var n = this._perCollectorRegistry.get(t);
      n == null && (n = /* @__PURE__ */ new Map(), this._perCollectorRegistry.set(t, n)), this._registerStorage(r, n);
    }, e.prototype.findOrUpdateCompatibleStorage = function(t) {
      var r = this._sharedRegistry.get(t.name);
      return r === void 0 ? null : this._findOrUpdateCompatibleStorage(t, r);
    }, e.prototype.findOrUpdateCompatibleCollectorStorage = function(t, r) {
      var n = this._perCollectorRegistry.get(t);
      if (n === void 0)
        return null;
      var i = n.get(r.name);
      return i === void 0 ? null : this._findOrUpdateCompatibleStorage(r, i);
    }, e.prototype._registerStorage = function(t, r) {
      var n = t.getInstrumentDescriptor(), i = r.get(n.name);
      if (i === void 0) {
        r.set(n.name, [t]);
        return;
      }
      i.push(t);
    }, e.prototype._findOrUpdateCompatibleStorage = function(t, r) {
      var n, i, o = null;
      try {
        for (var a = tn(r), u = a.next(); !u.done; u = a.next()) {
          var c = u.value, s = c.getInstrumentDescriptor();
          Fh(s, t) ? (s.description !== t.description && (t.description.length > s.description.length && c.updateDescription(t.description), m.warn("A view or instrument with the name ", t.name, ` has already been registered, but has a different description and is incompatible with another registered view.
`, `Details:
`, io(s, t), `The longer description will be used.
To resolve the conflict:`, oo(s, t))), o = c) : m.warn("A view or instrument with the name ", t.name, ` has already been registered and is incompatible with another registered view.
`, `Details:
`, io(s, t), `To resolve the conflict:
`, oo(s, t));
        }
      } catch (l) {
        n = { error: l };
      } finally {
        try {
          u && !u.done && (i = a.return) && i.call(a);
        } finally {
          if (n) throw n.error;
        }
      }
      return o;
    }, e;
  }()
), q_ = (
  /** @class */
  function() {
    function e(t) {
      this._backingStorages = t;
    }
    return e.prototype.record = function(t, r, n, i) {
      this._backingStorages.forEach(function(o) {
        o.record(t, r, n, i);
      });
    }, e;
  }()
), W_ = (
  /** @class */
  function() {
    function e(t, r) {
      this._instrumentName = t, this._valueType = r, this._buffer = new Le();
    }
    return e.prototype.observe = function(t, r) {
      if (r === void 0 && (r = {}), typeof t != "number") {
        m.warn("non-number value provided to metric " + this._instrumentName + ": " + t);
        return;
      }
      this._valueType === ve.INT && !Number.isInteger(t) && (m.warn("INT value type cannot accept a floating-point value for " + this._instrumentName + ", ignoring the fractional digits."), t = Math.trunc(t), !Number.isInteger(t)) || this._buffer.set(r, t);
    }, e;
  }()
), K_ = (
  /** @class */
  function() {
    function e() {
      this._buffer = /* @__PURE__ */ new Map();
    }
    return e.prototype.observe = function(t, r, n) {
      if (n === void 0 && (n = {}), !!wn(t)) {
        var i = this._buffer.get(t);
        if (i == null && (i = new Le(), this._buffer.set(t, i)), typeof r != "number") {
          m.warn("non-number value provided to metric " + t._descriptor.name + ": " + r);
          return;
        }
        t._descriptor.valueType === ve.INT && !Number.isInteger(r) && (m.warn("INT value type cannot accept a floating-point value for " + t._descriptor.name + ", ignoring the fractional digits."), r = Math.trunc(r), !Number.isInteger(r)) || i.set(n, r);
      }
    }, e;
  }()
), rn = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, nn = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, ao = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, so = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Y_ = (
  /** @class */
  function() {
    function e() {
      this._callbacks = [], this._batchCallbacks = [];
    }
    return e.prototype.addCallback = function(t, r) {
      var n = this._findCallback(t, r);
      n >= 0 || this._callbacks.push({ callback: t, instrument: r });
    }, e.prototype.removeCallback = function(t, r) {
      var n = this._findCallback(t, r);
      n < 0 || this._callbacks.splice(n, 1);
    }, e.prototype.addBatchCallback = function(t, r) {
      var n = new Set(r.filter(wn));
      if (n.size === 0) {
        m.error("BatchObservableCallback is not associated with valid instruments", r);
        return;
      }
      var i = this._findBatchCallback(t, n);
      i >= 0 || this._batchCallbacks.push({ callback: t, instruments: n });
    }, e.prototype.removeBatchCallback = function(t, r) {
      var n = new Set(r.filter(wn)), i = this._findBatchCallback(t, n);
      i < 0 || this._batchCallbacks.splice(i, 1);
    }, e.prototype.observe = function(t, r) {
      return rn(this, void 0, void 0, function() {
        var n, i, o, a;
        return nn(this, function(u) {
          switch (u.label) {
            case 0:
              return n = this._observeCallbacks(t, r), i = this._observeBatchCallbacks(t, r), [4, xh(so(so([], ao(n), !1), ao(i), !1))];
            case 1:
              return o = u.sent(), a = o.filter(Dh).map(function(c) {
                return c.reason;
              }), [2, a];
          }
        });
      });
    }, e.prototype._observeCallbacks = function(t, r) {
      var n = this;
      return this._callbacks.map(function(i) {
        var o = i.callback, a = i.instrument;
        return rn(n, void 0, void 0, function() {
          var u, c;
          return nn(this, function(s) {
            switch (s.label) {
              case 0:
                return u = new W_(a._descriptor.name, a._descriptor.valueType), c = Promise.resolve(o(u)), r != null && (c = gt(c, r)), [4, c];
              case 1:
                return s.sent(), a._metricStorages.forEach(function(l) {
                  l.record(u._buffer, t);
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, e.prototype._observeBatchCallbacks = function(t, r) {
      var n = this;
      return this._batchCallbacks.map(function(i) {
        var o = i.callback, a = i.instruments;
        return rn(n, void 0, void 0, function() {
          var u, c;
          return nn(this, function(s) {
            switch (s.label) {
              case 0:
                return u = new K_(), c = Promise.resolve(o(u)), r != null && (c = gt(c, r)), [4, c];
              case 1:
                return s.sent(), a.forEach(function(l) {
                  var f = u._buffer.get(l);
                  f != null && l._metricStorages.forEach(function(d) {
                    d.record(f, t);
                  });
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, e.prototype._findCallback = function(t, r) {
      return this._callbacks.findIndex(function(n) {
        return n.callback === t && n.instrument === r;
      });
    }, e.prototype._findBatchCallback = function(t, r) {
      return this._batchCallbacks.findIndex(function(n) {
        return n.callback === t && Uh(n.instruments, r);
      });
    }, e;
  }()
), J_ = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Z_ = (
  /** @class */
  function(e) {
    J_(t, e);
    function t(r, n, i, o, a) {
      var u = e.call(this, r) || this;
      return u._attributesProcessor = i, u._aggregationCardinalityLimit = a, u._deltaMetricStorage = new ns(n, u._aggregationCardinalityLimit), u._temporalMetricStorage = new is(n, o), u;
    }
    return t.prototype.record = function(r, n, i, o) {
      n = this._attributesProcessor.process(n, i), this._deltaMetricStorage.record(r, n, i, o);
    }, t.prototype.collect = function(r, n) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(r, this._instrumentDescriptor, i, n);
    }, t;
  }(rs)
), os = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), qn = (
  /** @class */
  function() {
    function e() {
    }
    return e.Noop = function() {
      return ev;
    }, e;
  }()
), Q_ = (
  /** @class */
  function(e) {
    os(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.process = function(r, n) {
      return r;
    }, t;
  }(qn)
);
(function(e) {
  os(t, e);
  function t(r) {
    var n = e.call(this) || this;
    return n._allowedAttributeNames = r, n;
  }
  return t.prototype.process = function(r, n) {
    var i = this, o = {};
    return Object.keys(r).filter(function(a) {
      return i._allowedAttributeNames.includes(a);
    }).forEach(function(a) {
      return o[a] = r[a];
    }), o;
  }, t;
})(qn);
var ev = new Q_(), tv = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, rv = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, nv = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, iv = (
  /** @class */
  function() {
    function e(t, r) {
      this._meterProviderSharedState = t, this._instrumentationScope = r, this.metricStorageRegistry = new X_(), this.observableRegistry = new Y_(), this.meter = new x_(this);
    }
    return e.prototype.registerMetricStorage = function(t) {
      var r = this._registerMetricStorage(t, Z_);
      return r.length === 1 ? r[0] : new q_(r);
    }, e.prototype.registerAsyncMetricStorage = function(t) {
      var r = this._registerMetricStorage(t, F_);
      return r;
    }, e.prototype.collect = function(t, r, n) {
      return tv(this, void 0, void 0, function() {
        var i, o, a;
        return rv(this, function(u) {
          switch (u.label) {
            case 0:
              return [4, this.observableRegistry.observe(r, n == null ? void 0 : n.timeoutMillis)];
            case 1:
              return i = u.sent(), o = this.metricStorageRegistry.getStorages(t), o.length === 0 ? [2, null] : (a = o.map(function(c) {
                return c.collect(t, r);
              }).filter(Mh), a.length === 0 ? [2, { errors: i }] : [2, {
                scopeMetrics: {
                  scope: this._instrumentationScope,
                  metrics: a
                },
                errors: i
              }]);
          }
        });
      });
    }, e.prototype._registerMetricStorage = function(t, r) {
      var n = this, i = this._meterProviderSharedState.viewRegistry.findViews(t, this._instrumentationScope), o = i.map(function(c) {
        var s = Gh(c, t), l = n.metricStorageRegistry.findOrUpdateCompatibleStorage(s);
        if (l != null)
          return l;
        var f = c.aggregation.createAggregator(s), d = new r(s, f, c.attributesProcessor, n._meterProviderSharedState.metricCollectors, c.aggregationCardinalityLimit);
        return n.metricStorageRegistry.register(d), d;
      });
      if (o.length === 0) {
        var a = this._meterProviderSharedState.selectAggregations(t.type), u = a.map(function(c) {
          var s = nv(c, 2), l = s[0], f = s[1], d = n.metricStorageRegistry.findOrUpdateCompatibleCollectorStorage(l, t);
          if (d != null)
            return d;
          var h = f.createAggregator(t), _ = l.selectCardinalityLimit(t.type), p = new r(t, h, qn.Noop(), [l], _);
          return n.metricStorageRegistry.registerForCollector(l, p), p;
        });
        o = o.concat(u);
      }
      return o;
    }, e;
  }()
), ov = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, av = (
  /** @class */
  function() {
    function e(t) {
      this.resource = t, this.viewRegistry = new O_(), this.metricCollectors = [], this.meterSharedStates = /* @__PURE__ */ new Map();
    }
    return e.prototype.getMeterSharedState = function(t) {
      var r = Ih(t), n = this.meterSharedStates.get(r);
      return n == null && (n = new iv(this, t), this.meterSharedStates.set(r, n)), n;
    }, e.prototype.selectAggregations = function(t) {
      var r, n, i = [];
      try {
        for (var o = ov(this.metricCollectors), a = o.next(); !a.done; a = o.next()) {
          var u = a.value;
          i.push([u, u.selectAggregation(t)]);
        }
      } catch (c) {
        r = { error: c };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (r) throw r.error;
        }
      }
      return i;
    }, e;
  }()
), Ht = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Gt = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, sv = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, uv = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, cv = (
  /** @class */
  function() {
    function e(t, r) {
      this._sharedState = t, this._metricReader = r;
    }
    return e.prototype.collect = function(t) {
      return Ht(this, void 0, void 0, function() {
        var r, n, i, o, a = this;
        return Gt(this, function(u) {
          switch (u.label) {
            case 0:
              return r = X(Date.now()), n = [], i = [], o = Array.from(this._sharedState.meterSharedStates.values()).map(function(c) {
                return Ht(a, void 0, void 0, function() {
                  var s;
                  return Gt(this, function(l) {
                    switch (l.label) {
                      case 0:
                        return [4, c.collect(this, r, t)];
                      case 1:
                        return s = l.sent(), (s == null ? void 0 : s.scopeMetrics) != null && n.push(s.scopeMetrics), (s == null ? void 0 : s.errors) != null && i.push.apply(i, uv([], sv(s.errors), !1)), [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }), [4, Promise.all(o)];
            case 1:
              return u.sent(), [2, {
                resourceMetrics: {
                  resource: this._sharedState.resource,
                  scopeMetrics: n
                },
                errors: i
              }];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return Ht(this, void 0, void 0, function() {
        return Gt(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._metricReader.forceFlush(t)];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.shutdown = function(t) {
      return Ht(this, void 0, void 0, function() {
        return Gt(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._metricReader.shutdown(t)];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.selectAggregationTemporality = function(t) {
      return this._metricReader.selectAggregationTemporality(t);
    }, e.prototype.selectAggregation = function(t) {
      return this._metricReader.selectAggregation(t);
    }, e.prototype.selectCardinalityLimit = function(t) {
      var r, n, i;
      return (i = (n = (r = this._metricReader).selectCardinalityLimit) === null || n === void 0 ? void 0 : n.call(r, t)) !== null && i !== void 0 ? i : 2e3;
    }, e;
  }()
), uo = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, co = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, lo = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function lv(e, t) {
  var r = t != null ? t : mt.empty();
  return e ? mt.default().merge(r) : r;
}
var fv = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i, o, a;
      if (this._shutdown = !1, this._sharedState = new av(lv((a = t == null ? void 0 : t.mergeResourceWithDefaults) !== null && a !== void 0 ? a : !0, t == null ? void 0 : t.resource)), (t == null ? void 0 : t.views) != null && t.views.length > 0)
        try {
          for (var u = lo(t.views), c = u.next(); !c.done; c = u.next()) {
            var s = c.value;
            this._sharedState.viewRegistry.addView(s);
          }
        } catch (h) {
          r = { error: h };
        } finally {
          try {
            c && !c.done && (n = u.return) && n.call(u);
          } finally {
            if (r) throw r.error;
          }
        }
      if ((t == null ? void 0 : t.readers) != null && t.readers.length > 0)
        try {
          for (var l = lo(t.readers), f = l.next(); !f.done; f = l.next()) {
            var d = f.value;
            this.addMetricReader(d);
          }
        } catch (h) {
          i = { error: h };
        } finally {
          try {
            f && !f.done && (o = l.return) && o.call(l);
          } finally {
            if (i) throw i.error;
          }
        }
    }
    return e.prototype.getMeter = function(t, r, n) {
      return r === void 0 && (r = ""), n === void 0 && (n = {}), this._shutdown ? (m.warn("A shutdown MeterProvider cannot provide a Meter"), Ec()) : this._sharedState.getMeterSharedState({
        name: t,
        version: r,
        schemaUrl: n.schemaUrl
      }).meter;
    }, e.prototype.addMetricReader = function(t) {
      var r = new cv(this._sharedState, t);
      t.setMetricProducer(r), this._sharedState.metricCollectors.push(r);
    }, e.prototype.shutdown = function(t) {
      return uo(this, void 0, void 0, function() {
        return co(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (m.warn("shutdown may only be called once per MeterProvider"), [
                2
                /*return*/
              ]) : (this._shutdown = !0, [4, Promise.all(this._sharedState.metricCollectors.map(function(n) {
                return n.shutdown(t);
              }))]);
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return uo(this, void 0, void 0, function() {
        return co(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (m.warn("invalid attempt to force flush after MeterProvider shutdown"), [
                2
                /*return*/
              ]) : [4, Promise.all(this._sharedState.metricCollectors.map(function(n) {
                return n.forceFlush(t);
              }))];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function dv(e, t) {
  var r = Ga(t);
  return {
    resource: Fa(e.resource),
    schemaUrl: void 0,
    scopeMetrics: pv(e.scopeMetrics, r)
  };
}
function pv(e, t) {
  return Array.from(e.map(function(r) {
    return {
      scope: ja(r.scope),
      metrics: r.metrics.map(function(n) {
        return hv(n, t);
      }),
      schemaUrl: r.scope.schemaUrl
    };
  }));
}
function hv(e, t) {
  var r = {
    name: e.descriptor.name,
    description: e.descriptor.description,
    unit: e.descriptor.unit
  }, n = mv(e.aggregationTemporality);
  switch (e.dataPointType) {
    case te.SUM:
      r.sum = {
        aggregationTemporality: n,
        isMonotonic: e.isMonotonic,
        dataPoints: fo(e, t)
      };
      break;
    case te.GAUGE:
      r.gauge = {
        dataPoints: fo(e, t)
      };
      break;
    case te.HISTOGRAM:
      r.histogram = {
        aggregationTemporality: n,
        dataPoints: vv(e, t)
      };
      break;
    case te.EXPONENTIAL_HISTOGRAM:
      r.exponentialHistogram = {
        aggregationTemporality: n,
        dataPoints: yv(e, t)
      };
      break;
  }
  return r;
}
function _v(e, t, r) {
  var n = {
    attributes: De(e.attributes),
    startTimeUnixNano: r.encodeHrTime(e.startTime),
    timeUnixNano: r.encodeHrTime(e.endTime)
  };
  switch (t) {
    case ve.INT:
      n.asInt = e.value;
      break;
    case ve.DOUBLE:
      n.asDouble = e.value;
      break;
  }
  return n;
}
function fo(e, t) {
  return e.dataPoints.map(function(r) {
    return _v(r, e.descriptor.valueType, t);
  });
}
function vv(e, t) {
  return e.dataPoints.map(function(r) {
    var n = r.value;
    return {
      attributes: De(r.attributes),
      bucketCounts: n.buckets.counts,
      explicitBounds: n.buckets.boundaries,
      count: n.count,
      sum: n.sum,
      min: n.min,
      max: n.max,
      startTimeUnixNano: t.encodeHrTime(r.startTime),
      timeUnixNano: t.encodeHrTime(r.endTime)
    };
  });
}
function yv(e, t) {
  return e.dataPoints.map(function(r) {
    var n = r.value;
    return {
      attributes: De(r.attributes),
      count: n.count,
      min: n.min,
      max: n.max,
      sum: n.sum,
      positive: {
        offset: n.positive.offset,
        bucketCounts: n.positive.bucketCounts
      },
      negative: {
        offset: n.negative.offset,
        bucketCounts: n.negative.bucketCounts
      },
      scale: n.scale,
      zeroCount: n.zeroCount,
      startTimeUnixNano: t.encodeHrTime(r.startTime),
      timeUnixNano: t.encodeHrTime(r.endTime)
    };
  });
}
function mv(e) {
  switch (e) {
    case Y.DELTA:
      return 1;
    case Y.CUMULATIVE:
      return 2;
  }
}
function gv(e, t) {
  return {
    resourceMetrics: e.map(function(r) {
      return dv(r, t);
    })
  };
}
var Ev = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Tv = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Sv(e, t) {
  var r, n = e.spanContext(), i = e.status;
  return {
    traceId: t.encodeSpanContext(n.traceId),
    spanId: t.encodeSpanContext(n.spanId),
    parentSpanId: t.encodeOptionalSpanContext(e.parentSpanId),
    traceState: (r = n.traceState) === null || r === void 0 ? void 0 : r.serialize(),
    name: e.name,
    // Span kind is offset by 1 because the API does not define a value for unset
    kind: e.kind == null ? 0 : e.kind + 1,
    startTimeUnixNano: t.encodeHrTime(e.startTime),
    endTimeUnixNano: t.encodeHrTime(e.endTime),
    attributes: De(e.attributes),
    droppedAttributesCount: e.droppedAttributesCount,
    events: e.events.map(function(o) {
      return wv(o, t);
    }),
    droppedEventsCount: e.droppedEventsCount,
    status: {
      // API and proto enums share the same values
      code: i.code,
      message: i.message
    },
    links: e.links.map(function(o) {
      return bv(o, t);
    }),
    droppedLinksCount: e.droppedLinksCount
  };
}
function bv(e, t) {
  var r;
  return {
    attributes: e.attributes ? De(e.attributes) : [],
    spanId: t.encodeSpanContext(e.context.spanId),
    traceId: t.encodeSpanContext(e.context.traceId),
    traceState: (r = e.context.traceState) === null || r === void 0 ? void 0 : r.serialize(),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
function wv(e, t) {
  return {
    attributes: e.attributes ? De(e.attributes) : [],
    name: e.name,
    timeUnixNano: t.encodeHrTime(e.time),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
function Av(e, t) {
  var r = Ga(t);
  return {
    resourceSpans: Rv(e, r)
  };
}
function Ov(e) {
  var t, r, n = /* @__PURE__ */ new Map();
  try {
    for (var i = Ev(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value, u = n.get(a.resource);
      u || (u = /* @__PURE__ */ new Map(), n.set(a.resource, u));
      var c = a.instrumentationLibrary.name + "@" + (a.instrumentationLibrary.version || "") + ":" + (a.instrumentationLibrary.schemaUrl || ""), s = u.get(c);
      s || (s = [], u.set(c, s)), s.push(a);
    }
  } catch (l) {
    t = { error: l };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
function Rv(e, t) {
  for (var r = Ov(e), n = [], i = r.entries(), o = i.next(); !o.done; ) {
    for (var a = Tv(o.value, 2), u = a[0], c = a[1], s = [], l = c.values(), f = l.next(); !f.done; ) {
      var d = f.value;
      if (d.length > 0) {
        var h = d.map(function(p) {
          return Sv(p, t);
        });
        s.push({
          scope: ja(d[0].instrumentationLibrary),
          spans: h,
          schemaUrl: d[0].instrumentationLibrary.schemaUrl
        });
      }
      f = l.next();
    }
    var _ = {
      resource: Fa(u),
      scopeSpans: s,
      schemaUrl: void 0
    };
    n.push(_), o = i.next();
  }
  return n;
}
var as = {
  serializeRequest: function(e) {
    var t = gv([e], {
      useLongBits: !1
    }), r = new TextEncoder();
    return r.encode(JSON.stringify(t));
  },
  deserializeResponse: function(e) {
    var t = new TextDecoder();
    return JSON.parse(t.decode(e));
  }
}, ss = {
  serializeRequest: function(e) {
    var t = Av(e, {
      useHex: !0,
      useLongBits: !1
    }), r = new TextEncoder();
    return r.encode(JSON.stringify(t));
  },
  deserializeResponse: function(e) {
    var t = new TextDecoder();
    return JSON.parse(t.decode(e));
  }
}, Lv = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Pv = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Nv = 5, Cv = 1e3, Mv = 5e3, Iv = 1.5, po = 0.2;
function xv() {
  return Math.random() * (2 * po) - po;
}
var Dv = (
  /** @class */
  function() {
    function e(t) {
      this._transport = t;
    }
    return e.prototype.retry = function(t, r, n) {
      var i = this;
      return new Promise(function(o, a) {
        setTimeout(function() {
          i._transport.send(t, r).then(o, a);
        }, n);
      });
    }, e.prototype.send = function(t, r) {
      var n;
      return Lv(this, void 0, void 0, function() {
        var i, o, a, u, c, s, l;
        return Pv(this, function(f) {
          switch (f.label) {
            case 0:
              return i = Date.now() + r, [4, this._transport.send(t, r)];
            case 1:
              o = f.sent(), a = Nv, u = Cv, f.label = 2;
            case 2:
              return o.status === "retryable" && a > 0 ? (a--, c = Math.max(Math.min(u, Mv) + xv(), 0), u = u * Iv, s = (n = o.retryInMillis) !== null && n !== void 0 ? n : c, l = i - Date.now(), s > l ? [2, o] : [4, this.retry(t, l, s)]) : [3, 4];
            case 3:
              return o = f.sent(), [3, 2];
            case 4:
              return [2, o];
          }
        });
      });
    }, e.prototype.shutdown = function() {
      return this._transport.shutdown();
    }, e;
  }()
);
function us(e) {
  return new Dv(e.transport);
}
function Uv(e) {
  var t = [429, 502, 503, 504];
  return t.includes(e);
}
function kv(e) {
  if (e != null) {
    var t = Number.parseInt(e, 10);
    if (Number.isInteger(t))
      return t > 0 ? t * 1e3 : -1;
    var r = new Date(e).getTime() - Date.now();
    return r >= 0 ? r : 0;
  }
}
var Bv = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Hv = (
  /** @class */
  function() {
    function e(t) {
      this._parameters = t;
    }
    return e.prototype.send = function(t, r) {
      var n = this;
      return new Promise(function(i) {
        var o = new XMLHttpRequest();
        o.timeout = r, o.open("POST", n._parameters.url);
        var a = n._parameters.headers();
        Object.entries(a).forEach(function(u) {
          var c = Bv(u, 2), s = c[0], l = c[1];
          o.setRequestHeader(s, l);
        }), o.ontimeout = function(u) {
          i({
            status: "failure",
            error: new Error("XHR request timed out")
          });
        }, o.onreadystatechange = function() {
          o.status >= 200 && o.status <= 299 ? (m.debug("XHR success"), i({
            status: "success"
          })) : o.status && Uv(o.status) ? i({
            status: "retryable",
            retryInMillis: kv(o.getResponseHeader("Retry-After"))
          }) : o.status !== 0 && i({
            status: "failure",
            error: new Error("XHR request failed with non-retryable status")
          });
        }, o.onabort = function() {
          i({
            status: "failure",
            error: new Error("XHR request aborted")
          });
        }, o.onerror = function() {
          i({
            status: "failure",
            error: new Error("XHR request errored")
          });
        }, o.send(t);
      });
    }, e.prototype.shutdown = function() {
    }, e;
  }()
);
function Gv(e) {
  return new Hv(e);
}
var Fv = (
  /** @class */
  function() {
    function e(t) {
      this._params = t;
    }
    return e.prototype.send = function(t) {
      var r = this;
      return new Promise(function(n) {
        navigator.sendBeacon(r._params.url, new Blob([t], { type: r._params.blobType })) ? (m.debug("SendBeacon success"), n({
          status: "success"
        })) : n({
          status: "failure",
          error: new Error("SendBeacon failed")
        });
      });
    }, e.prototype.shutdown = function() {
    }, e;
  }()
);
function jv(e) {
  return new Fv(e);
}
function Vv(e, t) {
  return Ua(e, t, us({
    transport: Gv(e)
  }));
}
function $v(e, t) {
  return Ua(e, t, us({
    transport: jv({
      url: e.url,
      blobType: e.headers()["Content-Type"]
    })
  }));
}
var zv = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Xv(e) {
  return function() {
    var t, r = {};
    return Object.entries((t = e == null ? void 0 : e()) !== null && t !== void 0 ? t : {}).forEach(function(n) {
      var i = zv(n, 2), o = i[0], a = i[1];
      typeof a != "undefined" ? r[o] = String(a) : m.warn('Header "' + o + '" has invalid value (' + a + ") and will be ignored");
    }), r;
  };
}
var Ie = function() {
  return Ie = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Ie.apply(this, arguments);
};
function qv(e, t, r) {
  var n = Ie({}, r()), i = {};
  return function() {
    return t != null && Object.assign(i, t()), e != null && Object.assign(i, e()), Object.assign(i, n);
  };
}
function Wv(e) {
  if (e != null)
    try {
      return new URL(e), e;
    } catch (t) {
      throw new Error("Configuration: Could not parse user-provided export URL: '" + e + "'");
    }
}
function Kv(e, t, r) {
  var n, i, o, a;
  return Ie(Ie({}, fh(e, t, r)), { headers: qv(Xv(e.headers), t.headers, r.headers), url: (i = (n = Wv(e.url)) !== null && n !== void 0 ? n : t.url) !== null && i !== void 0 ? i : r.url, agentOptions: (a = (o = e.agentOptions) !== null && o !== void 0 ? o : t.agentOptions) !== null && a !== void 0 ? a : r.agentOptions });
}
function Yv(e, t) {
  return Ie(Ie({}, dh()), { headers: function() {
    return e;
  }, url: "http://localhost:4318/" + t, agentOptions: { keepAlive: !0 } });
}
function Jv(e, t, r) {
  return Kv(
    {
      url: e.url,
      timeoutMillis: e.timeoutMillis,
      headers: lh(e.headers),
      concurrencyLimit: e.concurrencyLimit
    },
    {},
    // no fallback for browser case
    Yv(r, t)
  );
}
function cs(e, t, r, n) {
  var i = !!e.headers || typeof navigator.sendBeacon != "function", o = Jv(e, r, n);
  return i ? Vv(o, t) : $v(o, t);
}
var Zv = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Qv = (
  /** @class */
  function(e) {
    Zv(t, e);
    function t(r) {
      return r === void 0 && (r = {}), e.call(this, cs(r, ss, "v1/traces", { "Content-Type": "application/json" })) || this;
    }
    return t;
  }(Da)
), ar;
(function(e) {
  e[e.DELTA = 0] = "DELTA", e[e.CUMULATIVE = 1] = "CUMULATIVE", e[e.LOWMEMORY = 2] = "LOWMEMORY";
})(ar || (ar = {}));
var ey = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), An = function() {
  return Y.CUMULATIVE;
}, ls = function(e) {
  switch (e) {
    case S.COUNTER:
    case S.OBSERVABLE_COUNTER:
    case S.GAUGE:
    case S.HISTOGRAM:
    case S.OBSERVABLE_GAUGE:
      return Y.DELTA;
    case S.UP_DOWN_COUNTER:
    case S.OBSERVABLE_UP_DOWN_COUNTER:
      return Y.CUMULATIVE;
  }
}, fs = function(e) {
  switch (e) {
    case S.COUNTER:
    case S.HISTOGRAM:
      return Y.DELTA;
    case S.GAUGE:
    case S.UP_DOWN_COUNTER:
    case S.OBSERVABLE_UP_DOWN_COUNTER:
    case S.OBSERVABLE_COUNTER:
    case S.OBSERVABLE_GAUGE:
      return Y.CUMULATIVE;
  }
};
function ty() {
  var e = Ke(), t = e.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE.trim().toLowerCase();
  return t === "cumulative" ? An : t === "delta" ? ls : t === "lowmemory" ? fs : (m.warn("OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE is set to '" + e.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE + "', but only 'cumulative' and 'delta' are allowed. Using default ('cumulative') instead."), An);
}
function ry(e) {
  return e != null ? e === ar.DELTA ? ls : e === ar.LOWMEMORY ? fs : An : ty();
}
function ny(e) {
  return e != null && e.aggregationPreference ? e.aggregationPreference : function(t) {
    return ce.Default();
  };
}
var iy = (
  /** @class */
  function(e) {
    ey(t, e);
    function t(r, n) {
      var i = e.call(this, r) || this;
      return i._aggregationSelector = ny(n), i._aggregationTemporalitySelector = ry(n == null ? void 0 : n.temporalityPreference), i;
    }
    return t.prototype.selectAggregation = function(r) {
      return this._aggregationSelector(r);
    }, t.prototype.selectAggregationTemporality = function(r) {
      return this._aggregationTemporalitySelector(r);
    }, t;
  }(Da)
), oy = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ay = (
  /** @class */
  function(e) {
    oy(t, e);
    function t(r) {
      return e.call(this, cs(r != null ? r : {}, as, "v1/metrics", { "Content-Type": "application/json" }), r) || this;
    }
    return t;
  }(iy)
);
function sy(e, t) {
  const r = e.spanContext();
  return {
    name: e.name,
    kind: e.kind,
    spanContext: () => r,
    parentSpanId: e.parentSpanId,
    startTime: e.startTime,
    endTime: e.endTime,
    status: e.status,
    attributes: ca(e.attributes, t),
    links: e.links,
    events: e.events,
    duration: e.duration,
    ended: e.ended,
    resource: e.resource,
    instrumentationLibrary: e.instrumentationLibrary,
    droppedAttributesCount: e.droppedAttributesCount,
    droppedEventsCount: e.droppedEventsCount,
    droppedLinksCount: e.droppedLinksCount
  };
}
function uy(e, t) {
  if (!t.isSamplingEnabled())
    return e;
  const r = [], n = {}, i = {};
  for (const o of e) {
    o.parentSpanId && (i[o.parentSpanId] = i[o.parentSpanId] || [], i[o.parentSpanId].push(
      o.spanContext().spanId
    ));
    const a = t.shouldSample(o);
    a.sample ? a.attributes ? n[o.spanContext().spanId] = sy(
      o,
      a.attributes
    ) : n[o.spanContext().spanId] = o : r.push(o.spanContext().spanId);
  }
  for (; r.length > 0; ) {
    const o = r.shift(), a = i[o];
    if (a)
      for (const u of a)
        delete n[u], r.push(u);
  }
  return Object.values(n);
}
const cy = (e, t, r) => {
  if (typeof navigator == "undefined" || !navigator.sendBeacon)
    return !1;
  try {
    const n = new Blob([t], { type: r });
    return navigator.sendBeacon(e, n);
  } catch (n) {
    return !1;
  }
}, ds = (e, t, r, n) => {
  const i = (o) => {
    if (cy(e, t, r))
      return n({ code: N.SUCCESS });
    n({ code: N.FAILED, error: o });
  };
  try {
    const o = new Blob([t], { type: r });
    fetch(e, {
      method: "POST",
      body: o,
      keepalive: !0,
      headers: { "Content-Type": r },
      credentials: "omit"
    }).then(
      (a) => {
        if (a.ok)
          return n({ code: N.SUCCESS });
        n({
          code: N.FAILED,
          error: new Error(
            `keepalive fetch export failed with status ${a.status}`
          )
        });
      },
      // Promise rejection path: keepalive body-size overflow, network
      // error, CORS preflight failure, etc. This is where keepalive's
      // ~64KiB overflow lands — per WHATWG Fetch §4.6 it's an async
      // network error, not a synchronous throw.
      (a) => i(a)
    );
  } catch (o) {
    i(o);
  }
};
class ly extends Qv {
  constructor(r, n) {
    var i;
    super(I(E({}, r), {
      headers: {}
      // a truthy value enables sending with XHR instead of beacon
    }));
    b(this, "url");
    b(this, "unloading", !1);
    this.sampler = n, this.url = (i = r == null ? void 0 : r.url) != null ? i : "";
  }
  setUnloading(r) {
    this.unloading = r;
  }
  export(r, n) {
    const i = uy(r, this.sampler);
    if (i.length === 0)
      return;
    if (this.unloading) {
      const u = ss.serializeRequest(i);
      if (!u || !this.url)
        return n({
          code: N.FAILED,
          error: new Error(
            "keepalive export failed: serializer returned empty or url missing"
          )
        });
      ds(
        this.url,
        u,
        "application/json",
        n
      );
      return;
    }
    let o = 0;
    const a = (u) => {
      if (u.code === N.SUCCESS)
        return n({
          code: N.SUCCESS
        });
      if (o++, o > Io)
        return n({
          code: N.FAILED,
          error: u.error
        });
      new Promise(
        (c) => setTimeout(
          c,
          xo + Do * Math.pow(2, o)
        )
      ).then(() => {
        super.export(i, a);
      });
    };
    super.export(i, a);
  }
}
class fy extends ay {
  constructor(r) {
    var n;
    super(I(E({}, r), {
      headers: {}
    }));
    b(this, "url");
    b(this, "unloading", !1);
    this.url = (n = r == null ? void 0 : r.url) != null ? n : "";
  }
  setUnloading(r) {
    this.unloading = r;
  }
  export(r, n) {
    if (this.unloading) {
      const a = as.serializeRequest(r);
      if (!a || !this.url)
        return n({
          code: N.FAILED,
          error: new Error(
            "keepalive export failed: serializer returned empty or url missing"
          )
        });
      ds(
        this.url,
        a,
        "application/json",
        n
      );
      return;
    }
    let i = 0;
    const o = (a) => {
      var u;
      if (a.code === N.SUCCESS)
        return n({
          code: N.SUCCESS
        });
      if (i++, i > Io)
        return console.error(
          `[@launchdarkly/observability] failed to export OTeL metrics: ${(u = a.error) == null ? void 0 : u.message}`,
          a.error
        ), n({
          code: N.FAILED,
          error: a.error
        });
      new Promise(
        (c) => setTimeout(
          c,
          xo + Do * Math.pow(2, i)
        )
      ).then(() => {
        var c;
        console.warn(
          `[@launchdarkly/observability] retry ${i}, failed to export OTeL metrics: ${(c = a.error) == null ? void 0 : c.message}`,
          a.error
        ), super.export(r, o);
      });
    };
    super.export(r, o);
  }
}
const dy = "OT_ZONE_CONTEXT", py = "Navigation:";
function hy() {
  return !1;
}
const J = class J extends Ot {
  constructor(r = {}) {
    var n, i;
    super(
      J.moduleName,
      J.version,
      r
    );
    b(this, "_spansData", /* @__PURE__ */ new WeakMap());
    b(this, "_zonePatched");
    // for addEventListener/removeEventListener state
    b(this, "_wrappedListeners", /* @__PURE__ */ new WeakMap());
    // for event bubbling
    b(this, "_eventsSpanMap", /* @__PURE__ */ new WeakMap());
    b(this, "_eventNames");
    b(this, "_shouldPreventSpanCreation");
    b(this, "_getLDContextKeyAttributes");
    this._getLDContextKeyAttributes = r.getLDContextKeyAttributes, this._eventNames = new Set((n = r == null ? void 0 : r.eventNames) != null ? n : []), ((i = r.productAnalyticsEvents) == null ? void 0 : i.clicks) !== !1 && this._eventNames.add("click"), this._shouldPreventSpanCreation = typeof (r == null ? void 0 : r.shouldPreventSpanCreation) == "function" ? r.shouldPreventSpanCreation : hy;
  }
  init() {
  }
  /**
   * This will check if last task was timeout and will save the time to
   * fix the user interaction when nothing happens
   * This timeout comes from xhr plugin which is needed to collect information
   * about last xhr main request from observer
   * @param task
   * @param span
   */
  _checkForTimeout(r, n) {
    const i = this._spansData.get(n);
    i && (r.source === "setTimeout" ? i.hrTimeLastTimeout = Ce() : r.source !== "Promise.then" && r.source !== "setTimeout" && (i.hrTimeLastTimeout = void 0));
  }
  /**
   * Controls whether or not to create a span, based on the event type.
   */
  _allowEventName(r) {
    return this._eventNames.has(r);
  }
  /**
   * Creates a new span
   * @param event
   * @param parentSpan
   */
  _createSpan(r, n) {
    var u, c;
    const i = r == null ? void 0 : r.target, o = r == null ? void 0 : r.type;
    if (!(i instanceof HTMLElement) || !i.getAttribute || i.hasAttribute("disabled") || !this._allowEventName(o))
      return;
    const a = Aa(i, !0);
    try {
      const s = this.tracer.startSpan(
        o,
        {
          attributes: {
            [_e]: window.location.href,
            "event.type": o,
            "event.tag": i.tagName,
            "event.xpath": a,
            "event.id": i.id,
            "event.classname": i.className,
            "event.text": (u = i.textContent) != null ? u : "",
            "event.url": window.location.href,
            "viewport.width": window.innerWidth,
            "viewport.height": window.innerHeight
          }
        },
        n ? L.setSpan(O.active(), n) : void 0
      );
      r instanceof MouseEvent && (s.setAttribute("event.x", r.clientX), s.setAttribute("event.y", r.clientY), s.setAttribute(
        "event.relativeX",
        r.clientX / window.innerWidth
      ), s.setAttribute(
        "event.relativeY",
        r.clientY / window.innerHeight
      ), o === "scroll" && (s.setAttribute("event.scrollX", window.scrollX), s.setAttribute("event.scrollY", window.scrollY)));
      const l = (c = this._getLDContextKeyAttributes) == null ? void 0 : c.call(this);
      return l && s.setAttributes(l), this._shouldPreventSpanCreation(o, i, s) === !0 ? void 0 : (this._spansData.set(s, {
        taskCount: 0
      }), s);
    } catch (s) {
      this._diag.error(
        "failed to start create new user interaction span",
        s
      );
    }
  }
  /**
   * Decrement number of tasks that left in zone,
   * This is needed to be able to end span when no more tasks left
   * @param span
   */
  _decrementTask(r) {
    const n = this._spansData.get(r);
    n && (n.taskCount--, n.taskCount === 0 && this._tryToEndSpan(r, n.hrTimeLastTimeout));
  }
  /**
   * Return the current span
   * @param zone
   * @private
   */
  _getCurrentSpan(r) {
    const n = r.get(dy);
    return n && L.getSpan(n);
  }
  /**
   * Increment number of tasks that are run within the same zone.
   *     This is needed to be able to end span when no more tasks left
   * @param span
   */
  _incrementTask(r) {
    const n = this._spansData.get(r);
    n && n.taskCount++;
  }
  /**
   * Returns true iff we should use the patched callback; false if it's already been patched
   */
  addPatchedListener(r, n, i, o) {
    let a = this._wrappedListeners.get(i);
    a || (a = /* @__PURE__ */ new Map(), this._wrappedListeners.set(i, a));
    let u = a.get(n);
    return u || (u = /* @__PURE__ */ new Map(), a.set(n, u)), u.has(r) ? !1 : (u.set(r, o), !0);
  }
  /**
   * Returns the patched version of the callback (or undefined)
   */
  removePatchedListener(r, n, i) {
    const o = this._wrappedListeners.get(i);
    if (!o)
      return;
    const a = o.get(n);
    if (!a)
      return;
    const u = a.get(r);
    return u && (a.delete(r), a.size === 0 && (o.delete(n), o.size === 0 && this._wrappedListeners.delete(i))), u;
  }
  // utility method to deal with the Function|EventListener nature of addEventListener
  _invokeListener(r, n, i) {
    return typeof r == "function" ? r.apply(n, i) : r.handleEvent(i[0]);
  }
  /**
   * This patches the addEventListener of HTMLElement to be able to
   * auto instrument the click events
   * This is done when zone is not available
   */
  _patchAddEventListener() {
    const r = this;
    let n = /* @__PURE__ */ new Map();
    return (i) => function(a, u, c) {
      if (!u)
        return i.call(this, a, u, c);
      const s = c && typeof c == "object" && c.once, l = function(...f) {
        var p;
        let d;
        const h = f[0];
        if (!(h != null && h.type))
          return r._invokeListener(u, this, f);
        if (Date.now() - ((p = n.get(h.type)) != null ? p : 0) < 1e3 / 60)
          return r._invokeListener(u, this, f);
        n.set(h.type, Date.now()), h && (d = r._eventsSpanMap.get(h)), s && r.removePatchedListener(this, a, u);
        const _ = r._createSpan(h, d);
        return _ ? (h && r._eventsSpanMap.set(h, _), O.with(
          L.setSpan(O.active(), _),
          () => {
            const v = r._invokeListener(
              u,
              this,
              f
            );
            return _.end(), v;
          }
        )) : r._invokeListener(u, this, f);
      };
      if (r.addPatchedListener(
        this,
        a,
        u,
        l
      ))
        return i.call(
          this,
          a,
          l,
          c
        );
    };
  }
  /**
   * This patches the removeEventListener of HTMLElement to handle the fact that
   * we patched the original callbacks
   * This is done when zone is not available
   */
  _patchRemoveEventListener() {
    const r = this;
    return (n) => function(o, a, u) {
      const c = r.removePatchedListener(
        this,
        o,
        a
      );
      return c ? n.call(
        this,
        o,
        c,
        u
      ) : n.call(this, o, a, u);
    };
  }
  /**
   * Most browser provide event listener api via EventTarget in prototype chain.
   * Exception to this is IE 11 which has it on the prototypes closest to EventTarget:
   *
   * * - has addEventListener in IE
   * ** - has addEventListener in all other browsers
   * ! - missing in IE
   *
   * HTMLElement -> Element -> Node * -> EventTarget **! -> Object
   * Document -> Node * -> EventTarget **! -> Object
   * Window * -> WindowProperties ! -> EventTarget **! -> Object
   */
  _getPatchableEventTargets() {
    return window.EventTarget ? [EventTarget.prototype] : [Node.prototype, Window.prototype];
  }
  /**
   * Patches the history api
   */
  _patchHistoryApi() {
    this._unpatchHistoryApi(), this._wrap(history, "replaceState", this._patchHistoryMethod()), this._wrap(history, "pushState", this._patchHistoryMethod()), this._wrap(history, "back", this._patchHistoryMethod()), this._wrap(history, "forward", this._patchHistoryMethod()), this._wrap(history, "go", this._patchHistoryMethod());
  }
  /**
   * Patches the certain history api method
   */
  _patchHistoryMethod() {
    const r = this;
    return (n) => function(...o) {
      const a = `${location.pathname}${location.hash}${location.search}`, u = n.apply(this, o), c = `${location.pathname}${location.hash}${location.search}`;
      return a !== c && r._updateInteractionName(c), u;
    };
  }
  /**
   * unpatch the history api methods
   */
  _unpatchHistoryApi() {
    x(history.replaceState) && this._unwrap(history, "replaceState"), x(history.pushState) && this._unwrap(history, "pushState"), x(history.back) && this._unwrap(history, "back"), x(history.forward) && this._unwrap(history, "forward"), x(history.go) && this._unwrap(history, "go");
  }
  /**
   * Updates interaction span name
   * @param url
   */
  _updateInteractionName(r) {
    const n = L.getSpan(
      O.active()
    );
    n && typeof n.updateName == "function" && n.updateName(`${py} ${r}`);
  }
  /**
   * Patches zone cancel task - this is done to be able to correctly
   * decrement the number of remaining tasks
   */
  _patchZoneCancelTask() {
    const r = this;
    return (n) => function(o) {
      const a = Zone.current, u = r._getCurrentSpan(a);
      return u && r._shouldCountTask(o, a) && r._decrementTask(u), n.call(this, o);
    };
  }
  /**
   * Patches zone schedule task - this is done to be able to correctly
   * increment the number of tasks running within current zone but also to
   * save time in case of timeout running from xhr plugin when waiting for
   * main request from PerformanceResourceTiming
   */
  _patchZoneScheduleTask() {
    const r = this;
    return (n) => function(o) {
      const a = Zone.current, u = r._getCurrentSpan(a);
      return u && r._shouldCountTask(o, a) && (r._incrementTask(u), r._checkForTimeout(o, u)), n.call(this, o);
    };
  }
  /**
   * Patches zone run task - this is done to be able to create a span when
   * user interaction starts
   * @private
   */
  _patchZoneRunTask() {
    const r = this;
    return (n) => function(o, a, u) {
      const c = Array.isArray(u) && u[0] instanceof Event ? u[0] : void 0, s = c == null ? void 0 : c.target;
      let l;
      const f = this;
      if (s) {
        if (l = r._createSpan(c), l)
          return r._incrementTask(l), f.run(() => {
            try {
              return O.with(
                L.setSpan(
                  O.active(),
                  l
                ),
                () => {
                  const d = Zone.current;
                  return o._zone = d, n.call(
                    d,
                    o,
                    a,
                    u
                  );
                }
              );
            } finally {
              r._decrementTask(l);
            }
          });
      } else
        l = r._getCurrentSpan(f);
      try {
        return n.call(f, o, a, u);
      } finally {
        l && r._shouldCountTask(o, f) && r._decrementTask(l);
      }
    };
  }
  /**
   * Decides if task should be counted.
   * @param task
   * @param currentZone
   * @private
   */
  _shouldCountTask(r, n) {
    if (r._zone && (n = r._zone), !n || !r.data || r.data.isPeriodic)
      return !1;
    const i = this._getCurrentSpan(n);
    return !i || !this._spansData.get(i) ? !1 : r.type === "macroTask" || r.type === "microTask";
  }
  /**
   * Will try to end span when such span still exists.
   * @param span
   * @param endTime
   * @private
   */
  _tryToEndSpan(r, n) {
    r && this._spansData.get(r) && (r.end(n), this._spansData.delete(r));
  }
  /**
   * implements enable function
   */
  enable() {
    const r = this._getZoneWithPrototype();
    this._diag.debug(
      "applying patch to",
      J.moduleName,
      J.version,
      "zone:",
      !!r
    ), r ? (x(r.prototype.runTask) && (this._unwrap(r.prototype, "runTask"), this._diag.debug("removing previous patch from method runTask")), x(r.prototype.scheduleTask) && (this._unwrap(r.prototype, "scheduleTask"), this._diag.debug(
      "removing previous patch from method scheduleTask"
    )), x(r.prototype.cancelTask) && (this._unwrap(r.prototype, "cancelTask"), this._diag.debug(
      "removing previous patch from method cancelTask"
    )), this._zonePatched = !0, this._wrap(
      r.prototype,
      "runTask",
      this._patchZoneRunTask()
    ), this._wrap(
      r.prototype,
      "scheduleTask",
      this._patchZoneScheduleTask()
    ), this._wrap(
      r.prototype,
      "cancelTask",
      this._patchZoneCancelTask()
    )) : (this._zonePatched = !1, this._getPatchableEventTargets().forEach((i) => {
      x(i.addEventListener) && (this._unwrap(i, "addEventListener"), this._diag.debug(
        "removing previous patch from method addEventListener"
      )), x(i.removeEventListener) && (this._unwrap(i, "removeEventListener"), this._diag.debug(
        "removing previous patch from method removeEventListener"
      )), this._wrap(
        i,
        "addEventListener",
        this._patchAddEventListener()
      ), this._wrap(
        i,
        "removeEventListener",
        this._patchRemoveEventListener()
      );
    })), this._patchHistoryApi();
  }
  /**
   * implements unpatch function
   */
  disable() {
    const r = this._getZoneWithPrototype();
    this._diag.debug(
      "removing patch from",
      J.moduleName,
      J.version,
      "zone:",
      !!r
    ), r && this._zonePatched ? (x(r.prototype.runTask) && this._unwrap(r.prototype, "runTask"), x(r.prototype.scheduleTask) && this._unwrap(r.prototype, "scheduleTask"), x(r.prototype.cancelTask) && this._unwrap(r.prototype, "cancelTask")) : this._getPatchableEventTargets().forEach((i) => {
      x(i.addEventListener) && this._unwrap(i, "addEventListener"), x(i.removeEventListener) && this._unwrap(i, "removeEventListener");
    }), this._unpatchHistoryApi();
  }
  /**
   * returns Zone
   */
  _getZoneWithPrototype() {
    return window.Zone;
  }
};
b(J, "version", "0.1.1"), b(J, "moduleName", "user-interaction");
let On = J;
const _y = (e) => {
  if (typeof XMLHttpRequest == "undefined")
    return () => {
    };
  const t = XMLHttpRequest.prototype, r = t.open, n = t.setRequestHeader, i = t.send, o = (s) => !!s && e.some(
    (l) => s.toLowerCase().includes(l)
  ), a = function(s, l) {
    return this._method = s, this._url = typeof l == "string" ? l : String(l), this._requestHeaders = {}, this._body = void 0, r.apply(this, arguments);
  }, u = function(s, l) {
    return this._requestHeaders || (this._requestHeaders = {}), this._requestHeaders[s] = l, n.apply(this, arguments);
  }, c = function(s) {
    if (this._body === void 0 && s !== void 0 && s !== null && !o(this._url)) {
      const l = En(s, this._url);
      l && (this._body = l);
    }
    return i.apply(this, arguments);
  };
  return t.open = a, t.setRequestHeader = u, t.send = c, () => {
    t.open === a && (t.open = r), t.setRequestHeader === u && (t.setRequestHeader = n), t.send === c && (t.send = i);
  };
}, vy = 256 * 1024, yy = (e) => !!e && e.split(";")[0].trim().toLowerCase() === "multipart/form-data", ps = (e) => {
  if (!e || typeof e != "object")
    return {};
  if (typeof Headers != "undefined" && e instanceof Headers)
    return Object.fromEntries(e.entries());
  if (Array.isArray(e))
    try {
      return Object.fromEntries(new Headers(e).entries());
    } catch (t) {
      return Object.fromEntries(
        e.map(([r, n]) => [String(r), String(n)])
      );
    }
  return E({}, e);
}, sr = (e) => Object.prototype.toString.call(e), my = (e) => typeof ArrayBuffer != "undefined" && e instanceof ArrayBuffer || sr(e) === "[object ArrayBuffer]" || sr(e) === "[object SharedArrayBuffer]", hs = (e) => {
  if (typeof File != "undefined" && e instanceof File || sr(e) === "[object File]") {
    const t = e;
    return `[File name="${t.name}" type="${t.type}" size=${t.size}]`;
  }
  return `[Blob type="${e.type}" size=${e.size}]`;
}, Rn = (e, t, r) => {
  const n = e[t];
  n === void 0 ? e[t] = r : Array.isArray(n) ? n.push(r) : e[t] = [n, r];
}, gy = (e) => {
  const t = {};
  return e.forEach((r, n) => {
    Rn(
      t,
      n,
      typeof r == "string" ? r : hs(r)
    );
  }), JSON.stringify(t);
}, Ey = (e) => {
  const t = ArrayBuffer.isView(e) ? new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : new Uint8Array(e);
  if (t.byteLength > vy)
    return `[binary size=${t.byteLength}]`;
  try {
    return new TextDecoder("utf-8", { fatal: !0 }).decode(t);
  } catch (r) {
    return `[binary size=${t.byteLength}]`;
  }
}, _s = (e) => {
  if (e == null)
    return;
  switch (typeof e) {
    case "string":
      return e;
    case "number":
    case "boolean":
    case "bigint":
      return String(e);
    case "object":
      break;
    default:
      return;
  }
  const t = sr(e);
  if (typeof URLSearchParams != "undefined" && e instanceof URLSearchParams || t === "[object URLSearchParams]")
    return e.toString();
  if (typeof FormData != "undefined" && e instanceof FormData || t === "[object FormData]")
    return gy(e);
  if (typeof Blob != "undefined" && e instanceof Blob || t === "[object Blob]" || t === "[object File]")
    return hs(e);
  if (my(e) || ArrayBuffer.isView(e))
    return Ey(e);
  if (!(typeof ReadableStream != "undefined" && e instanceof ReadableStream || t === "[object ReadableStream]")) {
    if (typeof Document != "undefined" && e instanceof Document)
      try {
        return new XMLSerializer().serializeToString(e);
      } catch (r) {
        return;
      }
    try {
      return We(e);
    } catch (r) {
      return;
    }
  }
}, Ln = /* @__PURE__ */ new WeakMap(), Ty = (e) => Ln.get(e), Sy = (e, t) => U(void 0, null, function* () {
  const r = e.getReader(), n = [];
  let i = 0;
  for (; i < t; ) {
    const { done: o, value: a } = yield r.read();
    if (o)
      return { chunks: n, byteLength: i, truncated: !1 };
    const u = t - i, c = a.byteLength > u ? a.subarray(0, u) : a;
    n.push(c), i += c.byteLength;
  }
  return r.cancel().catch(() => {
  }), { chunks: n, byteLength: i, truncated: !0 };
}), by = ({ chunks: e, byteLength: t }) => {
  const r = new Uint8Array(t);
  let n = 0;
  for (const i of e)
    r.set(i, n), n += i.byteLength;
  return r;
}, wy = (e) => {
  const t = new TextDecoder("utf-8", { fatal: !0 });
  try {
    let r = "";
    for (const n of e.chunks)
      r += t.decode(n, { stream: !0 });
    return e.truncated ? r : r + t.decode();
  } catch (r) {
    return `[binary size${e.truncated ? ">" : "="}${e.byteLength}]`;
  }
}, Ft = (e) => `[multipart/form-data size${e.truncated ? ">" : "="}${e.byteLength}]`, Ay = (e, t) => {
  var i, o, a, u, c, s, l;
  const r = /;\s*boundary=(?:"([^"]*)"|([^;]*))/i.exec(
    t
  ), n = (o = (i = r == null ? void 0 : r[1]) != null ? i : r == null ? void 0 : r[2]) == null ? void 0 : o.trim();
  if (!n)
    return Ft(e);
  try {
    const f = by(e), d = new TextDecoder("windows-1252").decode(f), h = `--${n}`, _ = {};
    let p = d.indexOf(h);
    if (p === -1)
      return Ft(e);
    for (; p !== -1 && (p += h.length, !d.startsWith("--", p)); ) {
      const v = d.indexOf(`\r
`, p), y = v === -1 ? -1 : d.indexOf(`\r
\r
`, v);
      if (y === -1)
        break;
      const g = new TextDecoder().decode(
        f.subarray(v + 2, y)
      ), w = y + 4, A = d.indexOf(`\r
${h}`, w), R = A === -1, P = R ? d.length : A, G = (a = /\bname="([^"]*)"/i.exec(g)) == null ? void 0 : a[1];
      if (G !== void 0) {
        const C = (u = /\bfilename="([^"]*)"/i.exec(g)) == null ? void 0 : u[1];
        if (C !== void 0) {
          const F = (l = (s = (c = /^content-type:[ \t]*(.*)$/im.exec(g)) == null ? void 0 : c[1]) == null ? void 0 : s.trim()) != null ? l : "", ne = P - w;
          Rn(
            _,
            G,
            `[File name="${C}" type="${F}" size${R ? ">=" : "="}${ne}]`
          );
        } else
          Rn(
            _,
            G,
            new TextDecoder().decode(
              f.subarray(w, P)
            )
          );
      }
      p = R ? -1 : A + 2;
    }
    return e.truncated && Object.keys(_).length === 0 ? Ft(e) : JSON.stringify(_);
  } catch (f) {
    return Ft(e);
  }
}, Oy = (e, t) => {
  try {
    if (t && t.body !== void 0 && t.body !== null)
      return Promise.resolve(_s(t.body));
    if (!e.body || e.bodyUsed)
      return Promise.resolve(void 0);
    const r = e.clone();
    if (!r.body)
      return Promise.resolve(void 0);
    const n = e.headers.get("content-type");
    return Sy(r.body, zn(e.headers)).then(
      (i) => yy(n) ? Ay(i, n) : wy(i)
    ).catch(() => {
    });
  } catch (r) {
    return Promise.resolve(void 0);
  }
}, Ry = (e = []) => {
  if (typeof window == "undefined" || typeof window.fetch != "function" || typeof Request == "undefined")
    return () => {
    };
  const t = (i) => e.some(
    (o) => i.toLowerCase().includes(o)
  ), r = window.fetch, n = function(i, o) {
    return i instanceof Request && !Ln.has(i) && !t(i.url) && Ln.set(i, Oy(i, o)), r.call(this != null ? this : window, i, o);
  };
  return window.fetch = n, () => {
    window.fetch === n && (window.fetch = r);
  };
}, ze = class ze extends Ot {
  constructor(r = {}) {
    super(
      ze.moduleName,
      ze.version,
      r
    );
    b(this, "_getLDContextKeyAttributes");
    b(this, "_unlisten");
    b(this, "_lastUrl", "");
    this._getLDContextKeyAttributes = r.getLDContextKeyAttributes;
  }
  init() {
  }
  enable() {
    this._lastUrl = window.location.href, this._unlisten = Vs((r) => {
      var i;
      const n = this._lastUrl;
      if (this._lastUrl = r, n !== r)
        try {
          const o = this.tracer.startSpan($s, {
            attributes: {
              [_e]: r,
              "page_view.previous_url": n,
              "page_view.url": r
            }
          }), a = (i = this._getLDContextKeyAttributes) == null ? void 0 : i.call(this);
          a && o.setAttributes(a), o.end();
        } catch (o) {
          this._diag.error("failed to create page view span", o);
        }
    });
  }
  disable() {
    var r;
    (r = this._unlisten) == null || r.call(this), this._unlisten = void 0;
  }
};
b(ze, "version", "0.1.0"), b(ze, "moduleName", "location-change");
let Pn = ze, k = {}, ie, Jt, Oe, Re;
const Pe = "highlight.record", Ly = "highlight.session_id", ur = /* @__PURE__ */ new Map(), Nn = (e) => `${e.spanContext().traceId}:${e.spanContext().spanId}`, vs = "launchdarkly.js.log", Py = "launchdarkly.exception.id", ho = "launchdarkly.sampling.ratio", ys = "log.severity", ms = "log.message", Ny = (e, t) => {
  var v, y, g, w, A, R, P, G, C, F, ne, Zn, Qn, ei;
  if (k.tracerProvider || k.meterProvider) {
    console.warn("OTEL already initialized. Skipping...");
    return;
  }
  ie = e;
  const r = e.backendUrl || void 0 || "https://pub.highlight.io", n = [
    ...(y = (v = e.networkRecordingOptions) == null ? void 0 : v.urlBlocklist) != null ? y : [],
    ...jp
  ], i = [r, e.otlpEndpoint].filter((Lt) => !!Lt).map((Lt) => Lt.toLowerCase()), o = (g = e.environment) != null ? g : "production", a = {
    url: e.otlpEndpoint + "/v1/traces",
    concurrencyLimit: 10,
    timeoutMillis: 3e4,
    // Using any because we were getting an error importing CompressionAlgorithm
    // from @opentelemetry/otlp-exporter-base.
    compression: "gzip",
    keepAlive: !0,
    httpAgentOptions: {
      timeout: 6e4,
      keepAlive: !0
    }
  }, u = new ly(
    a,
    t
  ), c = new cr(u, {
    maxExportBatchSize: 1024,
    // Default value from SDK is 512
    maxQueueSize: 2048,
    // Default value from SDK is 2048
    exportTimeoutMillis: a.timeoutMillis,
    // Default value from SDK is 30_000
    scheduledDelayMillis: 5e3
    // OTEL default; shorter window reduces data lost to page unload
  }), s = new mt({
    [Ws]: (w = e.serviceName) != null ? w : "highlight-browser",
    [qs]: e.serviceVersion,
    "deployment.environment.name": o,
    "highlight.project_id": e.projectId,
    [Xs]: navigator.userAgent,
    "browser.language": navigator.language,
    "telemetry.distro.name": "@highlight-run/observability",
    "telemetry.distro.version": zs
  });
  k.tracerProvider = new md({
    resource: s,
    mergeResourceWithDefaults: !0,
    spanProcessors: [c]
  }), L.setGlobalTracerProvider(k.tracerProvider);
  const l = new fy(I(E({}, a), {
    url: e.otlpEndpoint + "/v1/metrics"
  })), f = new A_({
    exporter: l,
    exportIntervalMillis: a.timeoutMillis,
    exportTimeoutMillis: a.timeoutMillis
  });
  k.meterProvider = new fv({ resource: s, readers: [f] }), kn.setGlobalMeterProvider(k.meterProvider);
  let d = [];
  if (((A = e.instrumentations) == null ? void 0 : A["@opentelemetry/instrumentation-document-load"]) !== !1 && d.push(
    new kd({
      applyCustomAttributesOnSpan: {
        documentLoad: mo,
        documentFetch: mo,
        resourceFetch: Vy
      }
    })
  ), ((R = e.instrumentations) == null ? void 0 : R["@opentelemetry/instrumentation-user-interaction"]) !== !1 && d.push(
    new On({
      productAnalyticsEvents: e.productAnalyticsEvents,
      getLDContextKeyAttributes: e.getLDContextKeyAttributes
    })
  ), ((P = e.productAnalyticsEvents) == null ? void 0 : P.pageViews) !== !1 && d.push(
    new Pn({
      getLDContextKeyAttributes: e.getLDContextKeyAttributes
    })
  ), (G = e.networkRecordingOptions) != null && G.enabled) {
    if (((C = e.instrumentations) == null ? void 0 : C["@opentelemetry/instrumentation-fetch"]) !== !1) {
      const ge = new fp({
        propagateTraceHeaderCorsUrls: go(
          e.tracingOrigins
        ),
        applyCustomAttributesOnSpan: (B, le, He) => {
          var Pt;
          if (!B.attributes)
            return;
          const et = B;
          if (et.attributes[Pe] === !1)
            return;
          const tt = typeof Request != "undefined" && le instanceof Request, rt = tt ? Ty(le) : void 0;
          vo(
            B,
            tt ? void 0 : le.body,
            le.headers,
            e.networkRecordingOptions
          );
          const nt = () => U(void 0, null, function* () {
            const Te = yield rt;
            Te !== void 0 && Uy(
              B,
              Te,
              le.headers,
              e.networkRecordingOptions
            );
          }), Ee = () => {
            var Te;
            return (Te = e.networkRecordingOptions) != null && Te.requestResponseSanitizer && yo(
              B,
              e.networkRecordingOptions.requestResponseSanitizer
            ), et.attributes[Pe] !== !1;
          };
          if (!(He instanceof Response)) {
            if (B.setAttributes({
              "http.response.error": He.message,
              [Uo]: He.status
            }), !Ee())
              return;
            rt && ur.set(
              Nn(B),
              nt().then(() => {
                Ee();
              })
            );
            return;
          }
          if (Ee() && (Pt = e.networkRecordingOptions) != null && Pt.recordHeadersAndBody) {
            const Te = U(void 0, null, function* () {
              var ti, ri, ni, ii, oi;
              yield nt();
              const Ms = yield xa(
                He,
                (ti = e.networkRecordingOptions) == null ? void 0 : ti.bodyKeysToRecord,
                (ri = e.networkRecordingOptions) == null ? void 0 : ri.networkBodyKeysToRedact
              ), Is = Object.fromEntries(
                He.headers.entries()
              ), xs = vr(
                (ii = (ni = e.networkRecordingOptions) == null ? void 0 : ni.networkHeadersToRedact) != null ? ii : [],
                Is,
                (oi = e.networkRecordingOptions) == null ? void 0 : oi.headerKeysToRecord
              ), Ds = Wn(
                xs,
                "http.response.header"
              );
              Object.assign(
                B.attributes,
                E({
                  "http.response.body": Ms
                }, Ds)
              ), Ee();
            });
            ur.set(Nn(B), Te);
          }
        }
      });
      d.push(ge);
    }
    ((F = e.instrumentations) == null ? void 0 : F["@opentelemetry/instrumentation-xml-http-request"]) !== !1 && d.push(
      new xp({
        propagateTraceHeaderCorsUrls: go(
          e.tracingOrigins
        ),
        applyCustomAttributesOnSpan: (ge, B) => {
          var et, tt, rt, nt;
          const le = B;
          if (!(!ge.attributes || ge.attributes[Pe] === !1)) {
            if (vo(
              ge,
              le._body,
              le._requestHeaders,
              e.networkRecordingOptions
            ), (et = e.networkRecordingOptions) != null && et.recordHeadersAndBody) {
              let Ee = "";
              (B.responseType === "" || B.responseType === "text") && (Ee = ee(
                B.responseText,
                (tt = e.networkRecordingOptions) == null ? void 0 : tt.networkBodyKeysToRedact,
                (rt = e.networkRecordingOptions) == null ? void 0 : rt.bodyKeysToRecord,
                void 0
              ));
              const Pt = ky(
                B.getAllResponseHeaders()
              );
              Fy(
                ge,
                Pt,
                Ee,
                e.networkRecordingOptions
              );
            }
            (nt = e.networkRecordingOptions) != null && nt.requestResponseSanitizer && yo(
              ge,
              e.networkRecordingOptions.requestResponseSanitizer
            );
          }
        }
      })
    );
  }
  xf({ instrumentations: d }), (ne = e.networkRecordingOptions) != null && ne.enabled && e.networkRecordingOptions.recordHeadersAndBody && ((Zn = e.instrumentations) == null ? void 0 : Zn["@opentelemetry/instrumentation-xml-http-request"]) !== !1 && (Oe == null || Oe(), Oe = _y([
    ...n,
    ...i
  ])), (Qn = e.networkRecordingOptions) != null && Qn.enabled && e.networkRecordingOptions.recordHeadersAndBody && ((ei = e.instrumentations) == null ? void 0 : ei["@opentelemetry/instrumentation-fetch"]) !== !1 && (Re == null || Re(), Re = Ry([
    ...n,
    ...i
  ]));
  const p = new Sa();
  return p.enable(), k.tracerProvider.register({
    contextManager: p,
    propagator: new na({
      propagators: [
        new Yo(),
        new My({
          backendUrl: r,
          otlpEndpoint: e.otlpEndpoint,
          tracingOrigins: e.tracingOrigins,
          urlBlocklist: n
        })
      ]
    })
  }), Jt = Cy(
    u,
    l,
    c,
    () => k
  ), k;
}, Cy = (e, t, r, n) => {
  if (typeof document == "undefined" || typeof window == "undefined")
    return () => {
    };
  const i = () => {
    var c, s;
    e.setUnloading(!0), t.setUnloading(!0), r.setSkipPendingOnFlush(!0);
    const u = n();
    (c = u.tracerProvider) == null || c.forceFlush().catch(() => {
    }), (s = u.meterProvider) == null || s.forceFlush().catch(() => {
    });
  }, o = () => {
    document.visibilityState === "hidden" ? i() : document.visibilityState === "visible" && (e.setUnloading(!1), t.setUnloading(!1), r.setSkipPendingOnFlush(!1));
  }, a = () => i();
  return document.addEventListener("visibilitychange", o), window.addEventListener("pagehide", a), () => {
    document.removeEventListener("visibilitychange", o), window.removeEventListener("pagehide", a);
  };
};
class cr extends Ta {
  constructor() {
    super(...arguments);
    b(this, "_pendingSpans", /* @__PURE__ */ new Set());
    // When set, forceFlush/shutdown return immediately without waiting for
    // in-flight response-body reads. Used on page unload where waiting risks
    // the browser freezing JS before we hand the spans to the transport.
    b(this, "_skipPendingOnFlush", !1);
  }
  setSkipPendingOnFlush(r) {
    this._skipPendingOnFlush = r;
  }
  onStart(r, n) {
    r.setAttribute(Ly, de()), super.onStart(r, n);
  }
  onEnd(r) {
    if (r.attributes[Pe] === !1)
      return;
    const n = Nn(r), i = ur.get(n);
    if (i) {
      const o = i.catch((a) => {
        console.warn(
          "[CustomBatchSpanProcessor] Failed to capture response body attributes",
          a
        );
      }).finally(() => {
        ur.delete(n), this._pendingSpans.delete(o), r.attributes[Pe] !== !1 && super.onEnd(r);
      });
      this._pendingSpans.add(o);
      return;
    }
    super.onEnd(r);
  }
  shutdown() {
    return U(this, null, function* () {
      return this._skipPendingOnFlush || (yield Promise.allSettled(this._pendingSpans)), wr(cr.prototype, this, "shutdown").call(this);
    });
  }
  forceFlush() {
    return U(this, null, function* () {
      return this._skipPendingOnFlush || (yield Promise.allSettled(this._pendingSpans)), wr(cr.prototype, this, "forceFlush").call(this);
    });
  }
}
class My extends ia {
  constructor(r) {
    super();
    b(this, "highlightEndpoints");
    b(this, "tracingOrigins");
    b(this, "urlBlocklist");
    this.highlightEndpoints = [
      r.backendUrl,
      `${r.otlpEndpoint}/v1/traces`,
      `${r.otlpEndpoint}/v1/logs`,
      `${r.otlpEndpoint}/v1/metrics`
    ], this.tracingOrigins = r.tracingOrigins, this.urlBlocklist = r.urlBlocklist;
  }
  inject(r, n, i) {
    var u;
    const o = L.getSpan(r);
    if (!o || !o.attributes)
      return;
    const a = Ss(o);
    typeof a == "string" && (jy(
      a,
      this.highlightEndpoints,
      this.tracingOrigins,
      this.urlBlocklist
    ) || o.setAttribute(Pe, !1), !$n(
      a,
      (u = this.tracingOrigins) != null ? u : [],
      this.urlBlocklist
    )) || super.inject(r, n, i);
  }
}
const gs = "highlight-browser", Iy = gs, _o = () => {
  var e;
  return (e = k.tracerProvider) == null ? void 0 : e.getTracer(gs);
}, jt = () => {
  var e;
  return (e = k.meterProvider) == null ? void 0 : e.getMeter(Iy);
}, xy = () => L.getActiveSpan(), Dy = () => U(void 0, null, function* () {
  Jt && (Jt(), Jt = void 0), Oe && (Oe(), Oe = void 0), Re && (Re(), Re = void 0), yield Promise.allSettled([
    U(void 0, null, function* () {
      k.tracerProvider ? (yield k.tracerProvider.shutdown(), k.tracerProvider = void 0) : console.warn(
        "OTEL shutdown called without initialized tracerProvider."
      );
    }),
    U(void 0, null, function* () {
      k.meterProvider ? (yield k.meterProvider.shutdown(), k.meterProvider = void 0) : console.warn(
        "OTEL shutdown called without initialized meterProvider."
      );
    })
  ]);
}), Es = (e) => {
  const t = Dp(e), r = {};
  return t != null && t.name && (r["graphql.operation.name"] = t.name), t != null && t.type && (r["graphql.operation.type"] = t.type), r;
}, Uy = (e, t, r, n) => {
  if (!e.attributes)
    return;
  const i = e.attributes;
  Object.assign(i, Es(t)), n != null && n.recordHeadersAndBody && Object.assign(i, {
    "http.request.body": ee(
      t,
      n.networkBodyKeysToRedact,
      n.bodyKeysToRecord,
      ps(r)
    )
  });
}, vo = (e, t, r, n) => {
  var l;
  if (!e.attributes)
    return;
  const o = Ss(e), a = gn(o), u = La(a), c = _s(t), s = ps(r);
  if (e.setAttributes(Es(c != null ? c : t)), e.setAttributes({
    "highlight.type": "http.request",
    [qe]: a,
    // overwrite with sanitized version
    [_e]: a,
    [zt]: u.pathname,
    [Ys]: u.search
  }), e.setAttributes(
    By(
      u.searchParams,
      "url.query_params"
    )
  ), n != null && n.recordHeadersAndBody) {
    c !== void 0 && e.setAttribute(
      "http.request.body",
      ee(
        c,
        n.networkBodyKeysToRedact,
        n.bodyKeysToRecord,
        s
      )
    );
    const f = vr(
      (l = n.networkHeadersToRedact) != null ? l : [],
      s,
      n.headerKeysToRecord
    ), d = Wn(
      f,
      "http.request.header"
    );
    e.setAttributes(d);
  }
}, ky = (e) => {
  const t = {};
  return e && e.trim().split(/[\r\n]+/).forEach((r) => {
    const n = r.split(": "), i = n.shift();
    i && (t[i] = n.join(": "));
  }), t;
}, Wn = (e, t) => {
  const r = {};
  return Object.entries(e).forEach(([n, i]) => {
    const o = n.toLowerCase().replace(/_/g, "-"), a = `${t}.${o}`, u = Gy(o, i);
    if (r[a]) {
      const c = r[a];
      Array.isArray(c) ? r[a] = [...c, ...u] : r[a] = [c, ...u];
    } else
      r[a] = u.length === 1 ? u[0] : u;
  }), r;
}, By = (e, t) => {
  const r = {};
  for (const [n, i] of e.entries()) {
    const o = `${t}.${n}`, a = r[o];
    a === void 0 ? r[o] = i : Array.isArray(a) ? a.push(i) : r[o] = [a, i];
  }
  return r;
}, Hy = /* @__PURE__ */ new Set([
  "accept",
  "accept-charset",
  "accept-encoding",
  "accept-language",
  "accept-ranges",
  "allow",
  "cache-control",
  "connection",
  "content-encoding",
  "content-language",
  "expect",
  "if-match",
  "if-none-match",
  "pragma",
  "proxy-authenticate",
  "te",
  "trailer",
  "transfer-encoding",
  "upgrade",
  "vary",
  "via",
  "warning",
  "www-authenticate",
  "access-control-allow-headers",
  "access-control-allow-methods",
  "access-control-expose-headers",
  "access-control-request-headers"
]), Gy = (e, t) => Hy.has(e) ? t.split(",").map((r) => r.trim()).filter((r) => r.length > 0) : [t], Fy = (e, t, r, n) => {
  var a;
  e.setAttribute("http.response.body", r);
  const i = vr(
    (a = n.networkHeadersToRedact) != null ? a : [],
    t,
    n.headerKeysToRecord
  ), o = Wn(
    i,
    "http.response.header"
  );
  e.setAttributes(o);
}, yo = (e, t) => {
  var f, d, h, _, p, v, y, g, w, A;
  const n = e.attributes, i = {}, o = {};
  for (const [R, P] of Object.entries(n))
    R.startsWith("http.request.header.") && (i[R.slice(20)] = String(P)), R.startsWith("http.response.header.") && (o[R.slice(21)] = String(P));
  let u = {
    request: {
      sessionSecureID: "",
      id: "",
      url: (d = (f = n[_e]) != null ? f : n[qe]) != null ? d : "",
      verb: (h = n["http.request.method"]) != null ? h : "GET",
      headers: i,
      body: (_ = n["http.request.body"]) != null ? _ : ""
    },
    response: {
      status: Number(
        (p = n[Uo]) != null ? p : 0
      ),
      headers: o,
      body: (v = n["http.response.body"]) != null ? v : ""
    },
    urlBlocked: !1
  }, c = !0;
  try {
    u.request.body = JSON.parse(u.request.body);
  } catch (R) {
    c = !1;
  }
  let s = !0;
  try {
    u.response.body = JSON.parse(u.response.body);
  } catch (R) {
    s = !1;
  }
  let l;
  try {
    l = t(u);
  } catch (R) {
    return;
  }
  if (!l) {
    Object.assign(e.attributes, {
      [Pe]: !1
    });
    return;
  }
  c && ((y = l.request) != null && y.body) && (l.request.body = JSON.stringify(l.request.body)), s && ((g = l.response) != null && g.body) && (l.response.body = JSON.stringify(l.response.body)), Object.assign(e.attributes, {
    "http.request.body": (w = l.request.body) != null ? w : "",
    "http.response.body": (A = l.response.body) != null ? A : ""
  });
}, jy = (e, t, r, n) => n != null && n.some(
  (o) => e.toLowerCase().includes(o)
) ? !1 : Vn(
  e,
  t
), mo = (e) => {
  var o, a, u;
  if (!e.events)
    return;
  const r = e.events, n = {
    unload: V("unloadEventStart", "unloadEventEnd", r),
    dom_interactive: V(
      "fetchStart",
      "domInteractive",
      r
    ),
    dom_content_loaded: V(
      "domContentLoadedEventStart",
      "domContentLoadedEventEnd",
      r
    ),
    dom_complete: V("fetchStart", "domComplete", r),
    load_event: V("loadEventStart", "loadEventEnd", r),
    document_load: V("fetchStart", "loadEventEnd", r),
    first_paint: V("fetchStart", "firstPaint", r),
    first_contentful_paint: V(
      "fetchStart",
      "firstContentfulPaint",
      r
    ),
    domain_lookup: V(
      "domainLookupStart",
      "domainLookupEnd",
      r
    ),
    connect: V("connectStart", "connectEnd", r),
    request: V("requestStart", "requestEnd", r),
    response: V("responseStart", "responseEnd", r)
  }, i = (a = (o = ie == null ? void 0 : ie.getIntegrations) == null ? void 0 : o.call(ie)) != null ? a : [];
  if (n.document_load !== void 0)
    for (const c of i)
      c.recordGauge((u = ie == null ? void 0 : ie.sessionSecureId) != null ? u : "", {
        name: Ks,
        value: n.document_load / 1e6
      });
  Object.entries(n).forEach(([c, s]) => {
    s !== void 0 && (e.setAttribute(`timings.${c}.ns`, s), e.setAttribute(
      `timings.${c}.readable`,
      Ts(s)
    ));
  });
};
function V(e, t, r) {
  const n = r.find((u) => u.name === e), i = r.find((u) => u.name === t);
  if (!n || !i)
    return;
  const o = n.time[0] * 1e9 + n.time[1];
  return i.time[0] * 1e9 + i.time[1] - o;
}
const Vy = (e, t) => {
  const r = {
    domain_lookup: (t.domainLookupEnd - t.domainLookupStart) * 1e9,
    connect: (t.connectEnd - t.connectStart) * 1e9,
    request: (t.responseEnd - t.requestStart) * 1e9,
    response: (t.responseEnd - t.responseStart) * 1e9
  };
  Object.entries(r).forEach(([n, i]) => {
    e.setAttribute(`timings.${n}.ns`, i), e.setAttribute(`timings.${n}.readable`, Ts(i));
  });
}, Ts = (e) => {
  if (e >= 36e11) {
    const a = e / 36e11;
    return `${Number(a.toFixed(1))}h`;
  } else if (e >= 6e10) {
    const a = e / 6e10;
    return `${Number(a.toFixed(1))}m`;
  } else if (e >= 1e9) {
    const a = e / 1e9;
    return `${Number(a.toFixed(1))}s`;
  } else if (e >= 1e6) {
    const a = e / 1e6;
    return `${Number(a.toFixed(1))}ms`;
  } else if (e >= 1e3) {
    const a = e / 1e3;
    return `${Number(a.toFixed(1))}µs`;
  } else
    return `${Number(e.toFixed(1))}ns`;
}, go = (e) => e === !0 ? [
  /localhost/,
  /^\//,
  Na(window.location.host)
] : Array.isArray(e) ? e.map(
  (t) => typeof t == "string" ? new RegExp(t) : t
) : /^$/, Ss = (e) => e.attributes[_e] ? e.attributes[_e] : e.attributes[qe], $y = 30, zy = () => new Promise(
  (e) => requestAnimationFrame(
    (t) => requestAnimationFrame((r) => e(r - t))
  )
), Xy = () => U(void 0, null, function* () {
  const e = [];
  for (let t = 0; t < $y; t++)
    e.push(yield zy());
  return e.reduce((t, r) => t + r, 0) / e.length;
}), qy = (e, t) => {
  let r = {}, n = 16.666666666666668;
  Xy().then((c) => n = c);
  const i = (c) => {
    var s;
    r != null && r.event || (r = {
      event: c,
      location: window.location.href,
      timerStart: (s = window.performance) == null ? void 0 : s.now()
    }, window.requestAnimationFrame(o));
  }, o = () => {
    if (!(r != null && r.timerStart)) return;
    const c = window.performance.now() - r.timerStart - n;
    a(c), r = {};
  }, a = (c) => {
    const s = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3;
    e({
      relativeTimestamp: s,
      jankAmount: c,
      querySelector: u(),
      newLocation: window.location.href != r.location ? window.location.href : void 0
    });
  }, u = () => {
    var c;
    return (c = r == null ? void 0 : r.event) != null && c.target ? Js(r.event.target) : "";
  };
  return window.addEventListener("click", i, !0), window.addEventListener("keydown", i, !0), () => {
    window.removeEventListener("keydown", i, !0), window.removeEventListener("click", i, !0);
  };
}, Wy = typeof window != "undefined", Eo = Wy && "performance" in window && "memory" in performance ? performance : { memory: {} }, Ky = (e, t) => {
  let r = 0, n = 0;
  const i = () => {
    const l = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3, f = Eo.memory.jsHeapSizeLimit || 0, d = Eo.memory.usedJSHeapSize || 0;
    e({
      jsHeapSizeLimit: f,
      usedJSHeapSize: d,
      relativeTimestamp: l,
      fps: r
    });
  };
  i();
  let o;
  o = setInterval(() => {
    i();
  }, 1e3);
  let a = 0, u = Date.now();
  const c = function() {
    var s = Date.now();
    a++, s > 1e3 + u && (r = Math.round(a * 1e3 / (s - u)), a = 0, u = s), n = requestAnimationFrame(c);
  };
  return c(), () => {
    clearInterval(o), cancelAnimationFrame(n);
  };
};
var he, ht, bs, lr, Cn, Ze = function() {
  return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, Tt = function(e) {
  if (document.readyState === "loading") return "loading";
  var t = Ze();
  if (t) {
    if (e < t.domInteractive) return "loading";
    if (t.domContentLoadedEventStart === 0 || e < t.domContentLoadedEventStart) return "dom-interactive";
    if (t.domComplete === 0 || e < t.domComplete) return "dom-content-loaded";
  }
  return "complete";
}, Yy = function(e) {
  var t = e.nodeName;
  return e.nodeType === 1 ? t.toLowerCase() : t.toUpperCase().replace(/^#/, "");
}, gr = function(e, t) {
  var r = "";
  try {
    for (; e && e.nodeType !== 9; ) {
      var n = e, i = n.id ? "#" + n.id : Yy(n) + (n.classList && n.classList.value && n.classList.value.trim() && n.classList.value.trim().length ? "." + n.classList.value.trim().replace(/\s+/g, ".") : "");
      if (r.length + i.length > 99) return r || i;
      if (r = r ? i + ">" + r : i, n.id) break;
      e = n.parentNode;
    }
  } catch (o) {
  }
  return r;
}, ws = -1, As = function() {
  return ws;
}, Be = function(e) {
  addEventListener("pageshow", function(t) {
    t.persisted && (ws = t.timeStamp, e(t));
  }, !0);
}, Er = function() {
  var e = Ze();
  return e && e.activationStart || 0;
}, W = function(e, t) {
  var r = Ze(), n = "navigate";
  return As() >= 0 ? n = "back-forward-cache" : r && (document.prerendering || Er() > 0 ? n = "prerender" : document.wasDiscarded ? n = "restore" : r.type && (n = r.type.replace(/_/g, "-"))), { name: e, value: t === void 0 ? -1 : t, rating: "good", delta: 0, entries: [], id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: n };
}, Qe = function(e, t, r) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      var n = new PerformanceObserver(function(i) {
        Promise.resolve().then(function() {
          t(i.getEntries());
        });
      });
      return n.observe(Object.assign({ type: e, buffered: !0 }, r || {})), n;
    }
  } catch (i) {
  }
}, K = function(e, t, r, n) {
  var i, o;
  return function(a) {
    t.value >= 0 && (a || n) && ((o = t.value - (i || 0)) || i === void 0) && (i = t.value, t.delta = o, t.rating = function(u, c) {
      return u > c[1] ? "poor" : u > c[0] ? "needs-improvement" : "good";
    }(t.value, r), e(t));
  };
}, Kn = function(e) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return e();
    });
  });
}, Tr = function(e) {
  var t = function(r) {
    r.type !== "pagehide" && document.visibilityState !== "hidden" || e(r);
  };
  addEventListener("visibilitychange", t, !0), addEventListener("pagehide", t, !0);
}, Yn = function(e) {
  var t = !1;
  return function(r) {
    t || (e(r), t = !0);
  };
}, $e = -1, To = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, fr = function(e) {
  document.visibilityState === "hidden" && $e > -1 && ($e = e.type === "visibilitychange" ? e.timeStamp : 0, Jy());
}, So = function() {
  addEventListener("visibilitychange", fr, !0), addEventListener("prerenderingchange", fr, !0);
}, Jy = function() {
  removeEventListener("visibilitychange", fr, !0), removeEventListener("prerenderingchange", fr, !0);
}, Jn = function() {
  return $e < 0 && ($e = To(), So(), Be(function() {
    setTimeout(function() {
      $e = To(), So();
    }, 0);
  })), { get firstHiddenTime() {
    return $e;
  } };
}, Rt = function(e) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return e();
  }, !0) : e();
}, bo = [1800, 3e3], Os = function(e, t) {
  t = t || {}, Rt(function() {
    var r, n = Jn(), i = W("FCP"), o = Qe("paint", function(a) {
      a.forEach(function(u) {
        u.name === "first-contentful-paint" && (o.disconnect(), u.startTime < n.firstHiddenTime && (i.value = Math.max(u.startTime - Er(), 0), i.entries.push(u), r(!0)));
      });
    });
    o && (r = K(e, i, bo, t.reportAllChanges), Be(function(a) {
      i = W("FCP"), r = K(e, i, bo, t.reportAllChanges), Kn(function() {
        i.value = performance.now() - a.timeStamp, r(!0);
      });
    }));
  });
}, wo = [0.1, 0.25], Zy = function(e, t) {
  (function(r, n) {
    n = n || {}, Os(Yn(function() {
      var i, o = W("CLS", 0), a = 0, u = [], c = function(l) {
        l.forEach(function(f) {
          if (!f.hadRecentInput) {
            var d = u[0], h = u[u.length - 1];
            a && f.startTime - h.startTime < 1e3 && f.startTime - d.startTime < 5e3 ? (a += f.value, u.push(f)) : (a = f.value, u = [f]);
          }
        }), a > o.value && (o.value = a, o.entries = u, i());
      }, s = Qe("layout-shift", c);
      s && (i = K(r, o, wo, n.reportAllChanges), Tr(function() {
        c(s.takeRecords()), i(!0);
      }), Be(function() {
        a = 0, o = W("CLS", 0), i = K(r, o, wo, n.reportAllChanges), Kn(function() {
          return i();
        });
      }), setTimeout(i, 0));
    }));
  })(function(r) {
    (function(n) {
      if (n.entries.length) {
        var i = n.entries.reduce(function(u, c) {
          return u && u.value > c.value ? u : c;
        });
        if (i && i.sources && i.sources.length) {
          var o = (a = i.sources).find(function(u) {
            return u.node && u.node.nodeType === 1;
          }) || a[0];
          if (o) return void (n.attribution = { largestShiftTarget: gr(o.node), largestShiftTime: i.startTime, largestShiftValue: i.value, largestShiftSource: o, largestShiftEntry: i, loadState: Tt(i.startTime) });
        }
      }
      var a;
      n.attribution = {};
    })(r), e(r);
  }, t);
}, Qy = function(e, t) {
  Os(function(r) {
    (function(n) {
      if (n.entries.length) {
        var i = Ze(), o = n.entries[n.entries.length - 1];
        if (i) {
          var a = i.activationStart || 0, u = Math.max(0, i.responseStart - a);
          return void (n.attribution = { timeToFirstByte: u, firstByteToFCP: n.value - u, loadState: Tt(n.entries[0].startTime), navigationEntry: i, fcpEntry: o });
        }
      }
      n.attribution = { timeToFirstByte: 0, firstByteToFCP: n.value, loadState: Tt(As()) };
    })(r), e(r);
  }, t);
}, ct = { passive: !0, capture: !0 }, em = /* @__PURE__ */ new Date(), Ao = function(e, t) {
  he || (he = t, ht = e, bs = /* @__PURE__ */ new Date(), Ls(removeEventListener), Rs());
}, Rs = function() {
  if (ht >= 0 && ht < bs - em) {
    var e = { entryType: "first-input", name: he.type, target: he.target, cancelable: he.cancelable, startTime: he.timeStamp, processingStart: he.timeStamp + ht };
    lr.forEach(function(t) {
      t(e);
    }), lr = [];
  }
}, tm = function(e) {
  if (e.cancelable) {
    var t = (e.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - e.timeStamp;
    e.type == "pointerdown" ? function(r, n) {
      var i = function() {
        Ao(r, n), a();
      }, o = function() {
        a();
      }, a = function() {
        removeEventListener("pointerup", i, ct), removeEventListener("pointercancel", o, ct);
      };
      addEventListener("pointerup", i, ct), addEventListener("pointercancel", o, ct);
    }(t, e) : Ao(t, e);
  }
}, Ls = function(e) {
  ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function(t) {
    return e(t, tm, ct);
  });
}, Oo = [100, 300], rm = function(e, t) {
  t = t || {}, Rt(function() {
    var r, n = Jn(), i = W("FID"), o = function(c) {
      c.startTime < n.firstHiddenTime && (i.value = c.processingStart - c.startTime, i.entries.push(c), r(!0));
    }, a = function(c) {
      c.forEach(o);
    }, u = Qe("first-input", a);
    r = K(e, i, Oo, t.reportAllChanges), u && Tr(Yn(function() {
      a(u.takeRecords()), u.disconnect();
    })), u && Be(function() {
      var c;
      i = W("FID"), r = K(e, i, Oo, t.reportAllChanges), lr = [], ht = -1, he = null, Ls(addEventListener), c = o, lr.push(c), Rs();
    });
  });
}, nm = function(e, t) {
  rm(function(r) {
    (function(n) {
      var i = n.entries[0];
      n.attribution = { eventTarget: gr(i.target), eventType: i.name, eventTime: i.startTime, eventEntry: i, loadState: Tt(i.startTime) };
    })(r), e(r);
  }, t);
}, Ps = 0, on = 1 / 0, Vt = 0, im = function(e) {
  e.forEach(function(t) {
    t.interactionId && (on = Math.min(on, t.interactionId), Vt = Math.max(Vt, t.interactionId), Ps = Vt ? (Vt - on) / 7 + 1 : 0);
  });
}, Ns = function() {
  return Cn ? Ps : performance.interactionCount || 0;
}, om = function() {
  "interactionCount" in performance || Cn || (Cn = Qe("event", im, { type: "event", buffered: !0, durationThreshold: 0 }));
}, Ro = [200, 500], Cs = 0, Lo = function() {
  return Ns() - Cs;
}, Q = [], an = {}, Po = function(e) {
  var t = Q[Q.length - 1], r = an[e.interactionId];
  if (r || Q.length < 10 || e.duration > t.latency) {
    if (r) r.entries.push(e), r.latency = Math.max(r.latency, e.duration);
    else {
      var n = { id: e.interactionId, latency: e.duration, entries: [e] };
      an[n.id] = n, Q.push(n);
    }
    Q.sort(function(i, o) {
      return o.latency - i.latency;
    }), Q.splice(10).forEach(function(i) {
      delete an[i.id];
    });
  }
}, am = function(e, t) {
  t = t || {}, Rt(function() {
    var r;
    om();
    var n, i = W("INP"), o = function(u) {
      u.forEach(function(l) {
        l.interactionId && Po(l), l.entryType === "first-input" && !Q.some(function(f) {
          return f.entries.some(function(d) {
            return l.duration === d.duration && l.startTime === d.startTime;
          });
        }) && Po(l);
      });
      var c, s = (c = Math.min(Q.length - 1, Math.floor(Lo() / 50)), Q[c]);
      s && s.latency !== i.value && (i.value = s.latency, i.entries = s.entries, n());
    }, a = Qe("event", o, { durationThreshold: (r = t.durationThreshold) !== null && r !== void 0 ? r : 40 });
    n = K(e, i, Ro, t.reportAllChanges), a && ("interactionId" in PerformanceEventTiming.prototype && a.observe({ type: "first-input", buffered: !0 }), Tr(function() {
      o(a.takeRecords()), i.value < 0 && Lo() > 0 && (i.value = 0, i.entries = []), n(!0);
    }), Be(function() {
      Q = [], Cs = Ns(), i = W("INP"), n = K(e, i, Ro, t.reportAllChanges);
    }));
  });
}, sm = function(e, t) {
  am(function(r) {
    (function(n) {
      if (n.entries.length) {
        var i = n.entries.sort(function(o, a) {
          return a.duration - o.duration || a.processingEnd - a.processingStart - (o.processingEnd - o.processingStart);
        })[0];
        n.attribution = { eventTarget: gr(i.target), eventType: i.name, eventTime: i.startTime, eventEntry: i, loadState: Tt(i.startTime) };
      } else n.attribution = {};
    })(r), e(r);
  }, t);
}, No = [2500, 4e3], sn = {}, um = function(e, t) {
  (function(r, n) {
    n = n || {}, Rt(function() {
      var i, o = Jn(), a = W("LCP"), u = function(l) {
        var f = l[l.length - 1];
        f && f.startTime < o.firstHiddenTime && (a.value = Math.max(f.startTime - Er(), 0), a.entries = [f], i());
      }, c = Qe("largest-contentful-paint", u);
      if (c) {
        i = K(r, a, No, n.reportAllChanges);
        var s = Yn(function() {
          sn[a.id] || (u(c.takeRecords()), c.disconnect(), sn[a.id] = !0, i(!0));
        });
        ["keydown", "click"].forEach(function(l) {
          addEventListener(l, function() {
            return setTimeout(s, 0);
          }, !0);
        }), Tr(s), Be(function(l) {
          a = W("LCP"), i = K(r, a, No, n.reportAllChanges), Kn(function() {
            a.value = performance.now() - l.timeStamp, sn[a.id] = !0, i(!0);
          });
        });
      }
    });
  })(function(r) {
    (function(n) {
      if (n.entries.length) {
        var i = Ze();
        if (i) {
          var o = i.activationStart || 0, a = n.entries[n.entries.length - 1], u = a.url && performance.getEntriesByType("resource").filter(function(h) {
            return h.name === a.url;
          })[0], c = Math.max(0, i.responseStart - o), s = Math.max(c, u ? (u.requestStart || u.startTime) - o : 0), l = Math.max(s, u ? u.responseEnd - o : 0), f = Math.max(l, a ? a.startTime - o : 0), d = { element: gr(a.element), timeToFirstByte: c, resourceLoadDelay: s - c, resourceLoadTime: l - s, elementRenderDelay: f - l, navigationEntry: i, lcpEntry: a };
          return a.url && (d.url = a.url), u && (d.lcpResourceEntry = u), void (n.attribution = d);
        }
      }
      n.attribution = { timeToFirstByte: 0, resourceLoadDelay: 0, resourceLoadTime: 0, elementRenderDelay: n.value };
    })(r), e(r);
  }, t);
}, Co = [800, 1800], cm = function e(t) {
  document.prerendering ? Rt(function() {
    return e(t);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return e(t);
  }, !0) : setTimeout(t, 0);
}, lm = function(e, t) {
  t = t || {};
  var r = W("TTFB"), n = K(e, r, Co, t.reportAllChanges);
  cm(function() {
    var i = Ze();
    if (i) {
      var o = i.responseStart;
      if (o <= 0 || o > performance.now()) return;
      r.value = Math.max(o - Er(), 0), r.entries = [i], n(!0), Be(function() {
        r = W("TTFB", 0), (n = K(e, r, Co, t.reportAllChanges))(!0);
      });
    }
  });
}, fm = function(e, t) {
  lm(function(r) {
    (function(n) {
      if (n.entries.length) {
        var i = n.entries[0], o = i.activationStart || 0, a = Math.max(i.domainLookupStart - o, 0), u = Math.max(i.connectStart - o, 0), c = Math.max(i.requestStart - o, 0);
        n.attribution = { waitingTime: a, dnsTime: u - a, connectionTime: c - u, requestTime: n.value - c, navigationEntry: i };
      } else n.attribution = { waitingTime: 0, dnsTime: 0, connectionTime: 0, requestTime: 0 };
    })(r), e(r);
  }, t);
};
const dm = (e) => (Zy(e), Qy(e), nm(e), um(e), fm(e), sm(e), () => {
}), Ve = typeof navigator != "undefined" && "connection" in navigator ? navigator.connection : {}, pm = (e, t) => {
  const r = () => {
    const o = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3;
    e({
      relativeTimestamp: o,
      downlink: Ve.downlink,
      downlinkMax: Ve.downlinkMax,
      effectiveType: Ve.effectiveType,
      rtt: Ve.rtt,
      saveData: Ve.saveData,
      type: Ve.type
    });
  };
  r();
  let n;
  return n = setInterval(() => {
    r();
  }, 1e3), () => {
    clearInterval(n);
  };
}, hm = () => {
  if (!("performance" in window && "memory" in performance))
    return {
      getDeviceDetails: void 0,
      getCurrentDeviceDetails: void 0
    };
  const e = window.performance;
  return {
    getDeviceDetails: () => ({
      deviceMemory: _m(
        navigator.deviceMemory || 0
      )
    }),
    getCurrentDeviceDetails: () => {
      const n = un(
        e.memory.jsHeapSizeLimit
      ), i = un(
        e.memory.totalJSHeapSize
      ), o = un(
        e.memory.usedJSHeapSize
      );
      return {
        jsHeapSizeLimit: n,
        totalJSHeapSize: i,
        usedJSHeapSize: o
      };
    }
  };
}, un = (e) => e / Math.pow(1e3, 2), _m = (e) => 1024 * e, vm = {
  TTFB: "ms",
  FCP: "ms",
  LCP: "ms",
  INP: "ms",
  FID: "ms",
  Jank: "ms",
  CLS: "1",
  usedJSHeapSize: "By",
  jsHeapSizeLimit: "By",
  totalJSHeapSize: "By",
  fps: "{frames}/s",
  [j.ViewportHeight]: "{px}",
  [j.ViewportWidth]: "{px}",
  [j.ScreenHeight]: "{px}",
  [j.ScreenWidth]: "{px}",
  [j.ViewportArea]: "{px2}",
  // Value is 1024 * navigator.deviceMemory (GiB → MiB), not decimal megabytes.
  [j.DeviceMemory]: "MiBy",
  downlink: "Mbit/s",
  downlinkMax: "Mbit/s",
  rtt: "ms",
  "long_task.duration": "ms"
};
function $t(e, t) {
  const r = t != null ? t : vm[e];
  return r ? { unit: r } : void 0;
}
function ym(e) {
  return "regexValue" in e;
}
function mm(e) {
  return "matchValue" in e;
}
function gm(e) {
  const t = Math.trunc(e);
  return t === 1 ? !0 : t === 0 ? !1 : Math.floor(Math.random() * t) === 0;
}
class Em {
  /**
   * @param config The sampling configuration.
   * @param sampler The sampler to use. This is intended to be used for testing purposes.
   */
  constructor(t = gm) {
    b(this, "regexCache", /* @__PURE__ */ new Map());
    b(this, "config");
    this.sampler = t;
  }
  setConfig(t) {
    this.config = t;
  }
  isSamplingEnabled() {
    var t, r, n, i;
    return !!((r = (t = this.config) == null ? void 0 : t.logs) != null && r.length || (i = (n = this.config) == null ? void 0 : n.spans) != null && i.length);
  }
  shouldSample(t) {
    var r, n;
    return t.name === vs ? this.sampleLog((r = this.config) == null ? void 0 : r.logs, t) : this.sampleSpan((n = this.config) == null ? void 0 : n.spans, t);
  }
  /**
   * Check if a value matches a match config.
   */
  matchesValue(t, r) {
    if (!t)
      return !1;
    if (mm(t))
      return t.matchValue === r;
    if (ym(t)) {
      const n = t.regexValue;
      if (n === null)
        return !1;
      this.regexCache.has(n) || this.regexCache.set(n, new RegExp(n));
      const i = this.regexCache.get(n);
      if (typeof r == "string")
        return i.test(r);
    }
    return !1;
  }
  /**
   * Check if the attributes match the attribute configs.
   */
  matchesAttributes(t, r) {
    if (t)
      for (const n of t) {
        let i = !1;
        for (const o of Object.keys(r))
          if (this.matchesValue(n.key, o)) {
            const a = r[o];
            if (this.matchesValue(
              n.attribute,
              a
            )) {
              i = !0;
              break;
            }
          }
        if (!i)
          return !1;
      }
    return !0;
  }
  matchEvent(t, r) {
    return !(t.name && !this.matchesValue(t.name, r.name) || t.attributes && (!r.attributes || !this.matchesAttributes(
      t.attributes,
      r.attributes
    )));
  }
  matchesEvents(t, r) {
    if (t)
      for (const n of t) {
        let i = !1;
        for (const o of r)
          if (this.matchEvent(n, o)) {
            i = !0;
            break;
          }
        if (!i)
          return !1;
      }
    return !0;
  }
  /**
   * Attempts to match the span to the config. The span will match only if all defined conditions are met.
   *
   * @param config The config to match against.
   * @param name The name of the span to match.
   * @param attributes The attributes of the span to match.
   * @returns True if the span matches the config, false otherwise.
   */
  matchesSpanConfig(t, r) {
    return !(t.name && !this.matchesValue(t.name, r.name) || !this.matchesAttributes(t.attributes, r.attributes) || !this.matchesEvents(t.events, r.events));
  }
  matchesLogConfig(t, r) {
    if (t.severityText) {
      const n = r[ys];
      if (!this.matchesValue(t.severityText, n))
        return !1;
    }
    if (t.message) {
      const n = r[ms];
      if (!this.matchesValue(t.message, n))
        return !1;
    }
    return !!this.matchesAttributes(t.attributes, r);
  }
  /**
   * Sample a span based on the sampling configuration.
   *
   * @param configs The sampling configuration.
   * @param name The name of the span to sample.
   * @param attributes The attributes of the span to sample.
   * @returns The sampling result.
   */
  sampleSpan(t, r) {
    if (t) {
      for (const n of t)
        if (this.matchesSpanConfig(n, r))
          return {
            sample: this.sampler(n.samplingRatio),
            attributes: {
              [ho]: n.samplingRatio
            }
          };
    }
    return {
      sample: !0
    };
  }
  /**
   * Sample a log based on the sampling configuration.
   *
   * @param configs The sampling configuration.
   * @param attributes The attributes of the log to sample.
   * @returns The sampling result.
   */
  sampleLog(t, r) {
    if (t) {
      for (const n of t)
        if (this.matchesLogConfig(n, r.attributes))
          return {
            sample: this.sampler(n.samplingRatio),
            attributes: {
              [ho]: n.samplingRatio
            }
          };
    }
    return {
      sample: !0
    };
  }
}
const Tm = () => {
  if (typeof window == "undefined" || typeof PerformanceObserver == "undefined") return !1;
  const e = PerformanceObserver.supportedEntryTypes;
  return Array.isArray(e) && e.includes("longtask");
}, Sm = (e) => {
  if (!Tm()) return () => {
  };
  let t;
  try {
    t = new PerformanceObserver((r) => {
      var n;
      for (const i of r.getEntries()) {
        const o = (n = i.attribution) == null ? void 0 : n[0];
        e({
          duration: i.duration,
          name: i.name,
          startTime: i.startTime,
          containerType: o == null ? void 0 : o.containerType,
          containerSrc: o == null ? void 0 : o.containerSrc,
          containerId: o == null ? void 0 : o.containerId,
          containerName: o == null ? void 0 : o.containerName
        });
      }
    }), t.observe({ type: "longtask", buffered: !0 });
  } catch (r) {
    return () => {
    };
  }
  return () => {
    try {
      t.disconnect();
    } catch (r) {
    }
  };
}, bm = /* @__PURE__ */ new Set(["string", "number", "boolean"]), wm = () => typeof window != "undefined" && typeof window.ReportingObserver != "undefined", Am = (e) => {
  const t = {};
  if (!e || typeof e != "object") return t;
  for (const [r, n] of Object.entries(
    e
  ))
    if (n != null)
      if (bm.has(typeof n))
        t[`report.body.${r}`] = n;
      else
        try {
          t[`report.body.${r}`] = JSON.stringify(n);
        } catch (i) {
        }
  return t;
}, Om = (e) => {
  var n;
  const t = (n = e.body) != null ? n : {}, r = t.message || t.reason || t.id || e.type;
  return typeof r == "string" ? r : e.type;
}, Rm = (e, t) => {
  if (!wm()) return () => {
  };
  const r = [
    "deprecation",
    "intervention",
    "csp-violation"
  ], n = window.ReportingObserver;
  let i;
  try {
    i = new n(
      (o) => {
        var a, u;
        for (const c of o) {
          const s = (a = c.type) != null ? a : "unknown", l = (u = c.body) != null ? u : {}, f = E({
            "report.type": s,
            "report.url": c.url
          }, Am(l)), d = Om({ type: s, body: l });
          e(s === "deprecation" ? {
            kind: "log",
            level: "warn",
            type: s,
            message: d,
            url: c.url,
            attributes: f
          } : {
            kind: "error",
            type: s,
            message: d,
            url: c.url,
            attributes: f
          });
        }
      },
      { buffered: !0, types: r }
    ), i.observe();
  } catch (o) {
    return () => {
    };
  }
  return () => {
    try {
      i.disconnect();
    } catch (o) {
    }
  };
}, Lm = "exception", Pm = function(e, t, r) {
  if (!e)
    return;
  const n = E({}, r);
  typeof t == "string" ? n[Or] = t : t && (t.code ? n[Ar] = t.code.toString() : t.name && (n[Ar] = t.name), t.message && (n[Or] = t.message), t.stack && (n[Zs] = t.stack)), n[Ar] || n[Or] ? e.addEvent(Lm, n) : wu(
    "otel",
    "recordException",
    "warn",
    `Failed to record an exception ${t}`
  );
};
var St;
class Nm {
  constructor(t) {
    /** Verbose project ID that is exposed to users. Legacy users may still be using ints. */
    b(this, "organizationID");
    b(this, "_options");
    b(this, "_integrations", []);
    b(this, "_gauges", /* @__PURE__ */ new Map());
    b(this, "_counters", /* @__PURE__ */ new Map());
    b(this, "_histograms", /* @__PURE__ */ new Map());
    b(this, "_up_down_counters", /* @__PURE__ */ new Map());
    b(this, "sampler", new Em());
    b(this, "_started", !1);
    b(this, "_ldContextKeys");
    // ECMAScript-private (#) so the internal GraphQL SDK type — which
    // references graphql-request / graphql — does not leak into the published
    // declaration file and break consumer type-checking.
    fi(this, St);
    this._options = t, this.organizationID = t.projectId;
  }
  _productAnalyticsEvents() {
    var n;
    const t = (n = this._options) == null ? void 0 : n.productAnalytics;
    if (t === !1)
      return {};
    const r = {
      clicks: !0,
      pageViews: !0,
      trackEvents: !0
    };
    if (t === void 0 || t === !0)
      return r;
    for (const i of Object.keys(t))
      t[i] === !1 && (r[i] = !1);
    return r;
  }
  setLDContextKeyAttributes(t) {
    t && (this._ldContextKeys = Object.fromEntries(
      Object.entries(t).map(([r, n]) => [
        `${Qs}.${r}`,
        n
      ])
    ));
  }
  getLDContextKeyAttributes() {
    return this._ldContextKeys;
  }
  start() {
    return U(this, null, function* () {
      var r, n, i, o, a, u, c, s, l, f, d, h, _, p, v;
      if (this._started)
        return;
      this._started = !0, Ny(
        {
          backendUrl: (n = (r = this._options) == null ? void 0 : r.backendUrl) != null ? n : "https://pub.observability.app.launchdarkly.com",
          otlpEndpoint: (a = (o = (i = this._options) == null ? void 0 : i.otel) == null ? void 0 : o.otlpEndpoint) != null ? a : "https://otel.observability.app.launchdarkly.com",
          projectId: this._options.projectId,
          sessionSecureId: this._options.sessionSecureId,
          environment: (c = (u = this._options) == null ? void 0 : u.environment) != null ? c : "production",
          networkRecordingOptions: typeof ((s = this._options) == null ? void 0 : s.networkRecording) == "object" ? this._options.networkRecording : void 0,
          tracingOrigins: (l = this._options) == null ? void 0 : l.tracingOrigins,
          serviceName: (d = (f = this._options) == null ? void 0 : f.serviceName) != null ? d : "browser",
          serviceVersion: (h = this._options) == null ? void 0 : h.version,
          instrumentations: (p = (_ = this._options) == null ? void 0 : _.otel) == null ? void 0 : p.instrumentations,
          productAnalyticsEvents: this._productAnalyticsEvents(),
          getLDContextKeyAttributes: () => this.getLDContextKeyAttributes(),
          getIntegrations: () => this._integrations
        },
        this.sampler
      ), this._gauges.clear(), this._counters.clear(), this._histograms.clear(), this._up_down_counters.clear();
      const t = new ru(
        (v = this._options.backendUrl) != null ? v : "https://pub.observability.app.launchdarkly.com",
        {
          headers: {}
        }
      );
      di(this, St, eu(t, tu())), yield this.configureSampling(), this.setupListeners();
    });
  }
  stop() {
    return U(this, null, function* () {
      this._started && (this._started = !1, yield Dy());
    });
  }
  configureSampling() {
    return U(this, null, function* () {
      try {
        const t = yield li(this, St).GetSamplingConfig({
          organization_verbose_id: `${this.organizationID}`
        });
        this.sampler.setConfig(t.sampling);
      } catch (t) {
        ko(
          "sampling",
          "warn",
          `LaunchDarkly Observability: Failed to configure sampling: ${t}`
        );
      }
    });
  }
  _recordLog(t, r, n, i) {
    this.startSpan(vs, (o) => {
      var c, s, l, f, d;
      const a = typeof t == "string" ? t : We(t), u = i ? i.map((h) => h.toString()).join(`
`) : void 0;
      if (o == null || o.addEvent("log", E(E({
        [ys]: r,
        [ms]: a,
        "code.stacktrace": u
      }, (c = this._ldContextKeys) != null ? c : {}), n)), this._options.reportConsoleErrors && r === "error") {
        const h = new Error(a);
        o == null || o.recordException(h), o == null || o.setStatus({
          code: Qt.ERROR,
          message: a
        }), i ? this._recordErrorMessage({
          error: h,
          event: h.message,
          type: "custom",
          url: window.location.href,
          source: "frontend",
          lineNumber: (l = (s = i[0]) == null ? void 0 : s.lineNumber) != null ? l : 0,
          columnNumber: (d = (f = i[0]) == null ? void 0 : f.columnNumber) != null ? d : 0,
          stackTrace: i,
          timestamp: (/* @__PURE__ */ new Date()).toISOString(),
          id: ln()
        }) : this.recordError(h);
      }
    });
  }
  _recordErrorMessage(t, r) {
    try {
      t.payload && (r = E(E({}, JSON.parse(t.payload)), r || {}));
    } catch (a) {
    }
    this.startSpan("highlight.exception", (a) => {
      var u;
      Pm(a, (u = t.error) != null ? u : new Error(t.event), {
        [Py]: t.id
      }), a == null || a.setAttributes(E({
        event: t.event,
        type: t.type,
        url: t.url,
        source: t.source,
        lineNumber: t.lineNumber,
        columnNumber: t.columnNumber
      }, r));
    });
    const o = t, { payload: n } = o, i = br(o, ["payload"]);
    for (const a of this._integrations)
      a.error(de(), I(E({}, i), {
        payload: JSON.stringify(r)
      }));
  }
  recordError(t, r, n, i, o) {
    var s, l, f, d;
    t = t || new Error("Unknown error"), t instanceof Error && t.cause && (n = I(E({}, n), {
      "exception.cause": JSON.stringify(t.cause)
    }));
    let a = r ? r + ":" + t.message : t.message;
    o === "React.ErrorBoundary" && (a = "ErrorBoundary: " + a);
    const u = dr(t), c = {
      error: t,
      event: a,
      type: o != null ? o : "custom",
      url: window.location.href,
      source: i != null ? i : "frontend",
      lineNumber: (s = u[0]) != null && s.lineNumber ? (l = u[0]) == null ? void 0 : l.lineNumber : 0,
      columnNumber: (f = u[0]) != null && f.columnNumber ? (d = u[0]) == null ? void 0 : d.columnNumber : 0,
      stackTrace: u,
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      id: ln()
    };
    this._recordErrorMessage(c, n);
  }
  recordCount(t) {
    var n, i;
    let r = this._counters.get(t.name);
    if (!r) {
      if (r = (n = jt()) == null ? void 0 : n.createCounter(
        t.name,
        $t(t.name, t.unit)
      ), !r) return;
      this._counters.set(t.name, r);
    }
    r.add(t.value, I(E(E({}, (i = this._ldContextKeys) != null ? i : {}), t.attributes), {
      "highlight.session_id": de()
    }));
  }
  recordGauge(t) {
    var o, a, u;
    let r = this._gauges.get(t.name);
    if (!r) {
      if (r = (o = jt()) == null ? void 0 : o.createGauge(
        t.name,
        $t(t.name, t.unit)
      ), !r) return;
      this._gauges.set(t.name, r);
    }
    const n = E(E({}, (a = this._ldContextKeys) != null ? a : {}), t.attributes);
    r.record(t.value, I(E({}, n), {
      "highlight.session_id": de()
    }));
    const i = {
      name: t.name,
      value: t.value,
      unit: t.unit,
      category: n.category,
      group: (u = n.group) == null ? void 0 : u.toString(),
      tags: Object.entries(n).map(([c, s]) => {
        var l;
        return {
          name: c != null ? c : "",
          value: (l = s == null ? void 0 : s.toString()) != null ? l : ""
        };
      })
    };
    for (const c of this._integrations)
      c.recordGauge(
        de(),
        i
      );
  }
  recordIncr(t) {
    this.recordCount(I(E({}, t), { value: 1 }));
  }
  recordHistogram(t) {
    var n, i;
    let r = this._histograms.get(t.name);
    if (!r) {
      if (r = (n = jt()) == null ? void 0 : n.createHistogram(
        t.name,
        $t(t.name, t.unit)
      ), !r) return;
      this._histograms.set(t.name, r);
    }
    r.record(t.value, I(E(E({}, (i = this._ldContextKeys) != null ? i : {}), t.attributes), {
      "highlight.session_id": de()
    }));
  }
  recordUpDownCounter(t) {
    var n, i;
    let r = this._up_down_counters.get(t.name);
    if (!r) {
      if (r = (n = jt()) == null ? void 0 : n.createUpDownCounter(
        t.name,
        $t(t.name, t.unit)
      ), !r) return;
      this._up_down_counters.set(t.name, r);
    }
    r.add(t.value, I(E(E({}, (i = this._ldContextKeys) != null ? i : {}), t.attributes), {
      "highlight.session_id": de()
    }));
  }
  startSpan(t, r, n, i) {
    const o = _o();
    if (!o) {
      const u = _i();
      return i === void 0 && n === void 0 ? r(u) : i === void 0 ? n(u) : i(u);
    }
    const a = (u, c) => {
      this._ldContextKeys && u.setAttributes(this._ldContextKeys);
      const s = c(u);
      return s instanceof Promise ? s.finally(() => u.end()) : (u.end(), s);
    };
    return i === void 0 && n === void 0 ? o.startActiveSpan(
      t,
      (u) => a(u, r)
    ) : i === void 0 ? o.startActiveSpan(
      t,
      r,
      (u) => a(u, n)
    ) : o.startActiveSpan(
      t,
      r,
      n,
      (u) => a(u, i)
    );
  }
  startManualSpan(t, r, n, i) {
    const o = _o();
    if (!o) {
      const a = _i();
      return i === void 0 && n === void 0 ? r(a) : i === void 0 ? n(a) : i(a);
    }
    return i === void 0 && n === void 0 ? o.startActiveSpan(t, r) : i === void 0 ? o.startActiveSpan(
      t,
      r,
      n
    ) : o.startActiveSpan(
      t,
      r,
      n,
      i
    );
  }
  register(t, r) {
    this._integrations.push(new nu(t, r));
  }
  getHooks(t) {
    return this._integrations.flatMap((r) => {
      var n, i;
      return (i = (n = r.getHooks) == null ? void 0 : n.call(r, t)) != null ? i : [];
    });
  }
  submitViewportMetrics({
    height: t,
    width: r,
    availHeight: n,
    availWidth: i
  }) {
    this.recordGauge({
      name: j.ViewportHeight,
      value: t,
      attributes: {
        category: $.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: j.ViewportWidth,
      value: r,
      attributes: {
        category: $.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: j.ScreenHeight,
      value: n,
      attributes: {
        category: $.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: j.ScreenWidth,
      value: i,
      attributes: {
        category: $.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: j.ViewportArea,
      value: t * r,
      attributes: {
        category: $.Device,
        group: window.location.href
      }
    });
  }
  setupListeners() {
    var r;
    this._options.disableConsoleRecording || Ru(
      (n) => {
        var i;
        this._recordLog(
          (i = n.value) == null ? void 0 : i.join(" "),
          n.type,
          n.attributes ? JSON.parse(n.attributes) : {},
          n.trace
        );
      },
      {
        level: (r = this._options.consoleMethodsToRecord) != null ? r : [
          ...Bo
        ],
        logger: "console",
        stringifyOptions: {
          depthOfLimit: 10,
          numOfKeysLimit: 100,
          stringLengthLimit: 1e3
        }
      }
    ), this._options.enablePerformanceRecording !== !1 && (Ky((n) => {
      Object.entries(n).filter(([i]) => i !== "relativeTimestamp").forEach(
        ([i, o]) => o && this.recordGauge({
          name: i,
          value: o,
          attributes: {
            category: $.Performance,
            group: window.location.href
          }
        })
      );
    }, 0), qy((n) => {
      this.recordGauge({
        name: "Jank",
        value: n.jankAmount,
        attributes: {
          category: $.WebVital,
          group: n.querySelector
        }
      });
    }, 0)), Uu(
      (n) => {
        var a;
        if (Bu.includes(n.event) || Hu.some(
          (u) => n.event.includes(u)
        ))
          return;
        const i = new Error(n.event);
        i.stack = We(n.stackTrace.map((u) => u.toString()));
        let o = {};
        try {
          n.payload && (o = JSON.parse(n.payload));
        } catch (u) {
        }
        this._recordErrorMessage(
          I(E({}, n), { error: (a = n.error) != null ? a : i }),
          o
        );
      },
      { enablePromisePatch: !!this._options.enablePromisePatch }
    ), dm((n) => {
      const { name: i, value: o } = n, { hostname: a, pathname: u, href: c } = window.location, s = {
        group: window.location.pathname,
        category: $.WebVital,
        [_e]: gn(c),
        [zt]: u,
        [au]: a
      };
      switch (n.name) {
        case "LCP": {
          const l = n.attribution;
          l.element && (s["web_vital.element"] = l.element), l.url && (s["web_vital.attribution.url"] = gn(
            l.url
          ));
          break;
        }
        case "CLS": {
          const l = n.attribution;
          l.largestShiftTarget && (s["web_vital.element"] = l.largestShiftTarget), l.loadState && (s["web_vital.load_state"] = l.loadState);
          break;
        }
        case "INP": {
          const l = n.attribution;
          l.eventTarget && (s["web_vital.element"] = l.eventTarget), l.eventType && (s["web_vital.event_type"] = l.eventType), l.loadState && (s["web_vital.load_state"] = l.loadState);
          break;
        }
        case "FID": {
          const l = n.attribution;
          l.eventTarget && (s["web_vital.element"] = l.eventTarget), l.eventType && (s["web_vital.event_type"] = l.eventType);
          break;
        }
        case "FCP": {
          const l = n.attribution;
          l.loadState && (s["web_vital.load_state"] = l.loadState);
          break;
        }
      }
      this.recordGauge({
        name: i,
        value: o,
        attributes: s
      });
    }), iu((n) => {
      this.submitViewportMetrics(n);
    }), pm((n) => {
      const i = {
        category: $.Performance,
        group: window.location.href
      };
      n.saveData !== void 0 && (i.saveData = n.saveData.toString()), n.effectiveType !== void 0 && (i.effectiveType = n.effectiveType.toString()), n.type !== void 0 && (i.type = n.type.toString()), Object.entries(n).filter(([o]) => o !== "relativeTimestamp").forEach(([o, a]) => {
        ou(a) && this.recordGauge({
          name: o,
          value: a,
          attributes: i
        });
      });
    }, (/* @__PURE__ */ new Date()).getTime());
    const { getDeviceDetails: t } = hm();
    t && this.recordGauge({
      name: j.DeviceMemory,
      value: t().deviceMemory,
      attributes: {
        category: $.Device,
        group: window.location.href
      }
    }), this._options.enableLongtaskRecording !== !1 && Sm((n) => {
      const i = {
        category: $.Performance,
        name: n.name,
        [zt]: window.location.pathname
      };
      n.containerType && (i.container_type = n.containerType), n.containerSrc && (i.container_src = n.containerSrc), n.containerId && (i.container_id = n.containerId), n.containerName && (i.container_name = n.containerName), this.recordHistogram({
        name: "long_task.duration",
        value: n.duration,
        attributes: i
      });
    }), this._options.enableReportingObserver !== !1 && Rm((n) => {
      var o;
      const i = I(E({}, n.attributes), {
        [zt]: window.location.pathname
      });
      if (n.kind === "log")
        this._recordLog(
          n.message,
          (o = n.level) != null ? o : "warn",
          i
        );
      else {
        const a = new Error(n.message);
        this.recordError(
          a,
          void 0,
          Object.fromEntries(
            Object.entries(i).map(([u, c]) => [
              u,
              c === void 0 ? "" : String(c)
            ])
          ),
          "reporting-observer",
          "custom"
        );
      }
    });
  }
  recordLog(t, r, n) {
    return this._recordLog(t, r, n);
  }
}
St = new WeakMap();
class Fm extends su {
  constructor(r) {
    super(r);
    b(this, "observe");
    b(this, "options");
    b(this, "exposureDeduper");
    this.options = r, this.exposureDeduper = new Gp(
      r == null ? void 0 : r.flagExposureDedupeWindowMillis,
      r == null ? void 0 : r.flagExposureDedupeMaxSize
    );
  }
  initialize(r, n) {
    try {
      if (typeof window == "undefined" || typeof document == "undefined") {
        console.warn(
          "@launchdarkly/observability is not initializing because it is not supported in this environment."
        );
        return;
      }
      if (!r) {
        console.warn(
          "@launchdarkly/observability is not initializing because the SDK credential is undefined."
        );
        return;
      }
      this.configureSession(r, n), this.observe = new Nm(I(E({}, n), {
        projectId: r,
        sessionSecureId: this.sessionSecureID
      })), n != null && n.manualStart || this.observe.start(), bu.load(this.observe);
    } catch (i) {
      ko(
        "Error initializing @launchdarkly/observability SDK",
        "error",
        i
      );
    }
  }
  getMetadata() {
    return {
      name: "@launchdarkly/observability"
    };
  }
  register(r, n) {
    var i;
    (i = this.observe) == null || i.register(r, n);
  }
  getHooks(r) {
    var i, o, a, u;
    const n = E(E({
      [yu]: r.sdk.name,
      [vu]: r.sdk.version,
      [_u]: r.clientSideId,
      [hu]: "LaunchDarkly"
    }, (i = r.application) != null && i.id ? { [pu]: r.application.id } : {}), (o = r.application) != null && o.version ? {
      [du]: r.application.version
    } : {});
    return this.initialize(
      (u = (a = r.sdkKey) != null ? a : r.mobileKey) != null ? u : r.clientSideId,
      this.options
    ), [
      {
        getMetadata: () => ({
          name: "@launchdarkly/observability/hooks"
        }),
        afterIdentify: (c, s, l) => {
          var d, h, _, p, v, y, g, w, A;
          for (const R of (_ = (h = (d = this.observe) == null ? void 0 : d.getHooks) == null ? void 0 : h.call(d, r)) != null ? _ : [])
            (p = R.afterIdentify) == null || p.call(R, c, s, l);
          const f = pi(c.context);
          if ((v = this.observe) == null || v.setLDContextKeyAttributes(f), l.status === "completed") {
            this.exposureDeduper.reset();
            const R = I(E({}, f), {
              key: (w = (g = (y = this.options) == null ? void 0 : y.contextFriendlyName) == null ? void 0 : g.call(
                y,
                c.context
              )) != null ? w : Rr(c.context),
              timeout: c.timeout,
              canonicalKey: Rr(c.context),
              [Su]: l.status
            });
            (A = this.observe) == null || A.recordLog("LD.identify", "info", E(E({}, n), R));
          }
          return s;
        },
        afterEvaluation: (c, s, l) => {
          var p, v, y, g, w, A, R, P, G;
          for (const C of (y = (v = (p = this.observe) == null ? void 0 : p.getHooks) == null ? void 0 : v.call(p, r)) != null ? y : [])
            (g = C.afterEvaluation) == null || g.call(C, c, s, l);
          const f = E({
            [gu]: c.flagKey,
            [cu]: JSON.stringify(l.value)
          }, l.variationIndex ? {
            [mu]: l.variationIndex
          } : {});
          if (l.reason)
            for (const C in hi) {
              const F = C, ne = l.reason[F];
              ne && (f[hi[F]] = ne);
            }
          const d = c.context ? Rr(c.context) : void 0;
          c.context && (f[Eu] = JSON.stringify(pi(c.context)), f[Tu] = d);
          const h = [
            c.flagKey,
            JSON.stringify(l.value),
            (w = l.variationIndex) != null ? w : "",
            (R = (A = l.reason) == null ? void 0 : A.kind) != null ? R : "",
            (G = (P = l.reason) == null ? void 0 : P.ruleId) != null ? G : "",
            d != null ? d : ""
          ].join("|");
          if (!this.observe || !this.exposureDeduper.shouldRecord(h))
            return s;
          const _ = E(E({}, n), f);
          return this.observe.startSpan(lu, (C) => {
            C != null && C.isRecording() && (C.addEvent(fu, _), this.exposureDeduper.markRecorded(h));
          }), s;
        },
        afterTrack: (c) => {
          var f, d, h, _, p, v, y, g, w;
          for (const A of (h = (d = (f = this.observe) == null ? void 0 : f.getHooks) == null ? void 0 : d.call(f, r)) != null ? h : [])
            (_ = A.afterTrack) == null || _.call(A, c);
          if (!(((p = this.options) == null ? void 0 : p.productAnalytics) !== !1 && (typeof ((v = this.options) == null ? void 0 : v.productAnalytics) != "object" || this.options.productAnalytics.trackEvents !== !1)))
            return;
          const l = E(I(E(E({
            [_e]: window.location.href
          }, (g = (y = this.observe) == null ? void 0 : y.getLDContextKeyAttributes()) != null ? g : {}), n), {
            key: c.key,
            value: c.metricValue
          }), typeof c.data == "object" ? c.data : {});
          (w = this.observe) == null || w.startSpan(uu, (A) => {
            A && A.setAttributes(l);
          });
        }
      }
    ];
  }
}
export {
  Bo as A,
  Ru as C,
  jp as D,
  Uu as E,
  Gm as F,
  qy as J,
  $ as M,
  pm as N,
  Fm as O,
  Ky as P,
  dm as W,
  Hm as X,
  Vn as a,
  Bu as b,
  Hu as c,
  Um as d,
  Lu as e,
  Ny as f,
  Em as g,
  j as h,
  jt as i,
  $t as j,
  hm as k,
  gn as l,
  Bm as m,
  Ca as n,
  _o as o,
  dr as p,
  ln as r,
  Dy as s
};
//# sourceMappingURL=observe-Cjo5opVs.js.map
